/* eslint-disable react/sort-comp */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Segment,
  Modal,
  Message,
  Popup,
} from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment-timezone';
import qs from 'qs';
import { connect } from 'react-redux';
import { push, replace, goBack } from 'react-router-redux';
import { required, stringLength, email, identity as validateIdentity, phoneNumber, matchRegex } from '@mhub/web-validations';
import { clearBookQuery } from '../../actions/bookQuery';
import { fetchAddressSettings } from '../../actions/addressSettings';
import { fetchAppConfig } from '../../actions/appConfig';
import { fetchCustomOptions } from '../../actions/customOptions';
import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import InputBirthdate from '../../components/InputBirthdate';
import Countdown from '../../components/CountdownAdvance';
import CurrencySymbol from '../../components/CurrencySymbol';
import SearchStaff from '../../components/SearchStaff';
import LoanAmount from '../../components/LoanAmount';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import STATES from '../../constants/states';
import { RACE } from '../../constants/race';
import { MARITAL_STATUS } from '../../constants/maritalStatus';
import { RELATIONSHIP_TYPE } from '../../constants/relationshipType';
import { GENDER } from '../../constants/gender';
import { BUMI } from '../../constants/bumi';
import { SELECT_COUNTRIES, SELECT_NATIONALITY, isCountryVietnam } from '../../constants/countries';
import CUSTOMER_TITLES from '../../constants/customerTitles';
import FIRST_TIME_BUYER from '../../constants/firstTimeBuyer';
import { DEFAULT_BOOKING_FIELD_LIST, EXTRA_PURCHASER_CUSTOM_FIELDS, PURCHASER_CUSTOM_FIELDS } from '../../constants/defaultBookingFields';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { REGEX_NPWP_ID, REGEX_POSTCODE_MY, REGEX_TIN_VALID } from '../../constants/regex';
import { decodeSearch, encodeSearch } from '../../utils/url';
import { isNumeric } from '../../utils/numbers/isNumber';
import { bookingFlow } from '../../utils/routes';
import dateFromIC from '../../utils/dateFromIC';
import { amountToFixed, fullToAmount, spaFullNumber } from '../../utils/amount';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage, flashMessage } from '../../actions/flash';
import config from '../../../config';
import BookingSwapUnit from '../../containers/modals/BookingSwapUnit';
import { UNIT_HELD_M_TYPE, heldUnitPagePath, parseUnitHeldRefusal, preReservedURL, shouldReleaseHoldOnLeave } from '../../utils/unitHold';
import Input from '../../components/AppForm/Input';
import TinFieldInput from '../../components/AppForm/TinFieldInput';
import BookingSteppers from '../../components/BookingSteppers';
import SearchHimsDistricts from '../../components/SearchHimsDistricts';
import SearchHimsPostcodes from '../../components/SearchHimsPostcodes';
import { bookQueryToBooking } from '../../utils/bookQuery';
import { getItem } from '../../utils/storage';
import { getPhoneValidRegex } from '../../utils/validations/phone';
import { isForeignCompany } from '../../utils/companies';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';
import { fetchPhoneValidationPresets } from '../../actions/phoneValidationPresets';
import { fetchIdentityPresets } from '../../actions/identityPresets';
import { getIdentityTypeOpts } from '../../utils/identityTypes';
import { translateModels } from '../../utils/translation';
import { getFinanceSourceLabel } from '../../utils/financeSource';
import { agentAssignedLocked, blocksVietnamLocalUnit, CITIZENSHIP_FOREIGNER, CITIZENSHIP_LOCAL, crmAgentLookupQuery, crmContactCitizenship, crmContactMobile, crmMonthlyIncome, createdByLabel, hasVietnamElevatedAccess, isCompleteSaleAgent, isVietnamCompany, paymentMethodOpts, unitQuotaChipLabel, vnFullNameValidations, vnIdentityValidation, vnPreferredNameValidations, VN_FOREIGN_THRESHOLD_MESSAGE, VN_LOCAL_UNIT_FOREIGNER_MESSAGE } from '../../utils/vietnam';
import { reservationBlocked } from '../../utils/preSalesLaunch';
import {
  depositToCollect,
  isPricingPackageMissing,
  livePackageTotal,
  liveTotalFor,
  vnPricePanelFigure,
  VN_STORED_TOTAL_NOTICE,
} from '../../utils/vietnamPricing';
import { crmIdentityMediaReference } from '../../utils/crmIdentityMedia';
import { formatMajorAmount } from '../../utils/numbers/currencyMinor';
import { AUTOFILL_IDENTITY_TYPES, AUTOFILL_MSISDN, AUTOFILL_NRIC, AUTOFILL_PASSPORT, AUTOFILL_PRESET, AUTOFILL_PRS, CRM_SEARCH_FIELD_MAPPINGS } from '../../constants/autofillTypes';
import { hasAnyRequiredRoleIDs, matchGroupIDToSrRoleID } from '../../constants/srRoleAccess';
import { FOREIGN_BUYER_GENERIC_TIN, GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getAutoFillTin, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isForeignIdType, isGenericTinFound } from '../../constants/tin';
import { IDENTITY_TYPE_BRN, IDENTITY_TYPE_NRIC, IDENTITY_TYPE_PASSPORT } from '../../constants/defaultIdentityTypeOpts';
import GiftBlueSvg from '../../assets/icons/gift_blue.svg';
import { checkRegex } from '../../components/RegexDropdownPicker';

const isPRS = config.get('prs');
const isPackagePricingRequired = config.get('isPackagePricingRequired');

// CPI-977 S4/S6: the VN price panel is dong-only, matching the CRM payment tab's formatter.
const VN_CURRENCY_CODE = 'VND';

const renderPackagePricingDescription = (description) => {
  if (!description) {
    return '';
  }
  if (!description.includes('\n')) {
    return description;
  }
  return description.split('\n').map((line, idx) => <span key={idx}>{line}<br /></span>);
};

// CPI-974 (D23): CRM identity_type -> Showroom identityTypeID. The CRM's 3 (Enterprise
// Registration Number) is Showroom's 4; an unmapped type leaves the field blank.
const CRM_IDENTITY_TYPE_MAP = {
  1: IDENTITY_TYPE_NRIC,      // CCCD
  2: IDENTITY_TYPE_PASSPORT,  // Passport
  3: IDENTITY_TYPE_BRN,       // Enterprise Registration Number / Certificate
};

const CRM_IDENTITY_VALUE_FIELD = {
  [IDENTITY_TYPE_NRIC]: 'cccd',
  [IDENTITY_TYPE_PASSPORT]: 'passport',
  [IDENTITY_TYPE_BRN]: 'other_identity',
};

const CRM_OPPORTUNITY_APPROVED = 'approved';

class BookingForm extends Component {
  static propTypes = {
    // onSubmit: PropTypes.func.isRequired,
    token: PropTypes.string,
    auth: PropTypes.shape({
      id: PropTypes.number,
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
    }),
    bookQuery: PropTypes.shape({
      data: PropTypes.array,
    }),
    onChange: PropTypes.func,
    registerLeaveGuard: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
      hash: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        leadV2IsEnabled: PropTypes.bool,
        externalServiceIsEnabled: PropTypes.bool,
        externalServiceAutofillIsEnabled: PropTypes.bool,
        apieServiceIsEnabled: PropTypes.bool,
        himsIsEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          bookingHideFirstTimeBuyer: PropTypes.bool,
          uppercasePurchaserInfoIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    financeSources: PropTypes.shape({
      data: PropTypes.array,
    }),
    identityPresets: PropTypes.shape({
      data: PropTypes.array,
    }),
    phoneValidationPresets: PropTypes.shape({
      data: PropTypes.array,
    }),
    customOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    bookQuery: state.bookQuery,
    addressSettings: state.addressSettings,
    financeSources: state.financeSources,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions,
  })
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    address6: '',
    address7: '',
    address8: '',
    address9: '',
    address10: '',
    country: 'my',
    customerDetailID: null,
    customerID: null,
    email: '',
    identity: '',
    identityTypeID: null,
    identityPresetID: '',
    identityPresetLabel: '',
    identityPresetRegex: '',
    taxIdentificationNo: '',
    prsID: '',
    mobile: '',
    mobilePrefix: '60',
    name: '',
    paymentMethodID: 'referred_banker',
    phone: '',
    phonePrefix: '60',
    preferredName: '',
    projectID: null,
    projectUnitID: null,
    spaValue: '',
    spaDecimal: '',
    spaFull: '',
    spaTimes: '',
    nettSellingPrice: '',  // TODO Remove (deprecated tier pricing)
    statusID: 'reserved',
    title: '',
    jobTitle: '',
    monthlyIncome: '',
    nationality: '',
    // CPI-1248: 'local' | 'foreigner', blank until the CRM declares one. Posted for Vietnam only.
    citizenship: '',
    gender: '',
    race: '',
    raceOther: '',
    bumi: 'Not Applicable',
    maritalStatus: '',
    pricingTier: '',
    tierPricingName: '',
    tierPricingDescription: '',
    customerSpecification: [],
    maUserID: 0,
    maCreatedByName: '',
    maCreatedByEmail: '',
    maCreatedByPreferredName: '',
    unitPackagePricingID: '',
    waiveBankGuarantee: false,
    linkBuyerApp: false,
    leadCustomerID: '',
    leadICFrontURL: '',
    leadICBackURL: '',
    origin: '',
    originID: '',
    emergencyContactName: '',
    emergencyContactRelation: '',
    emergencyContactMobilePrefix: '60',
    emergencyContactMobile: '',
    emergencyContactEmail: '',
    emergencyContactIdentity: '',
    sstRegistrationNo: '',
    firstTimeBuyer: '',
    // hims fields
    himsKodPoskod: '',
    himsKodBandar: '',
    himsKodDaerah: '',
    himsKodNegeri: '',
    himsKodNegara: '',
    isRequirePricingSelection: false,
    isDisableBaseSellingPriceSelection: false,
    isForeignCompany: false,
  };
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const booking = Object.assign({}, BookingForm.defaultValues);
    const auth = props.auth;
    let defaultCountryPhoneCode = '60';
    let defaultCountryAddressCode = 'my';
    if (auth && isForeignCompany(auth.company)) {
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === auth.company.countryCode);
      if (idx !== -1) {
        defaultCountryPhoneCode = INTL_FLAG_CODES[idx].value;
        defaultCountryAddressCode = INTL_FLAG_CODES[idx].countryCode;
        booking.mobilePrefix = defaultCountryPhoneCode;
        booking.phonePrefix = defaultCountryPhoneCode;
        booking.emergencyContactMobilePrefix = defaultCountryPhoneCode;
        booking.country = defaultCountryAddressCode;
      }
    }
    booking.maCreatedByPreferredName = auth ? auth.preferredName : '';
    booking.maUserID = auth ? auth.id : 0;
    booking.taxIdentificationNo = '';
    const errMessages = [];
    const tinMessage = null;
    const existingCustomer = {};
    const externalCustomer = {};
    const leadCustomer = {};
    const identity = '';
    // CPI-974 (D6/A7): a VN reservation normally starts from the Booking ID search. CPI-1357
    // additionally accepts the paired, authenticated Marketplace handoff after the event. Do not
    // accept an opportunityID by itself: the detail response must match this exact Booking ID.
    const isVNMarketplaceBookingContext = isVietnamCompany(auth) &&
      query.source === 'lead' &&
      typeof query.opportunityID === 'string' && query.opportunityID !== '' &&
      typeof query.bookingID === 'string' && query.bookingID !== '';
    const crmOpportunityID = isVNMarketplaceBookingContext ? query.opportunityID : '';
    const crmBookingID = isVNMarketplaceBookingContext ? query.bookingID : '';
    const opportunityID = isVietnamCompany(auth) ? '' : (query.opportunityID || '');
    const identityType = (isPRS || opportunityID) ? 1 : '';
    const prsID = '';
    const loaders = {
      searchingID: false,
      searchingIDByMobile: false,
      isFetching: false,
      validatingTIN: false,
    };
    const projectID = query.projectID || '';
    const projectUnitDetails = {
      projectName: '',
      unitStatus: '',
      reference: '',
      statusID: '',
      isBumi: '',
      bookingUnitLimit: 0,
      reservedCount: 0,
      maOwnerCompanyBranchID: 0,
    };
    const projectUnitID = query.unitID || '';
    const identityError = false;
    const tinError = null;
    const selectedProjectUnit = {
      key: '',
      title: '',
    };
    const projectCustomFields = [];
    const origin = query.origin || document.referrer;
    let globalSettings = {};
    const storeGlobalSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGlobalSettings) {
      try {
        globalSettings = JSON.parse(storeGlobalSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    const isCRMEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.leadV2IsEnabled;
    // Keep only a scalar URL value. A nested qs value must never reach the CRM lookup.
    const srCode = typeof query.srCode === 'string' ? query.srCode : '';
    const hasSRCodeQuery = Object.prototype.hasOwnProperty.call(query, 'srCode');

    const identityPresets = props.identityPresets.data;
    const identityTypeOpts = getIdentityTypeOpts(props.auth, identityPresets);
    const phoneValidationPresets = props.phoneValidationPresets.data;

    let hideTitle = false;
    const customOptions = props.customOptions.data;
    if (customOptions.length > 0) {
      const hideTitleOpt = customOptions.find(o => o.name === 'hide_purchaser_title');
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }
    if (hideTitle) {
      booking.title = 'Not Applicable';
    }
    const hideFirstTimeBuyer = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideFirstTimeBuyer;
    if (hideFirstTimeBuyer) {
      booking.firstTimeBuyer = 'no';
    }

    return {
      booking,
      errMessages,
      tinMessage,
      existingCustomer,
      externalCustomer,
      leadCustomer,
      identity,
      identityType,
      identityPresetID: '',
      identityPresetLabel: '',
      identityPresetRegex: '',
      taxIdentificationNo: '',
      prsID,
      loaders,
      projectID,
      projectUnitDetails,
      projectUnitID,
      identityError,
      tinError,
      hasChanges: false,
      selectedProjectUnit,
      projectCustomFields,
      origin,
      opportunityID,
      crmOpportunityID,
      crmBookingID,
      globalSettings,
      identityTypeOpts,
      identityPresets,
      phoneValidationPresets,
      defaultCountryPhoneCode,
      defaultCountryAddressCode,
      isCRMEnabled,
      hideTitle,
      hideFirstTimeBuyer,
      isForeignCompany: false,
      srCode,
      hasSRCodeQuery,
    };
  }
  constructor(props) {
    super(props);
    this.identityInputRef = React.createRef();
    const state = BookingForm.getPropsToState(props);
    this.state = {
      identityLock: false,
      mobileLock: false,
      isLaunchMode: false,
      reservedTimeoutExpireAt: null,
      modalReservationIsOpen: false,
      allowCustomBookingStatus: false,
      allowStaffEditBookingSPAValue: false,
      allowAgentEditBookingSPAValue: false,
      allowAgentAutofillPurchaserDetails: false,
      showCountdown: true,
      showSwapUnit: false,
      showLaunchModeMulti: false,
      launchModeMultiErr: '',
      heldUnit: null, // CPI-1377: the unit named by the one-unit refusal
      bookingSubmitted: false, // CPI-1377: a saved reservation owns its unit, leaving never releases it
      manualSwap: false,
      projectBranchOwnerID: 0,
      projectUnitSwapError: false,
      showNoAutofill: false,
      fetchDataErrorMessage: '',
      showPurchaserExtraFields: false,
      bookingCustomFields: [],
      projectUnitPricings: [],
      defaultBumiProjectPricingID: '',
      defaultProjectPricingID: '',
      pricingTiers: [],
      packagePricings: [],
      feePackages: [],
      paymentMethods: [],
      searchUsersData: [],
      searchUserValue: '',
      projectAllowLinkBuyerApp: false,
      autofillOptions: [],
      isPreviewing: false,
      project: null,
      financeSourceOpts: paymentMethodOpts(props.auth),
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false,
      screenWidth: window.innerWidth,
      isDisableBaseSellingPriceSelection: false,
      // CPI-974 (A): Booking ID (CRM sr_code) lookup; srOpportunity stays null outside Vietnam.
      srCode: '',
      srSearching: false,
      srOpportunity: null,
      srError: '',
      // CPI-1435: the CRM booking's agent could not become Agent Assigned (none, or no agency).
      vnAgentError: '',
      // The project a rejected Booking ID actually belongs to, so the notice can name it.
      srErrorProjectName: '',
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
      // The identity the opportunity supplied, kept so a CCCD the agent types over it can be
      // recognised as a deliberate swap to a different buyer rather than an incidental edit.
      srOriginalIdentity: '',
      // The CRM answer for a swapped-in buyer: null before any lookup, then 'searching', 'found'
      // (with vnCRMCustomer) or 'not_found'.
      vnCRMLookup: null,
      vnCRMCustomer: null,
      // The CCCD whose "not in the CRM" answer already emptied the purchaser fields, so typing
      // on does not wipe what the agent is filling in.
      vnCRMClearedFor: '',
      // CPI-977 D-C4/D-C5: server-priced totals per scheme, and whether the last preview failed.
      vnLivePackageTotals: {},
      vnPreviewFailed: false,
      ...state,
    };
    this.srCodeQueryConsumed = false;
    this.validation = {
      emergencyContactMobilePrefix: createRef(),
      emergencyContactMobile: createRef(),
      identity: createRef(),
      taxIdentificationNo: createRef(),
      country: createRef(),
      prsID: createRef(),
      title: createRef(),
      name: createRef(),
      preferredName: createRef(),
      email: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
      phone: createRef(),
      spaValue: createRef(),
      unitPackagePricingID: createRef(),
      paymentMethodID: createRef(),
      firstTimeBuyer: createRef(),
      srpLoan: createRef(),
      raceOther: createRef(),
      himsKodDaerah: createRef(),
      himsKodPoskod: createRef(),
      sstRegistrationNo: createRef(),
      citizenship: createRef(),
    };

    // add validateRef for all enabled address settings
    const enabledAddressSettings = props.addressSettings.data.filter(as => as.enabled);
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach((as) => {
        const key = _.camelCase(as.columnName);
        this.validation[key] = createRef();
      });
    }
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
    store.dispatch(fetchIdentityPresets());
    store.dispatch(fetchPhoneValidationPresets());
    store.dispatch(fetchAppConfig());
    store.dispatch(fetchCustomOptions());
  }
  async componentDidMount() {
    // CPI-1377: leaving the Reserve screen inside the app while holding an unsaved unit asks first,
    // then releases the hold. Refresh and tab close are not covered on purpose: the hold and its
    // timer carry on until it runs out.
    if (this.props.registerLeaveGuard) this.props.registerLeaveGuard(this.buildLeaveGuard());
    if (this.state.crmOpportunityID && this.state.projectUnitID && this.state.projectID) {
      await this.setLoading('isFetching', true);
      await this.getProjectUnit(this.state.projectID, this.state.projectUnitID, true, true);
      await this.getVNMarketplaceOpportunity();
    } else if (this.state.opportunityID) {
      await this.getOpportunity(this.state.opportunityID);
    } else if (this.state.projectUnitID && this.state.projectID) {
      await this.setLoading('isFetching', true);
      await this.getProjectUnit(this.state.projectID, this.state.projectUnitID, true, true);
    } else {
      const { store } = this.context;
      store.dispatch(replace('/bookings/'));
    }
    this.autofillFromBookQuery(this.props.bookQuery.data);
    this.consumeSRCodeQuery();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillReceiveProps(nextProps) {
    const { identityTypeOpts, identityPresets, isCRMEnabled, phoneValidationPresets } = this.state;
    let newIdentityTypeOpts = [...identityTypeOpts];
    let newIdentityPresets = [...identityPresets];
    let newPhoneValidationPresets = [...phoneValidationPresets];
    let newIsCRMEnabled = isCRMEnabled;
    if (nextProps.identityPresets !== this.props.identityPresets) {
      const auth = this.props.auth;
      newIdentityTypeOpts = getIdentityTypeOpts(auth, nextProps.identityPresets.data);
      newIdentityPresets = nextProps.identityPresets.data;
    }
    if (nextProps.appConfig !== this.props.appConfig) {
      newIsCRMEnabled = nextProps.appConfig && nextProps.appConfig.data && nextProps.appConfig.data.leadV2IsEnabled;
    }
    if (nextProps.phoneValidationPresets !== this.props.phoneValidationPresets) {
      newPhoneValidationPresets = nextProps.phoneValidationPresets.data;
    }
    this.setState({
      identityTypeOpts: newIdentityTypeOpts,
      identityPresets: newIdentityPresets,
      isCRMEnabled: newIsCRMEnabled,
      phoneValidationPresets: newPhoneValidationPresets,
    }, () => this.consumeSRCodeQuery(nextProps));
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    window.removeEventListener('resize', this.handleResize);
    if (this.props.registerLeaveGuard) this.props.registerLeaveGuard(null);
  }
  // buildLeaveGuard is what checkChanges asks before an in-app navigation leaves this screen.
  buildLeaveGuard() {
    return {
      // showCountdown turns false when the timer runs out, just before the screen leaves by itself
      shouldBlock: () => !this.holdReleasedOnLeave && this.state.showCountdown !== false &&
        shouldReleaseHoldOnLeave(this.state),
      header: () => this.props.t('Release unit', { ns: TRANSLATION_FILES.translation }),
      message: () => this.props.t('Leave and release unit {{reference}}? Unsaved changes will be lost.', {
        reference: (this.state.projectUnitDetails && this.state.projectUnitDetails.reference) || '',
        ns: TRANSLATION_FILES.translation,
      }),
      onConfirm: () => this.releaseHoldOnLeave(),
    };
  }
  // releaseHoldOnLeave is the leave guard's confirm step: release this unit's hold, then let the
  // navigation go ahead. keepalive lets the request finish after the screen is gone, and a failed
  // release is no reason to keep the agent here: the hold still runs out on its own.
  async releaseHoldOnLeave() {
    this.holdReleasedOnLeave = true;
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(preReservedURL(config.get('bookApiURL'), this.state.projectID, this.state.projectUnitID, { clear: true }), {
        credentials: 'include',
        method: 'GET',
        keepalive: true,
        ignoreForbidden: true,
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      // best effort: the hold's server-side expiry is the backstop
    }
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  handleResize = () => {
    this.setState({ screenWidth: window.innerWidth });
  };
  setLoading(name, loading = false) {
    const { loaders } = this.state;
    let { identityLock, mobileLock } = this.state;
    const searchByID = name === 'searchingID';
    const searchByMobile = name === 'searchingIDByMobile';
    if (searchByID || searchByMobile) {
      if (loading) {
        if (searchByID) identityLock = true;
        if (searchByMobile) mobileLock = true;
      } else {
        if (searchByID) identityLock = false;
        if (searchByMobile) mobileLock = false;
      }
    }
    loaders[name] = loading;
    return new Promise((res) => {
      this.setState({ loaders, identityLock, mobileLock }, res);
    });
  }
  getIdentityPlaceholder = (isIndonesia) => {
    if (isPRS) return 'NRIC Number';
    if (this.state.identityType === '') {
      return 'Select Identity Type first';
    }
    switch (this.state.identityType) {
      case 2:
        return 'Passport Number';
      case 4:
        return isIndonesia ? 'e.g. 1234567890123' : 'e.g. 202401012345';
      default:
        return 'Identity Number';
    }
  }
  getIdentityInputLabel = (isHidden) => {
    switch (this.state.identityType) {
      case 4:
        return isHidden ? null : 'Enter 12-digit Company Registration Number';
      default:
        return null;
    }
  }
  getCountdownFormat = (reservedTimeoutExpireAt) => {
    const minutesLeft = moment.duration(moment(reservedTimeoutExpireAt).diff(moment())).asMinutes();
    return {
      hour: minutesLeft > 60 ? 'HH' : '',
      minute: 'MM',
      second: 'SS',
    };
  }
  getSelectedCreatorValue = () => {
    const { booking } = this.state;
    const SelectedCreatorValue = {
      key: booking.maUserID.toString() || 0,
      title: booking.maCreatedByPreferredName || '',
      price: '',
    };
    return SelectedCreatorValue;
  }
  getRace = (race) => {
    if (race) {
      const presetRace = RACE.find(d => d.value.toLowerCase() === race.toLowerCase());
      if (!presetRace) {
        return 'Others';
      }
      return presetRace.value;
    }
    return '';
  }
  getBirthDate = (birthDate, nric) => {
    if (nric !== '' && nric.length === 12) {
      const dfIC = dateFromIC(nric.substring(0, 6));
      if (dfIC) {
        const mBirthdate = moment.tz(dfIC, config.get('tzName'));
        if (mBirthdate.isValid()) {
          return mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    const date = new Date(birthDate);
    if ((date !== 'Invalid Date') && !isNaN(date)) {
      return birthDate;
    }
    return '';
  }
  getMaritalStatus = (maritalStatus) => {
    if (maritalStatus) {
      const preset = MARITAL_STATUS.find(d => d.value.toLowerCase() === maritalStatus.toLowerCase());
      if (preset) {
        return preset.value;
      }
    }
    return '';
  }
  getAutofillIdentityTypeName = (typeID) => {
    if (!isNumeric(typeID)) return AUTOFILL_PRESET;
    if (typeID > 0 && typeID <= 6) {
      const idx = AUTOFILL_IDENTITY_TYPES.findIndex(a => a.id === typeID);
      if (idx > -1) return AUTOFILL_IDENTITY_TYPES[idx].name;
    }
    return AUTOFILL_NRIC;
  }
  getAutofillIdentityTypeID = (typeName) => {
    if (typeName !== '') {
      const idx = AUTOFILL_IDENTITY_TYPES.findIndex(a => a.name === typeName);
      if (idx > -1) return AUTOFILL_IDENTITY_TYPES[idx].id;
    }
    return 1;
  }
  getPhoneInputIcon = () => {
    const { t } = this.props;
    const { loaders } = this.state;
    if (loaders.searchingIDByMobile) {
      return <Icon loading name="spinner" />;
    }
    if (this.hasResetMobileIcon()) {
      return (
        <Icon
          link
          name="x"
          onClick={this.handleResetAutofill}
          title={t('Clear Form')}
        />
      );
    }
    return null;
  }
  async getOpportunity(opportunityID) {
    const opportunity = await this.fetchData(`/leads/opportunity/${opportunityID}/`, 'isFetching');
    if (!opportunity || (opportunity && opportunity.booking_id)) {
      if (this.state.projectUnitID && this.state.projectID) {
        this.getProjectUnit(this.state.projectID, this.state.projectUnitID);
        this.getProjectCustomFields(this.state.projectID);
      } else {
        const { store } = this.context;
        store.dispatch(replace('/bookings/'));
      }
      return;
    }
    let { booking, identityType, identity } = this.state;
    const projectID = opportunity.data.project_id;
    const projectUnitID = opportunity.data.unit_id;
    let customer;
    if (opportunity.data.primary_customer && opportunity.data.primary_customer.customer) {
      customer = opportunity.data.primary_customer.customer;
    }
    if (customer) {
      booking = Object.assign(booking, customer.customerDetail);
      booking.leadCustomerID = opportunity.data.primary_customer_id;
      booking.race = this.getRace(customer.customerDetail.race);
      booking.raceOther = booking.race === 'Others' ? customer.customerDetail.race : '';
      if (customer.identity) {
        identity = customer.identity.trim();
        booking.identity = identity;
      }
      if (customer.identityTypeID) {
        identityType = customer.identityTypeID;
        booking.identityTypeID = identityType;
      }
      booking.birthdate = this.getBirthDate(customer.customerDetail.birthdate, identityType === 1 ? identity : '');
      booking.customerSpecification = customer.specifications;
      if (customer.icFrontDocument && customer.icFrontDocument.key) {
        booking.leadICFrontURL = customer.icFrontDocument.key;
      }
      if (customer.icBackDocument && customer.icBackDocument.key) {
        booking.leadICBackURL = customer.icBackDocument.key;
      }
      booking.maritalStatus = this.getMaritalStatus(customer.customerDetail.maritalStatus);
    }
    this.setState({
      projectID,
      projectUnitID,
      booking,
      identityType,
      identity,
    }, () => {
      this.getProjectUnit(projectID, projectUnitID);
      this.getProjectCustomFields(projectID, opportunity.data.primary_customer);
    });
  }
  // CPI-1357: book-api creates this URL only after it has validated the agent, project, unit and
  // CRM opportunity. The browser still treats query text as untrusted: populate the VN form only
  // after the opportunity detail has the exact Booking ID that travelled with it.
  async getVNMarketplaceOpportunity() {
    const { store } = this.context;
    const { crmBookingID, crmOpportunityID, projectID } = this.state;
    await this.setComponentState({
      srSearching: true,
      srError: '',
      srErrorProjectName: '',
      srOpportunity: null,
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
    });
    try {
      // The marketplace URL is browser-controlled after Book API creates it. The Book API
      // authenticates this detail request and applies the CRM role and assignment policy.
      const detailRes = await store.dispatch(fetchM(`/opportunity/${crmOpportunityID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      if (!detailRes || !detailRes.ok) {
        await this.setComponentState({ srError: 'not_found' });
        return;
      }
      const opportunity = await detailRes.json();
      if (String((opportunity && opportunity.sr_code) || '').trim() !== crmBookingID.trim()) {
        await this.setComponentState({ srError: 'not_found' });
        return;
      }
      if (opportunity.sr_status !== CRM_OPPORTUNITY_APPROVED) {
        await this.setComponentState({ srError: 'not_approved' });
        return;
      }
      if (projectID && opportunity.project_id && String(opportunity.project_id) !== String(projectID)) {
        await this.setComponentState({
          srError: 'wrong_project',
          srErrorProjectName: opportunity.project_name || '',
        });
        return;
      }
      this.applyOpportunityToForm(opportunity);
    } catch (err) {
      Bugsnag.notifyException(err);
      await this.setComponentState({ srError: 'not_found' });
    } finally {
      await this.setComponentState({ srSearching: false });
    }
  }
  // CPI-974 (A): Booking ID (CRM sr_code) lookup, Vietnam only - the form is read-only until an
  // APPROVED opportunity has been pulled in.
  isVNFormLocked = () => isVietnamCompany(this.props.auth) && !this.state.srOpportunity;
  // CPI-977 S1: Save is disabled until a package is chosen (always in Vietnam, else the project switch).
  isSaveBlockedByPricingPackage = () => isPricingPackageMissing(
    this.state.isRequirePricingSelection,
    this.state.booking.unitPackagePricingID,
    this.state.projectUnitDetails && this.state.projectUnitDetails.spaValue,
  );

  // A CRM-to-chart handoff supplies the Booking ID in the URL. Once the authenticated session is
  // ready, remove that one-time value. Vietnam then invokes the normal lookup and approval path.
  consumeSRCodeQuery = (props = this.props) => {
    if (this.srCodeQueryConsumed || !this.state.hasSRCodeQuery) return;
    const { auth, location } = props;
    if (!auth || !auth.id) return;

    this.srCodeQueryConsumed = true;
    const query = decodeSearch(location.search);
    const code = this.state.srCode;
    delete query.srCode;
    const nextSearch = encodeSearch(query);
    const nextLocation = `${location.pathname}${nextSearch ? `?${nextSearch}` : ''}${location.hash || window.location.hash || ''}`;
    const { store } = this.context;

    this.setState({ hasSRCodeQuery: false }, () => {
      store.dispatch(replace(nextLocation));
      if (isVietnamCompany(auth) && code.trim()) this.searchOpportunityBySRCode();
    });
  }

  handleSRCodeChange = (e) => {
    this.setState({ srCode: e.target.value, srError: '' });
  }

  handleSRCodeKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.searchOpportunityBySRCode();
    }
  }

  // CPI-1248: blank the citizenship the last opportunity supplied. Every path that drops the
  // opportunity goes through here, so a foreigner read off a mistyped Booking ID cannot survive
  // into the local purchaser the user looks up next - and neither can a stale 'local'.
  clearCRMCitizenship = (nextState) => {
    const { booking } = this.state;
    booking.citizenship = '';
    return Object.assign({ booking }, nextState);
  }

  async searchOpportunityBySRCode() {
    const { store } = this.context;
    const code = (this.state.srCode || '').trim();
    if (!code || this.state.srSearching) return;
    await this.setComponentState(this.clearCRMCitizenship({
      srSearching: true,
      srError: '',
      srErrorProjectName: '',
      srOpportunity: null,
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
    }));
    try {
      const listRes = await store.dispatch(fetchM(`/opportunity/?${qs.stringify({ sr_code: code, limit: 30 })}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      if (!listRes || !listRes.ok) {
        await this.setComponentState({ srError: 'not_found' });
        return;
      }
      const listData = await listRes.json();
      const opportunities = (listData && listData.opportunities) || [];
      const match = opportunities.find(o =>
        String(o.sr_code || '').trim().toUpperCase() === code.toUpperCase());
      if (!match || !match.id) {
        await this.setComponentState({ srError: 'not_found' });
        return;
      }
      if (match.sr_status !== CRM_OPPORTUNITY_APPROVED) {
        await this.setComponentState({ srError: 'not_approved' });
        return;
      }
      // book-api refuses a reservation whose opportunity belongs to another project, but it does
      // so on save (412), after the agent has filled the whole form in. Everything needed to know
      // that is already here, so say it now and leave the form locked.
      if (this.state.projectID && match.project_id && match.project_id !== this.state.projectID) {
        await this.setComponentState({
          srError: 'wrong_project',
          srErrorProjectName: match.project_name || '',
        });
        return;
      }
      const detailRes = await store.dispatch(fetchM(`/opportunity/${match.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      if (!detailRes || !detailRes.ok) {
        await this.setComponentState({ srError: 'not_found' });
        return;
      }
      const opportunity = await detailRes.json();
      if (!opportunity || opportunity.sr_status !== CRM_OPPORTUNITY_APPROVED) {
        await this.setComponentState({ srError: 'not_approved' });
        return;
      }
      this.applyOpportunityToForm(opportunity);
    } catch (err) {
      Bugsnag.notifyException(err);
      await this.setComponentState({ srError: 'not_found' });
    } finally {
      await this.setComponentState({ srSearching: false });
    }
  }

  getCRMContact = (customer) => {
    if (!customer) return null;
    if (customer.contact) return customer.contact;
    if (customer.contacts && customer.contacts.length > 0) return customer.contacts[0];
    return null;
  }

  // A contact that Showroom's own sync wrote to the CRM carries the number in `nric` and no
  // identity_type. Infer the type from whichever value field is present, so such a contact
  // (or any other typeless one) still maps instead of arriving as a blank identity.
  getShowroomIdentityType = (contact) => {
    const mapped = CRM_IDENTITY_TYPE_MAP[parseInt(contact.identity_type, 10)];
    if (mapped) return mapped;
    const has = field => String(contact[field] || '').trim() !== '';
    if (has('cccd') || has('nric')) return IDENTITY_TYPE_NRIC;
    if (has('passport')) return IDENTITY_TYPE_PASSPORT;
    if (has('other_identity')) return IDENTITY_TYPE_BRN;
    return 0;
  }

  getCRMIdentity = (contact, identityTypeID) => {
    const field = CRM_IDENTITY_VALUE_FIELD[identityTypeID];
    if (!field) return '';
    const value = String(contact[field] || '').trim();
    // `nric` is where Showroom's sync used to put a CCCD; read it when `cccd` is blank.
    if (value === '' && field === 'cccd') return String(contact.nric || '').trim();
    return value;
  }

  getCRMOptionValue = (options, value) => {
    if (!value) return '';
    const normalise = v => String(v).trim().toLowerCase().replace(/\.$/, '');
    const wanted = normalise(value);
    const match = options.find(o => normalise(o.value) === wanted);
    return match ? match.value : '';
  }

  getCRMMobilePrefix = (countryCode) => {
    const match = INTL_FLAG_CODES.find(f => f.countryCode === String(countryCode || '').toLowerCase());
    return match ? match.value : '';
  }

  mapCRMContactToBookingFields = (contact) => {
    const identityTypeID = this.getShowroomIdentityType(contact);
    const identity = this.getCRMIdentity(contact, identityTypeID);
    const mobilePrefix = this.getCRMMobilePrefix(contact.mobile_country_code);
    const emergency = (contact.emergency_contacts && contact.emergency_contacts[0]) || null;
    const fields = {
      title: this.getCRMOptionValue(CUSTOMER_TITLES, contact.title),
      name: contact.name || '',
      preferredName: contact.preferred_name || '',
      email: contact.email || '',
      gender: this.getCRMOptionValue(GENDER, contact.gender),
      // CPI-977: same treatment as mobile. The CRM sends no phone prefix, so the form's current
      // one (the company default unless changed) is what book-api will validate it against.
      phone: crmContactMobile(contact.phone, this.state.booking.phonePrefix),
      identity,
      identityTypeID: identityTypeID || null,
      birthdate: this.getBirthDate(contact.date_of_birth, ''),
      maritalStatus: this.getMaritalStatus(contact.marital_status),
      nationality: String(contact.nationality_country_code || '').toLowerCase(),
      // CPI-1248: the CRM's declared citizenship, explicit field first and the legacy address_4
      // only when it holds one of the two values. Blank for a customer who never declared one.
      citizenship: crmContactCitizenship(contact),
      // CPI-977: national number only - the CRM sometimes hands back the full msisdn here, and
      // a related purchaser posts it untouched (no input to correct it in).
      mobile: crmContactMobile(contact.mobile, mobilePrefix),
      address1: contact.address_1 || '',
      address2: contact.address_2 || '',
      address5: contact.postcode || '',
      address6: contact.city || '',
      address7: contact.state || '',
      jobTitle: contact.occupation || '',
      monthlyIncome: contact.monthly_income || '',
      leadICFrontURL: crmIdentityMediaReference(contact.ic_front),
      leadICBackURL: crmIdentityMediaReference(contact.ic_back),
    };
    const countryCode = String(contact.country_code || '').toLowerCase();
    if (countryCode) fields.country = countryCode;
    if (mobilePrefix) fields.mobilePrefix = mobilePrefix;
    if (emergency) {
      fields.emergencyContactName = emergency.name || '';
      fields.emergencyContactRelation = emergency.relation || '';
      fields.emergencyContactEmail = emergency.email || '';
      fields.emergencyContactIdentity = emergency.nric || '';
      const emergencyPrefix = emergency.mobile_prefix ||
        this.getCRMMobilePrefix(emergency.mobile_country_code);
      if (emergencyPrefix) fields.emergencyContactMobilePrefix = emergencyPrefix;
      // CPI-977: book-api runs the same preset regex on the emergency mobile ("Invalid Emergency
      // Contact Number"), so a full msisdn here fails a related purchaser just like `mobile`.
      fields.emergencyContactMobile = crmContactMobile(
        emergency.mobile,
        emergencyPrefix || this.state.booking.emergencyContactMobilePrefix,
      );
    }
    return fields;
  }

  buildRelatedBookingCustomers = (opportunity) => {
    const primaryID = opportunity.primary_customer_id ||
      (opportunity.primary_customer && opportunity.primary_customer.id);
    const customers = (opportunity.customers || []).filter(c => c && c.id !== primaryID);
    return customers.map((customer) => {
      const contact = this.getCRMContact(customer);
      if (!contact) return null;
      const fields = this.mapCRMContactToBookingFields(contact);
      // CRM allows a blank Preferred Name; Book requires one for each purchaser.
      if (isVietnamCompany(this.props.auth) && !fields.preferredName.trim()) {
        fields.preferredName = fields.name;
      }
      return {
        ...fields,
        // CPI-1291: the CRM's income is a string, bookingCustomers.monthlyIncome is a float64.
        // Read from the contact, not from fields, so a numeric 0 survives mapping's `|| ''`.
        monthlyIncome: crmMonthlyIncome(contact.monthly_income),
        // Related purchaser's relationship to the primary purchaser, from the CRM contact; matched
        // to RELATIONSHIP_TYPE (book-api rejects anything else). Blank when the CRM has none.
        relationshipType: this.getCRMOptionValue(RELATIONSHIP_TYPE, contact.relationship_type),
        customer: {
          identity: fields.identity,
          identityTypeID: fields.identityTypeID || 6,
        },
        leadCustomerID: customer.id,
      };
    }).filter(Boolean);
  }

  applyOpportunityToForm = (opportunity) => {
    const contact = this.getCRMContact(opportunity.primary_customer);
    const { booking } = this.state;
    const nextState = {
      srOpportunity: opportunity,
      srCode: opportunity.sr_code || this.state.srCode,
      srError: '',
      vnAgentError: '',
      opportunityID: opportunity.id,
      srRelatedBookingCustomers: this.buildRelatedBookingCustomers(opportunity),
    };
    if (contact) {
      const fields = this.mapCRMContactToBookingFields(contact);
      Object.assign(booking, fields);
      booking.origin = 'lead';
      booking.originID = opportunity.id;
      booking.leadCustomerID = opportunity.primary_customer_id || '';
      nextState.booking = booking;
      nextState.identity = fields.identity;
      nextState.identityType = fields.identityTypeID || '';
      nextState.srIdentityTypeUnmapped = !fields.identityTypeID;
      nextState.srOriginalIdentity = fields.identity || '';
    }
    nextState.vnCRMLookup = null;
    nextState.vnCRMCustomer = null;
    nextState.vnCRMClearedFor = '';
    this.setState(nextState, () => {
      this.handleCheckChanges();
      this.applyCRMAgentToForm(opportunity);
    });
  }

  // CPI-1435: Agent Assigned (Created By) is the CRM booking's agent. Resolve its Cognito username
  // to the Showroom user and agency and fill the locked field; book-api enforces the same agent on
  // Create and refuses "Invalid assigned agent" when there is none. Only the roles that see the field.
  applyCRMAgentToForm = async (opportunity) => {
    if (!agentAssignedLocked(this.props.auth) || !this.hasAccess(false, true, true, false, false)) return;
    if (this.state.srOpportunity !== opportunity) return;
    // Never show the logged-in user or a previous booking's agent while (or if) the lookup fails:
    // the field is locked, so it may only ever hold this CRM booking's agent.
    this.handleUserClear();
    const { store } = this.context;
    const { t } = this.props;
    const showInvalid = () => {
      if (this.state.srOpportunity !== opportunity) return;
      this.setState({
        vnAgentError: t('Invalid assigned agent. Please assign a valid agent to this booking in the CRM first.', { ns: TRANSLATION_FILES.screens }),
      });
    };
    const query = crmAgentLookupQuery(opportunity && opportunity.assigned_to);
    if (!query) {
      showInvalid();
      return;
    }
    let staffs;
    try {
      const res = await store.dispatch(fetchM(`/search/staffs/?${query}`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        ignoreForbidden: true,
        ignoreNotFound: true,
      }));
      staffs = (res && res.ok && await res.json()) || [];
    } catch (e) {
      // the lookup itself failed: leave the field to book-api's own check on Create
      Bugsnag.notifyException(e);
      return;
    }
    const agent = staffs.find(isCompleteSaleAgent);
    if (!agent) {
      showInvalid();
      return;
    }
    if (this.state.srOpportunity !== opportunity) return;
    const { booking } = this.state;
    booking.maCreatedByName = agent.name;
    booking.maCreatedByEmail = agent.email;
    booking.maCreatedByPreferredName = agent.preferredName;
    booking.maUserAffiliateCompanyBranchShortName = agent.companyBranchShortName;
    booking.maUserAffiliateCompanyBranchID = agent.companyBranchID;
    booking.maUserAffiliateCompanyID = agent.companyID;
    booking.maUserAffiliateID = agent.affiliateID;
    booking.maUserID = agent.id;
    this.setState({ booking, vnAgentError: '' });
  }

  handleResetSRSearch = () => {
    this.setState(this.clearCRMCitizenship({
      srCode: '',
      srOpportunity: null,
      srError: '',
      vnAgentError: '',
      srSearching: false,
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
      srOriginalIdentity: '',
      vnCRMLookup: null,
      vnCRMCustomer: null,
      vnCRMClearedFor: '',
      opportunityID: '',
    }));
  }

  // The CRM contact field a Showroom identity type is stored in for Vietnam. Mirrors book-api's
  // own Vietnam mapping, which is what wrote the contact. '' means this type has no CRM field.
  vnCRMSearchField = (identityTypeID) => {
    switch (identityTypeID) {
      case 1: return 'cccd';
      case 2: return 'passport';
      case 4: return 'other_identity';
      default: return '';
    }
  }

  // The CRM only accepts a Vietnam CCCD once it passes the same shared rule rendered below the
  // input. Keep this small lookup gate separate from form validation: a purchaser can be found
  // before the agent completes their other booking fields.
  isValidVNCCCD = (identity) => {
    const validation = vnIdentityValidation(this.props.auth, 1, this.props.t);
    return Boolean(validation && typeof identity === 'string' && validation.validRegex.test(identity));
  }

  // The agent reserved the unit under their own name and has now typed the real buyer's CCCD over
  // it. Ask the CRM who that is, so the form can be filled from the CRM rather than retyped. Only
  // reachable once an approved Booking ID has unlocked the form.
  searchVNCRMPurchaser = async (identity, identityTypeID) => {
    const searchField = this.vnCRMSearchField(identityTypeID);
    if (!searchField || !identity) {
      // The spinner is switched on when the wait starts, so an identity type the CRM has no
      // field for has to switch it back off here rather than leave it turning forever.
      await this.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });
      return;
    }
    if (identityTypeID === 1 && !this.isValidVNCCCD(identity)) {
      // The spinner starts with the debounce, so an incomplete CCCD must clear it without
      // waiting for a request that is deliberately never sent.
      if (this.state.identity === identity && this.state.identityType === identityTypeID) {
        await this.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });
      }
      return;
    }
    // A type switch may happen during the debounce. Do not turn an old CCCD request into a
    // passport/enterprise request, or show a response for an identity type no longer selected.
    if (this.state.identity !== identity || this.state.identityType !== identityTypeID) {
      return;
    }
    await this.setComponentState({ vnCRMLookup: 'searching', vnCRMCustomer: null });
    const res = await this.fetchData(
      `/leads/customers/search/?${qs.stringify({ search: identity, searchField })}`,
      '',
      true,
      {},
      false,
    );
    // Only answer the lookup the agent is still waiting on: they may have typed on since.
    if (this.state.identity !== identity || this.state.identityType !== identityTypeID ||
      (identityTypeID === 1 && !this.isValidVNCCCD(identity))) {
      return;
    }
    // fetchData answers null for a failed request and { data } for a successful one, so an empty
    // answer and an unreachable CRM look the same unless they are told apart here. They must be:
    // "not in the CRM" empties the purchaser fields, and a timeout or a 500 would otherwise erase
    // what the agent had typed. On a failure, say nothing and leave the form alone.
    if (res === null) {
      await this.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });
      return;
    }
    const match = res.data && res.data.length > 0 ? res.data[0] : null;
    const contact = match ? this.getCRMContact(match) : null;
    if (!contact) {
      await this.setComponentState({ vnCRMLookup: 'not_found', vnCRMCustomer: null });
      this.clearPurchaserForNewBuyer(identity);
      return;
    }
    await this.setComponentState({ vnCRMLookup: 'found', vnCRMCustomer: match });
  }

  // The CRM has nobody with this CCCD, so the details still on screen are the previous person's -
  // usually the agent, who opened the opportunity. Empty them, or a name the agent never changed
  // is saved against the new buyer's identity. The CCCD itself stays: they just typed it.
  //
  // Cleared once per CCCD. Each keystroke re-runs the lookup, and without this guard a second
  // not_found would wipe the details the agent had already started filling in.
  clearPurchaserForNewBuyer = (identity) => {
    if (this.state.vnCRMClearedFor === identity) {
      return;
    }
    const { defaultCountryPhoneCode, defaultCountryAddressCode } = this.state;
    const booking = Object.assign(this.state.booking, {
      title: this.state.hideTitle ? 'Not Applicable' : '',
      name: '',
      preferredName: '',
      email: '',
      mobile: '',
      mobilePrefix: defaultCountryPhoneCode,
      phone: '',
      phonePrefix: defaultCountryPhoneCode,
      address1: '',
      address2: '',
      address5: '',
      address6: '',
      address7: '',
      country: defaultCountryAddressCode,
      birthdate: '',
      gender: '',
      maritalStatus: '',
      nationality: '',
      jobTitle: '',
      monthlyIncome: '',
      // The reservation owns its purchaser, so nothing here may keep pointing at the CRM record
      // or the Showroom row the previous person came from.
      customerID: null,
      customerDetailID: null,
      leadCustomerID: '',
      leadICFrontURL: '',
      leadICBackURL: '',
    });
    this.setState(this.clearCRMCitizenship({
      booking,
      vnCRMClearedFor: identity,
    }), () => {
      this.handleCheckChanges();
    });
  }

  // Fill the purchaser from the CRM customer the lookup found. The agent asks for this explicitly,
  // so a wrong CCCD never silently overwrites what they typed.
  applyVNCRMPurchaser = () => {
    const { vnCRMCustomer, booking } = this.state;
    const contact = vnCRMCustomer ? this.getCRMContact(vnCRMCustomer) : null;
    if (!contact) {
      return;
    }
    const fields = this.mapCRMContactToBookingFields(contact);
    Object.assign(booking, fields);
    // mapCRMContactToBookingFields carries the contact's details and nothing else, so without this
    // the ids the opportunity left behind survive: customerID and customerDetailID still name the
    // agent's Showroom rows and leadCustomerID still names their CRM customer, and the submit
    // sends all three. This purchaser is a different person, and the reservation owns them
    // privately, so none of those may follow. Same reset the not-found path does.
    Object.assign(booking, {
      customerID: null,
      customerDetailID: null,
      leadCustomerID: '',
    });
    this.setState({
      booking,
      identity: fields.identity,
      identityType: fields.identityTypeID || this.state.identityType,
      vnCRMLookup: 'applied',
    }, () => {
      this.handleCheckChanges();
    });
  }

  async getProjectCustomFields(projectID, leadCustomer, skipLoader = false) {
    const project = await this.fetchData(`/projects/${projectID}/`, skipLoader ? '' : 'isFetching');
    if (!project) {
      return;
    }
    const projectCustomFields = project.data.projectBookingCustomFields || [];
    const { booking, bookingCustomFields } = this.state;
    let leadData;
    // autofill lead custom fields
    if (leadCustomer && leadCustomer.emergency_contacts) {
      leadData = leadCustomer.emergency_contacts;
    }
    if (projectCustomFields) {
      projectCustomFields.forEach((data) => {
        let value = data.defaultValue;
        // autofill lead custom fields
        if (leadData) {
          switch (data.name) {
            case 'name_emergency_contact_person_':
              value = leadData.name;
              break;
            case 'nric_no_emergency_contact_person_':
              value = leadData.nric || leadData.identity_no;
              break;
            case 'telephone_emergency_contact_person_':
              value = leadData.mobile_prefix + leadData.mobile;
              break;
            case 'email_emergency_contact_person_':
              value = leadData.email;
              break;
            case 'relationship_emergency_contact_person_':
              value = leadData.relation;
              break;
            default:
              if (leadData[data.name]) {
                value = leadData[data.name];
              }
              break;
          }
        }
        if (value !== '') {
          if (data.type === 'dropdown' && data.projectBookingCustomFieldOptions) {
            const optionItem = data.projectBookingCustomFieldOptions.find(
              d => d.value === value,
            );
            if (optionItem) {
              const customField = {
                name: data.name,
                value,
                projectBookingCustomFieldID: data.id,
                projectBookingCustomFieldOptionID: optionItem.id,
              };
              bookingCustomFields.push(customField);
              booking[data.name] = value;
            }
          }
          if (data.type === 'dropdown_multi' && data.projectBookingCustomFieldOptions) {
            value = data.defaultValue.split(',');
            const optionItems = [];
            data.projectBookingCustomFieldOptions.forEach((o) => {
              value.forEach((v) => {
                if (v === o.value) optionItems.push(o.id);
              });
            });
            if (optionItems) {
              const customField = {
                name: data.name,
                value: value.join(),
                projectBookingCustomFieldID: data.id,
                projectBookingCustomFieldOptionIDs: optionItems,
              };
              bookingCustomFields.push(customField);
              booking[data.name] = value.join();
            }
          }
          if (data.type === 'input') {
            const customField = {
              name: data.name,
              value,
              projectBookingCustomFieldID: data.id,
            };
            bookingCustomFields.push(customField);
            booking[data.name] = value;
          }
        }
      });
    }
    await this.setComponentState({
      projectCustomFields,
      bookingCustomFields,
      booking,
      project: project.data,
    });
  }
  async getProjectUnit(projectID, projectUnitID, skipLoader = false, firstLoad = false) {
    const projectUnit = await this.fetchData(`/projects/${projectID}/units/${projectUnitID}/?showAppliedPPBookingTotalPrice=true`, skipLoader ? '' : 'isFetching');
    const user = this.props.auth;
    let modalReservationIsOpen = false;
    if (!projectUnit) {
      return;
    }
    // Pre-Sales Launch: HQ can stop chosen roles creating bookings on this project. Checked before
    // any hold is taken, so every way into the form (unit page, siteplan app, a typed URL, swap
    // unit) lands on the Forbidden page. The API refuses the create and the hold as well.
    if (reservationBlocked(user, projectUnit.data.project)) {
      const { store } = this.context;
      store.dispatch(replace('/forbidden/'));
      return;
    }
    const { t, financeSources } = this.props;
    const { booking, leadCustomer } = this.state;
    const pud = this.state.projectUnitDetails;
    const isLaunchMode = projectUnit.data.project.isLaunchMode;
    const projectAllowLinkBuyerApp = projectUnit.data.project.linkBuyerApp;
    booking.projectID = projectUnit.data.projectID;
    booking.projectUnitID = projectUnit.data.id;
    booking.spaValue = spaFullNumber(projectUnit.data).toString();
    booking.nettSellingPrice = spaFullNumber(projectUnit.data).toString();  // TODO Remove (deprecated tier pricing)
    booking.pricingTier = spaFullNumber(projectUnit.data).toString();
    booking.statusID = projectUnit.data.project.defaultCustomBookingStatusID;
    pud.spaValue = spaFullNumber(projectUnit.data).toString();
    pud.spaTimes = projectUnit.spaTimes;
    pud.projectName = projectUnit.data.project.name;
    pud.reference = projectUnit.data.reference;
    pud.statusID = projectUnit.data.statusID;
    pud.unitStatus = projectUnit.data.status.name;
    pud.isBumi = projectUnit.data.isBumi;
    pud.loanTrackerDirectShow = projectUnit.data.project.loanTrackerDirectShow;
    pud.bookingUnitLimit = projectUnit.data.project.bookingUnitLimit;
    pud.maOwnerCompanyBranchID = projectUnit.data.project.maOwnerCompanyBranchID;
    pud.reservedCount = projectUnit.data.projectUnitBookingSummary.reservedCount;
    pud.autofillFromUrl = projectUnit.data.project.autofillFromUrl;
    pud.externalAutofillUrl = projectUnit.data.project.externalAutofillUrl;
    pud.defaultBumiProjectPricingID = projectUnit.data.project.defaultBumiProjectPricingID;
    pud.defaultProjectPricingID = projectUnit.data.project.defaultProjectPricingID;
    pud.projectUnitPricings = projectUnit.data.projectUnitPricings;
    // package pricing
    pud.projectUnitPackagePricings = projectUnit.data.projectUnitPackagePricings;
    pud.projectUnitPackageFees = projectUnit.data.projectUnitPackageFees;
    pud.defaultProjectPackagePricingID = projectUnit.data.project.defaultProjectPackagePricingID;
    pud.defaultBumiProjectPackagePricingID = projectUnit.data.project.defaultBumiProjectPackagePricingID;
    booking.tierPricingName = '';
    booking.tierPricingDescription = '';
    pud.isDisableBaseSellingPriceSelection = projectUnit.data.project.disableBaseSellingPriceSelection;
    // Setup package pricings
    const unitPackagePricings = pud.projectUnitPackagePricings || [];
    // CPI-977 (PO, 14 Sep): a Vietnam reservation always needs a named package, so the
    // "Base Selling Price" entry is not offered there at all - the dropdown starts empty.
    const packagePricings = isVietnamCompany(this.props.auth) ? [] : [{
      value: spaFullNumber(projectUnit.data).toString(),
      description: spaFullNumber(projectUnit.data).toString(),
      text: t('Base Selling Price'),
      disabled: (isPackagePricingRequired && (unitPackagePricings && unitPackagePricings.length > 0)) || pud.isDisableBaseSellingPriceSelection,
      content: (
        <Header className="ddPricingTierItem">
          <div className="name">{t('Base Selling Price')}</div>
          <div className="value"><LoanAmount precise={false} format="0,000,000.00" amount={spaFullNumber(projectUnit.data).toString()} prefix={<CurrencySymbol />} /></div>
        </Header>
      ),
    }];
    if (unitPackagePricings) {
      unitPackagePricings.forEach((d) => {
        const newItem = {
          value: d.id,
          description: d.totalPrice.toString(),
          disabled: false,
          text: d.customName,
          content: (
            <Header className="ddPricingTierItem">
              <div className="name">{d.customName}</div>
              <div className="value"><LoanAmount precise={false} format="0,000,000.00" amount={d.totalPrice.toString()} prefix={<CurrencySymbol />} /></div>
              <Header.Subheader>{d.customDescription}</Header.Subheader>
            </Header>
          ),
        };
        if (d.projectPackagePricing && d.projectPackagePricing.id) {
          let pppDescription = d.projectPackagePricing.description;
          if (pppDescription.includes('\n')) {
            pppDescription = pppDescription.split('\n').map((pppd, idx) => <span key={idx}>{pppd}<br /></span>);
          }

          newItem.text = d.projectPackagePricing.name;
          newItem.value = d.id;
          newItem.disabled = false;
          newItem.content = (
            <Header className="ddPricingTierItem">
              <div className="name">{d.projectPackagePricing.name}</div>
              <div className="value"><LoanAmount precise={false} format="0,000,000.00" amount={d.totalPrice.toString()} prefix={<CurrencySymbol />} /></div>
              <Header.Subheader>{pppDescription}</Header.Subheader>
            </Header>
          );
        }
        packagePricings.push(newItem);
      });
    }
    // default package pricing
    const bumiProjectPackagePricingID = pud.defaultBumiProjectPackagePricingID;
    const projectPackagePricingID = pud.defaultProjectPackagePricingID;
    if (pud.projectUnitPackagePricings) {
      if (pud.isBumi && bumiProjectPackagePricingID !== '') {
        const pricing = pud.projectUnitPackagePricings.find(
          d => d.projectPackagePricing.id === bumiProjectPackagePricingID,
        );
        if (pricing && pricing.totalPrice) {
          booking.spaValue = amountToFixed(pricing.totalPrice, projectUnit.spaTimes).toString();
          booking.unitPackagePricingID = pricing.id;
        }
      } else if (!pud.isBumi && projectPackagePricingID !== '') {
        const pricing = pud.projectUnitPackagePricings.find(
          d => d.projectPackagePricing.id === projectPackagePricingID,
        );
        if (pricing && pricing.totalPrice) {
          booking.spaValue = amountToFixed(pricing.totalPrice, projectUnit.spaTimes).toString();
          booking.unitPackagePricingID = pricing.id;
        }
      }
    }

    // Setup additional fee packages
    const unitPackageFees = pud.projectUnitPackageFees || [];
    const noneText = t('None', { ns: TRANSLATION_FILES.constants });
    const feePackages = [{
      value: '',
      description: '0',
      text: noneText,
      content: (
        <Header className="ddPricingTierItem">
          <div className="name">{noneText}</div>
        </Header>
      ),
    }];
    if (unitPackageFees) {
      unitPackageFees.forEach((d) => {
        const newItem = {
          value: d.id,
          description: d.totalPrice.toString(),
        };
        if (d.projectFeePackage && d.projectFeePackage.id) {
          let pppDescription = d.projectFeePackage.description;
          if (pppDescription.includes('\n')) {
            pppDescription = pppDescription.split('\n').map((pppd, idx) => <span key={idx}>{pppd}<br /></span>);
          }

          newItem.text = d.projectFeePackage.name;
          newItem.content = (
            <Header className="ddPricingTierItem">
              <div className="name">{d.projectFeePackage.name}</div>
              <div className="value"><LoanAmount precise={false} format="0,000,000.00" amount={d.totalPrice.toString()} prefix={<CurrencySymbol />} /></div>
              <Header.Subheader>{pppDescription}</Header.Subheader>
            </Header>
          );
        }
        if (newItem.content) {
          feePackages.push(newItem);
        }
      });
    }

    if (user && user.affiliate && user.affiliate.companyBranch && user.affiliate.companyBranch.reservationLimit !== 0 &&
      (projectUnit.data.companyBranchBookingReserveCount >= user.affiliate.companyBranch.reservationLimit)
    ) {
      modalReservationIsOpen = true;
    }
    // relink a correct lead opportunity
    booking.origin = '';
    booking.originID = '';
    if (booking.leadCustomerID) {
      if (leadCustomer && leadCustomer.opportunities && leadCustomer.opportunities.length > 0) {
        // get list of opportunities that are not linked to booking yet
        const opportunities = leadCustomer.opportunities.filter(o => o.project_id === projectID && (!o.booking_id || o.booking_id === ''));
        if (opportunities && opportunities.length > 0) {
          let opportunity;

          // find opportunity for current unit
          const unitOpp = opportunities.find(o => o.unit_id === projectUnitID);
          if (unitOpp) {
            opportunity = unitOpp;
          } else {
            // get first opp with empty unit
            opportunity = opportunities.find(o => !o.unit_id || o.unit_id === '');
          }
          if (opportunity) {
            booking.origin = 'lead';
            booking.originID = opportunity.id;
          }
        }
      }
    }

    const paymentOptions = [];
    if (projectUnit.data.project && projectUnit.data.project.sourceOfFinanceOptions && projectUnit.data.project.sourceOfFinanceOptions.length > 0) {
      projectUnit.data.project.sourceOfFinanceOptions.forEach((f) => {
        paymentOptions.push({ text: getFinanceSourceLabel(f, financeSources.data), value: f });
      });
    }
    await this.setComponentState({
      // pricingTiers,
      packagePricings,
      feePackages,
      projectUnitDetails: pud,
      booking,
      modalReservationIsOpen,
      allowCustomBookingStatus: projectUnit.data.project.allowCustomBookingStatus,
      allowStaffEditBookingSPAValue: projectUnit.data.project.allowStaffEditBookingSPAValue,
      allowAgentEditBookingSPAValue: projectUnit.data.project.allowAgentEditBookingSPAValue,
      allowAgentAutofillPurchaserDetails: projectUnit.data.project.allowAgentAutofillPurchaserDetails,
      isLaunchMode,
      paymentMethods: paymentOptions,
      projectAllowLinkBuyerApp,
      projectBranchOwnerID: projectUnit.data.project.maOwnerCompanyBranchID,
      showPurchaserExtraFields: projectUnit.data.project.showPurchaserExtraFields,
      // CPI-977 requirement 1: a Vietnamese reservation always needs a package; the project switch
      // stays the rule everywhere else (it failed UAT because no VN project had it on).
      isRequirePricingSelection: isVietnamCompany(this.props.auth) || projectUnit.data.project.requirePricingSelectDuringReserve,
      isDisableBaseSellingPriceSelection: projectUnit.data.project.disableBaseSellingPriceSelection,
      project: projectUnit.data.project,
    }, async () => {
      const pUnit = projectUnit.data;
      if (
        pUnit.projectUnitBookingSummary.reservedCount >= pUnit.project.bookingUnitLimit ||
        (pUnit.statusID === 'booked' || (pUnit.statusID === 'delist' && !this.checkBookableDelistedUnit(pUnit.project)))
      ) {
        const { store } = this.context;
        store.dispatch(replace('/bookings/'));
      }
      // cooldown check
      await this.fetchPreReservationCooldown(skipLoader);
      if (projectUnit.data.project.isLaunchMode) {
        await this.fetchPreReservation(false, skipLoader);
      }
      if (firstLoad && !this.state.showSwapUnit) {
        await Promise.all([
          this.getProjectCustomFields(this.state.projectID, false, true),
          this.getProjectFinanceSourceOpts(this.state.projectID),
        ]);
      }
      if (firstLoad || skipLoader) await this.setLoading('isFetching', false);
    });
  }
  checkBookableDelistedUnit = (project) => {
    const user = this.props.auth;
    if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
      if (user.isAdminBasic || user.isAdmin) return true;

      const uGroupIDs = [...user.groups.map(obj => obj.id)];
      const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
      return hasAnyRequiredRoleIDs(project.rduAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  }
  async getPackagePricingCalculation() {
    const { store } = this.context;
    const { t } = this.props;
    const { projectUnitDetails, booking } = this.state;
    await this.setLoading('isFetching', true);
    let res = null;
    let ppID = booking.unitPackagePricingID;
    if (ppID !== '') {
      if (ppID === projectUnitDetails.spaValue) {
        const basePriceID = Number(projectUnitDetails.spaValue);
        ppID = basePriceID.toFixed(0);
      }
      if (ppID !== projectUnitDetails.spaValue && ppID !== booking.unitPackagePricingID) {
        const basePriceID = Number(projectUnitDetails.spaValue);
        ppID = basePriceID.toFixed(0);
      }
    } else {
      const basePriceID = Number(projectUnitDetails.spaValue);
      ppID = basePriceID.toFixed(0);
    }
    const vnWaiver = isVietnamCompany(this.props.auth) && booking.waiveBankGuarantee
      ? '&waiveBankGuarantee=true'
      : '';
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.state.projectID}/units/${this.state.projectUnitID}/cal_package_pricing/${ppID}/?selling=${this.state.booking.spaValue}${vnWaiver}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        // CPI-977 D-C5: a refused preview must leave the panel saying so, not quote a stored total
        this.markVNPreviewFailed();
        if (isVietnamCompany(this.props.auth)) {
          await this.setLoading('isFetching', false);
        }
        store.dispatch(flashErrorMessage({ message }));
        return null;
      }
      await this.setLoading('isFetching', false);
      this.markVNPreviewFailed();
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    await this.setLoading('isFetching', false);
    const json = await res.json();
    if (json) {
      this.setState({ newPPI: json });
      this.applyVNLivePackageTotal(json);
    }
    return null;
  }
  async getFeePackageBreakdown() {
    const { store } = this.context;
    const { booking } = this.state;
    await this.setLoading('isFetching', true);
    let res = null;
    let ppID = booking.unitPackageFeeID;
    if (ppID === '') {
      ppID = 'none';
    }
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.state.projectID}/units/${this.state.projectUnitID}/cal_package_fee/${ppID}/?spa=${this.state.booking.spaValue}&nett=${this.state.booking.nettSellingPrice}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return null;
      }
      await this.setLoading('isFetching', false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return null;
    }
    await this.setLoading('isFetching', false);
    const json = await res.json();
    if (json) {
      this.setState({ newBFP: json });
    }
    return null;
  }
  async getProjectFinanceSourceOpts(projectID) {
    const { store } = this.context;
    let res = null;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${projectID}/finance_source_opts/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return null;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return null;
    }
    const json = await res.json();
    if (json) {
      await this.setComponentState({ financeSourceOpts: json });
    }
    return null;
  }
  async getSFAutofill(id) {
    const sfAutofill = await this.fetchData(
      `/bookings/sf/autofill/?id=${id}`,
      'isFetching',
      true,
      {},
      false,
    );
    if (sfAutofill && sfAutofill.data) {
      const { booking } = this.state;
      const sfa = sfAutofill.data;
      if (sfa.bumi) booking.bumi = sfa.bumi;
      if (sfa.email) booking.email = sfa.email;
      if (sfa.gender) booking.gender = sfa.gender;
      if (sfa.identity) booking.identity = sfa.identity;
      if (sfa.identityType) booking.identityTypeID = parseInt(sfa.identityType, 10);
      if (sfa.jobTitle) booking.jobTitle = sfa.jobTitle;
      if (sfa.maritalStatus) booking.maritalStatus = sfa.maritalStatus;
      if (sfa.mobile) booking.mobile = sfa.mobile;
      if (sfa.mobilePrefix) booking.mobilePrefix = sfa.mobilePrefix;
      if (sfa.monthlyIncome) booking.monthlyIncome = !isNaN(sfa.monthlyIncome) ? sfa.monthlyIncome.toString() : sfa.monthlyIncome;
      if (sfa.name) booking.name = sfa.name;
      if (sfa.nationality) booking.nationality = sfa.nationality;
      if (sfa.phone) booking.phone = sfa.phone;
      if (sfa.phonePrefix) booking.phonePrefix = sfa.phonePrefix;
      if (sfa.preferredName) booking.preferredName = sfa.preferredName;
      if (sfa.race) booking.race = sfa.race;
      if (sfa.title) booking.title = sfa.title;
      if (sfa.address1) booking.address1 = sfa.address1;
      if (sfa.address2) booking.address2 = sfa.address2;
      if (sfa.city) booking.address6 = sfa.city;
      if (sfa.postcode) booking.address5 = sfa.postcode;
      if (sfa.state) booking.address7 = sfa.state;
      if (sfa.country) booking.country = sfa.country;
      if (sfa.birthdate) booking.birthdate = sfa.birthdate;
      if (sfa.emergencyContactRelation) booking.emergencyContactRelation = sfa.emergencyContactRelation;
      if (sfa.emergencyContactName) booking.emergencyContactName = sfa.emergencyContactName;
      if (sfa.emergencyContactMobilePrefix) booking.emergencyContactMobilePrefix = sfa.emergencyContactMobilePrefix;
      if (sfa.emergencyContactMobile) booking.emergencyContactMobile = sfa.emergencyContactMobile;
      if (sfa.emergencyContactIdentity) booking.emergencyContactIdentity = sfa.emergencyContactIdentity;
      if (sfa.emergencyContactEmail) booking.emergencyContactEmail = sfa.emergencyContactEmail;
      if (sfa.occupation) {
        booking.jobTitle = sfa.occupation;
      } else if (sfa.jobTitle) {
        booking.jobTitle = sfa.jobTitle;
      }
      await this.setComponentState({ booking });
      const validations = await AppForm.validate(this.validation, booking);
      const newState = {
        errMessages: validations.filter(v => !v.isValid),
      };
      if (sfa.identity) newState.identity = sfa.identity;
      if (sfa.identityType) newState.identityType = parseInt(sfa.identityType, 10);
      await this.setComponentState(newState);
    }
  }
  async searchAutofillCustomer(searchValue, searchType, customerID = null, identityPresetID) {
    const { loaders, projectUnitDetails, projectID, projectUnitID } = this.state;
    const { t } = this.props;
    if (!this.hasAutofillAccess()) {
      return;
    }
    let existingCustomerData;
    let externalCustomerData;
    let leadCustomerData;

    let searchingBy = 'searchingID';
    if (searchType === AUTOFILL_MSISDN) searchingBy = 'searchingIDByMobile';

    const query = {
      search: searchValue,
      identityTypeID: this.getAutofillIdentityTypeID(searchType),
      projectBranchOwnerID: projectUnitDetails.maOwnerCompanyBranchID,
    };
    if (searchType === AUTOFILL_PRESET) query.presetID = identityPresetID;

    // search existing internal default
    existingCustomerData = await this.fetchData(`/customers/?${qs.stringify(query)}`, searchingBy);

    // search existing internal by customer id
    if (customerID) {
      existingCustomerData = await this.fetchData(`/customers/?customerID=${customerID}&projectBranchOwnerID=${projectUnitDetails.maOwnerCompanyBranchID}`, searchingBy);
    }

    // search existing prs
    if (isPRS) {
      existingCustomerData = await this.fetchData(
        `/search/prs/?search=${searchValue}&prsID=${this.state.prsID}&projectID=${projectID}&projectUnitID=${projectUnitID}`,
        searchingBy,
        true,
        {},
        false,
      );
    }

    // search external
    if (!isPRS && projectUnitDetails.autofillFromUrl && projectUnitDetails.externalAutofillUrl.trim() !== '') {
      const headers = {
        'x-mhub-registration-code': process.env.CRM_KEY,
      };
      externalCustomerData = await this.fetchData(`${projectUnitDetails.externalAutofillUrl}/customers/search/identity_type/${this.getAutofillIdentityTypeID(searchType)}/identity/${searchValue}/`, searchingBy, false, headers);
    }

    // search existing crm
    const crmEnabledSearchTypes = [AUTOFILL_NRIC, AUTOFILL_PASSPORT, AUTOFILL_MSISDN, AUTOFILL_PRESET];
    const invalidVNCCCD = isVietnamCompany(this.props.auth) &&
      searchType === AUTOFILL_NRIC && !this.isValidVNCCCD(searchValue);
    if (!isPRS && crmEnabledSearchTypes.includes(searchType) && this.state.isCRMEnabled && !invalidVNCCCD) {
      let crmSearchField = searchType;
      if (searchType === AUTOFILL_PRESET) {
        const preset = this.state.identityPresets.find(p => p.id === identityPresetID);
        if (preset && preset.label) {
          const mapping = CRM_SEARCH_FIELD_MAPPINGS.find(map => map.label === preset.label);
          crmSearchField = mapping ? mapping.searchField : searchType;
        }
      }
      const crmQuery = {
        search: searchValue,
        searchField: crmSearchField,
      };
      if (searchType === AUTOFILL_PRESET) {
        crmQuery.presetID = identityPresetID;
      }
      leadCustomerData = await this.fetchData(`/leads/customers/search/?${qs.stringify(crmQuery)}`, searchingBy);
    }

    if (!existingCustomerData && !externalCustomerData && !leadCustomerData) {
      await this.setComponentState({ showNoAutofill: true });
      return;
    }
    let { existingCustomer, externalCustomer, leadCustomer } = {};
    const autofillOptions = [];
    const replacedByField = searchType === AUTOFILL_MSISDN ? 'msisdn' : 'identity';

    // if existing customer exists
    const customerIsExisting = existingCustomerData && existingCustomerData.data && existingCustomerData.data.length > 0;
    if (customerIsExisting) {
      existingCustomer = Object.assign({}, existingCustomerData.data[0]);
      delete existingCustomer.customerDetail.createdAt;
      delete existingCustomer.customerDetail.updatedAt;
      if (isPRS) {
        const isValidPhonePrefix = INTL_CALL_CODES.find(
          d => d.value === existingCustomer.customerDetail.mobilePrefix,
        );
        if (!isValidPhonePrefix) {
          const message = <span>Mobile prefix is invalid! Please inform the customer to update it in <a href="http://www.pr1ma.my" target="_blank">PRS system (www.pr1ma.my).</a></span>;
          this.setState({ fetchDataErrorMessage: message, showNoAutofill: true });
          return;
        }
      }
      autofillOptions.push({
        key: 'existing',
        text: t('Previous entry'),
        onClick: (e) => {
          e.preventDefault();
          this.replaceWithAutofill('existing', replacedByField);
        },
      });
    }

    // if external customer exists
    const externalCustomerExists = externalCustomerData && externalCustomerData.data;
    if (externalCustomerExists) {
      externalCustomer = Object.assign({}, externalCustomerData.data);
      delete externalCustomer.id;
      delete externalCustomer.customerDetailID;
      delete externalCustomer.customerDetail.id;
      delete externalCustomer.customerDetail.customerID;
      delete externalCustomer.customerDetail.createdAt;
      delete externalCustomer.customerDetail.updatedAt;
      autofillOptions.push({
        key: 'external',
        text: t('Customer self registration'),
        onClick: (e) => {
          e.preventDefault();
          this.replaceWithAutofill('external', replacedByField);
        },
      });
    }

    if (leadCustomerData && leadCustomerData.data && leadCustomerData.data.length > 0) {
      leadCustomer = Object.assign({}, leadCustomerData.data[0]);
      autofillOptions.push({
        key: 'lead',
        text: 'CRM',
        onClick: (e) => {
          e.preventDefault();
          this.replaceWithAutofill('lead', replacedByField);
        },
      });
    }

    const showNoAutofill = autofillOptions.length < 1;
    loaders.searchingID = false;
    this.setState({
      existingCustomer,
      externalCustomer,
      leadCustomer,
      autofillOptions,
      loaders,
      showNoAutofill,
    }, () => {
      if (isPRS && customerIsExisting) this.replaceWithAutofill('existing', replacedByField);
    });
  }
  autofillCustomFields = async (leadCustomerData) => {
    const { booking, projectCustomFields, bookingCustomFields } = this.state;
    let leadData;
    // autofill lead custom fields
    if (leadCustomerData && leadCustomerData.emergency_contacts && leadCustomerData.emergency_contacts.length > 0) {
      leadData = leadCustomerData.emergency_contacts[0];
    }
    if (projectCustomFields) {
      projectCustomFields.filter(p => !p.isDefault).forEach((data) => {
        let value = data.defaultValue;

        // get current value
        const existsID = bookingCustomFields.findIndex(d => d.name === data.name);
        if (existsID > -1) {
          value = bookingCustomFields[existsID].value;
        }

        // autofill lead custom fields
        if (leadData) {
          switch (data.name) {
            case 'name_emergency_contact_person_':
              value = leadData.name;
              break;
            case 'nric_no_emergency_contact_person_':
              value = leadData.nric || leadData.identity_no;
              break;
            case 'telephone_emergency_contact_person_':
              value = leadData.mobile_prefix + leadData.mobile;
              break;
            case 'email_emergency_contact_person_':
              value = leadData.email;
              break;
            case 'relationship_emergency_contact_person_':
              value = leadData.relation;
              break;
            default:
              if (leadData[data.name]) {
                value = leadData[data.name];
              }
              break;
          }
        }
        if (value !== '') {
          if (data.type === 'dropdown' && data.projectBookingCustomFieldOptions) {
            const optionItem = data.projectBookingCustomFieldOptions.find(
              d => d.value === value,
            );
            if (optionItem) {
              const customField = {
                name: data.name,
                value,
                projectBookingCustomFieldID: data.id,
                projectBookingCustomFieldOptionID: optionItem.id,
              };
              if (existsID === -1) {
                bookingCustomFields.push(customField);
              } else {
                bookingCustomFields[existsID] = customField;
              }
              booking[data.name] = value;
            }
          }
          if (data.type === 'dropdown_multi' && data.projectBookingCustomFieldOptions) {
            value = data.defaultValue.split(',');
            const optionItems = [];
            data.projectBookingCustomFieldOptions.forEach((o) => {
              value.forEach((v) => {
                if (v === o.value) optionItems.push(o.id);
              });
            });
            if (optionItems) {
              const customField = {
                name: data.name,
                value: value.join(),
                projectBookingCustomFieldID: data.id,
                projectBookingCustomFieldOptionIDs: optionItems,
              };
              if (existsID === -1) {
                bookingCustomFields.push(customField);
              } else {
                bookingCustomFields[existsID] = customField;
              }
              booking[data.name] = value.join();
            }
          }
          if (data.type === 'input') {
            const customField = {
              name: data.name,
              value,
              projectBookingCustomFieldID: data.id,
            };
            if (existsID === -1) {
              bookingCustomFields.push(customField);
            } else {
              bookingCustomFields[existsID] = customField;
            }
            booking[data.name] = value;
          }
        } else {
          if (existsID > -1) {
            bookingCustomFields.splice(existsID, 1);
          }
          booking[data.name] = '';
        }
      });
    }
    await this.setComponentState({ booking, bookingCustomFields });
  }
  // autofill booking from from url query (book_xxx) data
  autofillFromBookQuery = async (bookQuery = []) => {
    if (bookQuery.length < 1) return;
    const queryFill = bookQueryToBooking(bookQuery);
    const { identity, identityTypeID, identityPresetID } = queryFill.bookingCustomer;
    // search autofill existing internal customer if customerID provided
    if (queryFill.customerID) {
      await this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(identityTypeID), queryFill.customerID);
    }
    // autofill booking form state from query
    if (queryFill.hasBooking || queryFill.hasBookingCustomer) {
      const { booking } = this.state;
      const qbc = queryFill.bookingCustomer;
      const qb = queryFill.booking;
      if (identity) booking.identity = identity;
      if (identityTypeID) booking.identityTypeID = identityTypeID;
      if (qbc.name) booking.name = qbc.name;
      if (qbc.email) booking.email = qbc.email;
      if (qbc.mobile) booking.mobile = qbc.mobile;
      if (qbc.mobilePrefix) booking.mobilePrefix = qbc.mobilePrefix;
      if (qb.externalID) booking.externalID = qb.externalID;
      if (qb.externalLeadID) booking.externalLeadID = qb.externalLeadID;
      if (qb.externalCustomerID) booking.externalCustomerID = qb.externalCustomerID;
      await this.setComponentState({ booking });
      const validations = await AppForm.validate(this.validation, booking);
      await this.setComponentState(prevState => ({
        errMessages: validations.filter(v => !v.isValid),
        // identity: identity || prevState.identity,
        identityType: identityTypeID || prevState.identityType,
      }));
      // salesforce autofill
      if (this.props.appConfig.data.externalServiceAutofillIsEnabled && qb.externalID !== '') {
        await this.getSFAutofill(qb.externalID);
      }
    }
    // autofill from exsisting data, mhub crm lead or external api.
    if (identity !== '' && identityTypeID > 0 && !queryFill.customerID) {
      await this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(identityTypeID), '', identityPresetID);
    }
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasAccessIsExternalAgent() {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && auth.companyBranch.isExternal) {
      return true;
    }
    return false;
  }
  hasUnitSwapAccess(check = false) {
    const { auth } = this.props;
    if (auth.isHeadquarters || auth.isSuperAdmin) {
      return true;
    }
    if (auth.isBranchLeader &&
      (this.state.projectBranchOwnerID === auth.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasTierPricingAccess() {
    const { auth } = this.props;
    if (auth.isSuperAdmin ||
      auth.isHeadquarters
    ) {
      return true;
    }
    if (auth &&
      auth.companyBranch &&
      !auth.companyBranch.isExternal &&
      this.state.allowStaffEditBookingSPAValue
    ) {
      return true;
    }
    if (auth &&
      auth.companyBranch &&
      auth.companyBranch.isExternal &&
      this.state.allowAgentEditBookingSPAValue
    ) {
      return true;
    }
    return false;
  }
  hasPackagePricingAccess() {
    const { auth } = this.props;
    if (auth.isSuperAdmin ||
      auth.isHeadquarters
    ) {
      return true;
    }
    if (auth &&
      auth.companyBranch &&
      !auth.companyBranch.isExternal &&
      this.state.allowStaffEditBookingSPAValue
    ) {
      return true;
    }
    if (auth &&
      auth.companyBranch &&
      auth.companyBranch.isExternal &&
      this.state.allowAgentEditBookingSPAValue
    ) {
      return true;
    }
    return false;
  }
  hasAutofillAccess() {
    const { auth } = this.props;
    // CPI-974 (D6/A7): no customer-search autofill in Vietnam; both trigger sites short-circuit.
    if (isVietnamCompany(auth)) {
      return false;
    }
    if (auth &&
      auth.companyBranch &&
      auth.companyBranch.isExternal
    ) {
      return this.state.allowAgentAutofillPurchaserDetails;
    }
    return true;
  }
  // CPI-974 (S1): only the SA / HQ family may change the Source of finance in Vietnam.
  hasSourceOfFinanceEditAccess() {
    return hasVietnamElevatedAccess(this.props.auth);
  }
  hasSPAValueAccess() {
    const auth = this.props.auth;
    if (this.props.auth.isSuperAdmin ||
      this.props.auth.isHeadquarters
    ) {
      return true;
    }
    if (auth &&
      auth.companyBranch &&
      !auth.companyBranch.isExternal &&
      this.state.allowStaffEditBookingSPAValue
    ) {
      return true;
    }
    return false;
  }
  isLoading(...names) {
    return names.some(name => this.state.loaders[name]);
  }
  async fetchData(fetchPath, loaderName, includeCredentials = true, extraHeaders = {}, showError = true) {
    const { store } = this.context;
    const { t } = this.props;
    if (loaderName !== '') await this.setLoading(loaderName, true);
    let res = null;
    let extraRequest = {};
    if (includeCredentials) {
      extraRequest = {
        credentials: 'include',
      };
    }
    try {
      res = await store.dispatch(fetchM(fetchPath, {
        ...extraRequest,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...extraHeaders,
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        if (showError) store.dispatch(flashErrorMessage({ message }));
        if (!showError) this.setComponentState({ fetchDataErrorMessage: message });
        if (loaderName !== '') await this.setLoading(loaderName, false);
        return null;
      }
      if (loaderName !== '') await this.setLoading(loaderName, false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    if (!res.ok) {
      if (loaderName !== '') await this.setLoading(loaderName, false);
      Bugsnag.notifyException(new Error(`Server error during booking: ${res.status}`));
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    if (loaderName !== '') await this.setLoading(loaderName, false);
    const data = {};
    const json = await res.json();
    if (json) {
      data.data = json;
    }
    return data;
  }
  formatAutofill = (booking) => {
    const purchaserInputFields = [
      'name',
      'preferredName',
      'jobTitle',
      'emergencyContactName',
      'emergencyContactRelation',
      'emergencyContactIdentity',
      'identity',
      'taxIdentificationNo',
    ];
    const { addressSettings } = this.props;
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    enabledAddressSettings.forEach((as) => {
      const key = _.camelCase(as.columnName);
      const label = as.label.toLowerCase();
      if (label !== 'postcode' && label !== 'state') {
        purchaserInputFields.push(key);
      }
    });
    const formattedBooking = { ...booking };
    purchaserInputFields.forEach((pf) => {
      if (formattedBooking[pf]) {
        formattedBooking[pf] = this.toUppercaseFormat(formattedBooking[pf]);
      }
    });
    return formattedBooking;
  }
  replaceWithAutofill = async (type, field = 'identity') => {
    const { externalCustomer, existingCustomer, leadCustomer, projectUnitDetails, projectID, projectUnitID, identityPresets } = this.state;
    const { auth } = this.props;
    const isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    let booking = this.state.booking;
    if (type === 'existing') {
      booking = Object.assign(this.state.booking, existingCustomer.customerDetail);
      booking.race = this.getRace(existingCustomer.customerDetail.race);
      booking.raceOther = booking.race === 'Others' ? existingCustomer.customerDetail.race : '';
      booking.customerDetailID = existingCustomer.customerDetailID;
      booking.customerID = existingCustomer.id;
      booking.identity = existingCustomer.identity.trim();
      booking.identityTypeID = existingCustomer.identityTypeID;
      booking.identityPresetID = existingCustomer.identityPresetID;
      booking.identityPresetLabel = existingCustomer.identityPresetLabel;
      booking.identityPresetRegex = existingCustomer.identityPresetRegex;
      // fix taxIdentification overwritten with empty value when autofilling form with existing data
      if (existingCustomer.taxIdentificationNo) {
        booking.taxIdentificationNo = existingCustomer.taxIdentificationNo;
      }
      booking.birthdate = this.getBirthDate(existingCustomer.customerDetail.birthdate, this.state.identityType === 1 ? this.state.identity : '');
      booking.customerSpecification = existingCustomer.specifications;
      // force reset package pricing
      if (booking.unitPackagePricingID !== '' && booking.bumi !== 'Bumiputera' && projectUnitDetails.projectUnitPackagePricings) {
        const price = projectUnitDetails.projectUnitPackagePricings.find(d => d.id === booking.unitPackagePricingID);
        if (price && price.projectPackagePricing && price.projectPackagePricing.bumiPurchaserOnly) {
          booking.spaValue = amountToFixed(parseFloat(projectUnitDetails.spaValue), projectUnitDetails.spaTimes);
          booking.unitPackagePricingID = '';
        }
      }
      booking.maritalStatus = this.getMaritalStatus(existingCustomer.customerDetail.maritalStatus);

      // clear lead data if replaced with internal
      if (booking.leadCustomerID !== '') {
        booking.leadCustomerID = '';
      }
      if (booking.leadICFrontURL !== '') {
        booking.leadICFrontURL = '';
      }
      if (booking.leadICBackURL !== '') {
        booking.leadICBackURL = '';
      }
      if (booking.origin === 'lead') {
        booking.origin = '';
        booking.originID = '';
      }
    }
    if (type === 'external') {
      const eccd = Object.assign({}, externalCustomer.customerDetail);
      booking.address1 = eccd.address1 ? eccd.address1 : '';
      booking.address2 = eccd.address2 ? eccd.address2 : '';
      booking.address5 = eccd.postcode ? eccd.postcode : '';
      booking.address6 = eccd.city ? eccd.city : '';
      booking.address7 = eccd.state ? eccd.state : '';
      booking.country = eccd.country ? eccd.country : '';
      booking.email = eccd.email ? eccd.email : '';
      booking.mobile = eccd.mobile ? eccd.mobile : '';
      booking.mobilePrefix = eccd.mobilePrefix ? eccd.mobilePrefix : '';
      booking.name = eccd.name ? eccd.name : '';
      booking.phonePrefix = eccd.phonePrefix ? eccd.phonePrefix : '';
      booking.preferredName = eccd.preferredName ? eccd.preferredName : '';
      booking.title = eccd.title ? eccd.title : '';
      booking.identity = externalCustomer.identity.trim();
      booking.identityTypeID = externalCustomer.identityTypeID;
      booking.taxIdentificationNo = existingCustomer.taxIdentificationNo;
      // clear lead data if replaced with external
      if (booking.leadCustomerID !== '') {
        booking.leadCustomerID = '';
      }
      if (booking.leadICFrontURL !== '') {
        booking.leadICFrontURL = '';
      }
      if (booking.leadICBackURL !== '') {
        booking.leadICBackURL = '';
      }
      if (booking.origin === 'lead') {
        booking.origin = '';
        booking.originID = '';
      }
    }
    if (type === 'lead') {
      const customer = leadCustomer.customer;
      booking = Object.assign(this.state.booking, customer.customerDetail);
      booking.leadCustomerID = leadCustomer.id;
      booking.race = this.getRace(customer.customerDetail.race);
      booking.raceOther = booking.race === 'Others' ? customer.customerDetail.race : '';
      booking.identity = customer.identity.trim();
      booking.identityTypeID = customer.identityTypeID;
      booking.identityPresetID = customer.identityPresetID;
      booking.identityPresetLabel = customer.identityPresetLabel;
      booking.identityPresetRegex = customer.identityPresetRegex;
      if (isMalaysia) {
        booking.taxIdentificationNo = leadCustomer.contacts[0].tin || '';
      } else if (isIndonesia) {
        booking.taxIdentificationNo = leadCustomer.contacts[0].npwp || '';
      }
      booking.birthdate = this.getBirthDate(customer.customerDetail.birthdate, this.state.identityType === 1 ? this.state.identity : '');
      booking.customerSpecification = customer.specifications;
      booking.jobTitle = leadCustomer.details && leadCustomer.details.occupation ? leadCustomer.details.occupation : '';
      booking.address1 = leadCustomer.details && leadCustomer.details.address_1 ? leadCustomer.details.address_1 : '';
      booking.address2 = leadCustomer.details && leadCustomer.details.address_2 ? leadCustomer.details.address_2 : '';
      if (customer.icFrontDocument && customer.icFrontDocument.key) {
        booking.leadICFrontURL = customer.icFrontDocument.key;
      }
      if (customer.icBackDocument && customer.icBackDocument.key) {
        booking.leadICBackURL = customer.icBackDocument.key;
      }
      booking.maritalStatus = this.getMaritalStatus(customer.customerDetail.maritalStatus);

      // relink a correct lead opportunity
      booking.origin = '';
      booking.originID = '';
      if (leadCustomer && leadCustomer.opportunities && leadCustomer.opportunities.length > 0) {
        // get list of opportunities that are not linked to booking yet
        const opportunities = leadCustomer.opportunities.filter(o => o.project_id === projectID && (!o.booking_id || o.booking_id === ''));
        if (opportunities && opportunities.length > 0) {
          let opportunity;

          // find opportunity for current unit
          const unitOpp = opportunities.find(o => o.unit_id === projectUnitID);
          if (unitOpp) {
            opportunity = unitOpp;
          } else {
            // get first opp with empty unit
            opportunity = opportunities.find(o => !o.unit_id || o.unit_id === '');
          }
          if (opportunity) {
            booking.origin = 'lead';
            booking.originID = opportunity.id;
          }
        }
      }
    }
    await this.setComponentState({ booking: this.formatAutofill(booking) });
    if (type === 'lead') {
      await this.autofillCustomFields(leadCustomer.details);
    }
    const isMsisdnField = field === 'msisdn';
    if (isMsisdnField && booking.identityTypeID === 6) {
      if (isIndonesia && leadCustomer.details.ktp) {
        booking.identityPresetLabel = 'Kartu Tanda Penduduk';
      }
      const matched = identityPresets.find(i => i.label === booking.identityPresetLabel);
      if (matched) {
        booking.identityType = matched.id;
        booking.identityPresetID = matched.id;
        booking.identityPresetLabel = matched.label;
        booking.identityPresetRegex = matched.regex;
      }
    }
    const validations = await AppForm.validate(this.validation, booking);
    await this.setComponentState(prevState => ({
      errMessages: validations.filter(v => !v.isValid),
      identityLock: field === 'identity',
      mobileLock: isMsisdnField,
      identity: !prevState.identity || isMsisdnField ? booking.identity : prevState.identity,
      identityType: !prevState.identityType || isMsisdnField ? booking.identityType : prevState.identityType,
      identityPresetID: !prevState.identityPresetID || isMsisdnField ? booking.identityPresetID : prevState.identityPresetID,
      identityPresetLabel: !prevState.identityPresetLabel || isMsisdnField ? booking.identityPresetLabel : prevState.identityPresetLabel,
      identityPresetRegex: !prevState.identityPresetRegex || isMsisdnField ? booking.identityPresetRegex : prevState.identityPresetRegex,
      taxIdentificationNo: !prevState.taxIdentificationNo || isMsisdnField ? booking.taxIdentificationNo : prevState.taxIdentificationNo,
    }));
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleResetCheck(callback) {
    this.setState({ hasChanges: false }, () => {
      if (this.props.onChange) {
        this.props.onChange(false, callback);
      }
    });
  }
  getMinimumPurchaserAgeMessage = () => this.props.t('Booking cannot be created. Purchaser must be at least 18 years old.');
  isUnderagePurchaser = (birthdate) => {
    if (!birthdate || birthdate === '') return false;

    const mBirthdate = moment(birthdate, 'YYYY-MM-DD', true).tz(config.get('tzName'), true);
    if (!mBirthdate.isValid()) return false;

    const age = moment.tz(config.get('tzName')).diff(mBirthdate, 'years');
    return age < 18;
  }
  isUnderageNRICPurchaser = (identityTypeID, identity) => {
    if (identityTypeID !== IDENTITY_TYPE_NRIC) return false;

    const dfIC = dateFromIC((identity || '').substring(0, 6));
    if (!dfIC) return false;

    const mBirthdate = moment.tz(dfIC, config.get('tzName'));
    if (!mBirthdate.isValid()) return false;

    return moment.tz(config.get('tzName')).diff(mBirthdate, 'years') < 18;
  }
  handleIdentityChange = (e) => {
    const { booking, loaders, identityType, identityPresetID } = this.state;
    const autofillEnabled = this.hasAutofillAccess();
    const identity = this.toUppercaseFormat(e.target.value);
    // CPI-974 (PO comment, 6 Sep): identity type 1 is the Malaysian NRIC here but the
    // Vietnamese CCCD there, and a CCCD is also 12 digits - so the NRIC birthdate parser
    // and the autofill search it shares a trigger with would overwrite the birthdate and
    // the purchaser that came from the CRM. Neither runs for a Vietnamese company.
    const isVietnam = isVietnamCompany(this.props.auth);
    if (!isVietnam && identityType === 1 && identity.length === 12) {
      const dfIC = dateFromIC(identity.substring(0, 6));
      if (dfIC) {
        const mBirthdate = moment.tz(dfIC, config.get('tzName'));
        if (mBirthdate.isValid()) {
          booking.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if (isNumeric(identity) || identity === '') {
      if (identity.length !== 12) {
        booking.customerDetailID = null;
        booking.customerID = null;
      } else if (!isVietnam && this.state.identityType === 1 && identity.length === 12) {
        if (autofillEnabled && (!isPRS || (isPRS && this.state.prsID && this.state.prsID.length === 13))) {
          loaders.searchingID = true;
        }
      }
    }
    this.setState({
      identity,
      autofillOptions: [],
      booking,
      loaders,
      showNoAutofill: false,
    }, () => {
      if (!isVietnam && this.state.identityType === 1 && identity.length === 12 && loaders.searchingID) {
        if (this.identityInputRef.current) {
          this.identityInputRef.current.blur();
        }
        this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType));
      }
      // Vietnam: the agent is swapping the agent's own details out for the real buyer's. Only once
      // an approved Booking ID has filled the form, and only for an identity that differs from the
      // one the opportunity supplied, so simply reviewing the agent's own CCCD searches nothing.
      if (isVietnam && this.state.srOpportunity) {
        clearTimeout(this.vnCRMTimer);
        // Any change to the identity invalidates the answer already on screen, and it must go
        // before the debounce rather than when the next answer lands. Otherwise the previous
        // person's "Use this customer" button stays pressable for 800ms against a CCCD that is no
        // longer theirs - and typing back to the identity the opportunity supplied takes the
        // branch below, which schedules nothing, so the stale notice would never clear at all.
        const willSearch = Boolean(identity) && identity !== this.state.srOriginalIdentity &&
          (identityType !== 1 || this.isValidVNCCCD(identity));
        if (this.state.vnCRMLookup || this.state.vnCRMCustomer || willSearch) {
          // 'searching' is set when the wait STARTS, not when the request goes out, so a pasted
          // CCCD shows the spinner at once instead of sitting still for the debounce and looking
          // like nothing happened.
          this.setState({ vnCRMLookup: willSearch ? 'searching' : null, vnCRMCustomer: null });
        }
        if (willSearch) {
          this.vnCRMTimer = setTimeout(() => {
            this.searchVNCRMPurchaser(identity, identityType);
          }, 800);
        }
      }
      // CPI-974 (A7): gated on the country, not hasAutofillAccess() - MY agency branches keep this.
      if (!isVietnam &&
        (((this.state.identityType !== 1 && this.state.identityType !== 4) && identity.length > 1) || (this.state.identityType === 4 && identity.length >= 8))) {
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (this.state.identityLock &&
            (this.state.autofillOptions && this.state.autofillOptions.length > 0)
          ) {
            this.setState({ identity: booking.identity });
          } else {
            this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType), '', identityPresetID);
          }
        }, 1000);
      }
      this.handleCheckChanges();
    });
  }
  handleIDTypeChange = (e, { value }) => {
    const { auth } = this.props;
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const { booking, identity, identityPresets } = this.state;
    if (isVietnamCompany(auth)) {
      clearTimeout(this.vnCRMTimer);
    }
    // CPI-977: keep booking.identityTypeID in step with the dropdown. The CRM Booking ID
    // lookup pre-fills it (e.g. 4 for an Enterprise contact) and nothing else rewrote it
    // until submit, so render-time checks against it went stale after a type change.
    booking.identityTypeID = !isNumeric(value) ? 6 : value;
    if (value === IDENTITY_TYPE_BRN) {
      booking.title = 'Not Applicable';
      booking.nationality = 'Not Applicable';
      booking.gender = 'Not Applicable';
      booking.race = 'Not Applicable';
      booking.bumi = 'Not Applicable';
      booking.maritalStatus = 'Not Applicable';
      booking.birthdate = '';
    }
    if (identity.length === 0) {
      booking.customerDetailID = null;
      booking.customerID = null;
    }
    let newPresetID = '';
    let newPresetLabel = '';
    let newPresetRegex = '';
    if (value === 6 || !isNumeric(value)) {
      if (identityPresets && identityPresets.length > 0) {
        const idx = identityPresets.findIndex(i => i.id === value);
        if (idx !== -1) {
          newPresetID = identityPresets[idx].id;
          newPresetLabel = identityPresets[idx].label;
          newPresetRegex = identityPresets[idx].regex;
        }
      }
    }
    if (isMalaysia) {
      booking.isForeignCompany = false;
      booking.taxIdentificationNo = getAutoFillTin(value, this.state.isForeignCompany);
    }
    this.setState({
      isForeignCompany: booking.isForeignCompany,
      taxIdentificationNo: booking.taxIdentificationNo,
      booking,
      identityType: value,
      identityPresetID: newPresetID,
      identityPresetLabel: newPresetLabel,
      identityPresetRegex: newPresetRegex,
      autofillOptions: [],
      showNoAutofill: false,
      tinError: false,
      tinFound: false,
      tinMessage: null,
      ...(isVietnamCompany(auth) ? { vnCRMLookup: null, vnCRMCustomer: null } : {}),
    }, () => {
      if (this.validation.identity && this.validation.identity.current && identity !== '') {
        this.validation.identity.current.validate(identity);
      }
      if (this.validation.preferredName && this.validation.preferredName.current && booking.preferredName !== '') {
        this.validation.preferredName.current.validate(booking.preferredName);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (this.validation.name && this.validation.name.current && booking.name !== '') {
        this.validation.name.current.validate(booking.name);
      }
      if (booking.taxIdentificationNo !== '') {
        this.handleTinInput({ target: { value: booking.taxIdentificationNo } });
      }
      if (isVietnamCompany(this.props.auth)) {
        this.handleCheckChanges();
        return;
      }
      if (value === 1 && identity.length === 12) {
        if (!this.isLoading('searchingID')) {
          this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(value));
        }
      } else if (value !== 1 && identity.length > 0) {
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (this.state.identityLock &&
            (this.state.autofillOptions && this.state.autofillOptions.length > 0)
          ) {
            this.setState({ identity: booking.identity });
          } else {
            this.searchAutofillCustomer(identity, this.getAutofillIdentityTypeName(this.state.identityType), '', this.state.identityPresetID);
          }
        }, 1000);
      }
      this.handleCheckChanges();
    });
  }
  handlePRSIDChange = (e) => {
    const { booking } = this.state;
    const value = e.target.value;
    booking.prsID = value;
    if (value.length > 13) return;
    this.setState({ prsID: value, booking }, () => {
      this.handleCheckChanges();
      if (value.length === 13 && this.state.identity.length === 12) {
        this.searchAutofillCustomer(this.state.identity, AUTOFILL_PRS);
      }
    });
  }
  handleSelectChange = (event, data) => {
    if (isPRS && !(data.name === 'firstTimeBuyer' || data.name === 'paymentMethodID' || data.name === 'unitPackagePricingID')) return;
    const { booking, packagePricings, projectUnitDetails, isCRMEnabled, isPreviewing } = this.state;
    // booking package pricing
    if (data.name === 'unitPackagePricingID') {
      const price = packagePricings.find(d => d.value === data.value);
      if (price) {
        booking.spaValue = amountToFixed(parseFloat(price.description), projectUnitDetails.spaTimes);
        this.validation.spaValue.current.validate(booking.spaValue);
      }
      booking.nettSellingPrice = projectUnitDetails.spaValue;
      if (isPreviewing) {
        this.setState({ isPreviewing: false });
      }
    }
    booking[data.name] = data.value;
    // booking package pricing bumi customer
    if (data.name === 'bumi' && data.value !== 'Bumiputera' && projectUnitDetails.projectUnitPackagePricings) {
      const price = projectUnitDetails.projectUnitPackagePricings.find(d => d.id === booking.unitPackagePricingID);
      if (price && price.projectPackagePricing && price.projectPackagePricing.bumiPurchaserOnly) {
        booking.spaValue = amountToFixed(parseFloat(projectUnitDetails.spaValue), projectUnitDetails.spaTimes);
        booking.unitPackagePricingID = '';
      }
    }
    this.setState({ booking }, () => {
      if (isVietnamCompany(this.props.auth)) {
        // The inline booking summary follows the package and the fee package live.
        if (data.name === 'unitPackagePricingID') {
          this.getPackagePricingCalculation();
          if (booking.unitPackageFeeID) {
            this.getFeePackageBreakdown();
          }
        }
        if (data.name === 'unitPackageFeeID') {
          this.getFeePackageBreakdown();
        }
      }
      if (data.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(booking.mobile);
        if (isCRMEnabled && booking.mobile !== '') {
          const msisdn = data.value + booking.mobile;
          clearTimeout(this.setTimer);
          this.setTimer = setTimeout(() => {
            if (!this.state.mobileLock && (!this.state.autofillOptions || this.state.autofillOptions.length === 0)) {
              this.searchAutofillCustomer(msisdn, AUTOFILL_MSISDN);
            }
          }, 1000);
        }
      }
      if (data.name === 'phonePrefix') {
        this.validation.phone.current.validate(booking.phone);
      }
      this.handleCheckChanges();
    });
  }
  handleInputChange = (event) => {
    if (isPRS && event.target.name !== 'spaValue') return;
    const { booking, isCRMEnabled, isPreviewing } = this.state;
    if (event.target.name === 'spaValue') {
      booking.unitPackagePricingID = '';
      booking.nettSellingPrice = event.target.value; // TODO Remove (deprecated tier pricing)
      booking.tierPricingName = 'Custom';
      booking.tierPricingDescription = `Custom Value: ${event.target.value}`;
      if (isPreviewing) {
        this.setState({ isPreviewing: false });
      }
    }
    booking[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : this.toUppercaseFormat(event.target.value);
    const hasMobileChanges = event && event.target && event.target.name === 'mobile';
    this.setState({ booking }, () => {
      if (isCRMEnabled && hasMobileChanges && booking.mobilePrefix !== '' && booking.mobile !== '') {
        const msisdn = booking.mobilePrefix + booking.mobile;
        clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          if (!this.state.mobileLock && (!this.state.autofillOptions || this.state.autofillOptions.length === 0)) {
            this.searchAutofillCustomer(msisdn, AUTOFILL_MSISDN);
          }
        }, 1000);
      }
      this.handleCheckChanges();
    });
  }
  handleLinkBuyerAppCheck = () => {
    const { booking } = this.state;
    let { identityType } = this.state;
    booking.linkBuyerApp = !booking.linkBuyerApp;
    if (booking.linkBuyerApp) {
      identityType = 1;
      booking.paymentMethodID = 'referred_banker';
    }
    this.setState({ booking, identityType }, () => {
      this.handleCheckChanges();
    });
  }
  handleCustomSelectChange = (e, data, fieldID, customFieldOptions) => {
    const { booking, bookingCustomFields } = this.state;
    const customField = {
      name: data.name,
      value: data.value,
      projectBookingCustomFieldID: fieldID,
    };
    booking[data.name] = data.value;
    if (Array.isArray(data.value)) { // dropdown_multi
      const values = [];
      customFieldOptions.forEach((cfo) => {
        data.value.forEach((v) => {
          if (v === cfo.value) values.push(cfo.id);
        });
      });
      customField.projectBookingCustomFieldOptionIDs = values;
      customField.projectBookingCustomFieldOptionID = '';
      customField.value = data.value.join();
      booking[data.name] = data.value.join();
    } else {
      // Handle cleared/empty value
      if (data.value === '' || data.value === null || data.value === undefined) {
        customField.projectBookingCustomFieldOptionID = '';
        customField.value = '';
        booking[data.name] = '';
      } else {
        const selectedOption = customFieldOptions.find(d => d.value === data.value);
        customField.projectBookingCustomFieldOptionID = selectedOption ? selectedOption.id : '';
      }
    }
    const existsID = bookingCustomFields.findIndex(d => d.name === data.name);
    if (existsID === -1) {
      bookingCustomFields.push(customField);
    } else {
      bookingCustomFields[existsID] = customField;
    }
    this.setState({ booking, bookingCustomFields }, () => {
      this.handleCheckChanges();
    });
  }
  handleCustomInputChange = (event, fieldID, isDefaultField) => {
    const { booking, bookingCustomFields } = this.state;
    const customField = {
      name: event.target.name,
      value: event.target.value,
      projectBookingCustomFieldID: fieldID,
    };
    const existsID = bookingCustomFields.findIndex(d => d.name === event.target.name);
    if (existsID === -1) {
      bookingCustomFields.push(customField);
    } else {
      bookingCustomFields[existsID] = customField;
    }
    booking[event.target.name] = event.target.value;
    if (isDefaultField && !event.target.name.toLowerCase().includes('email')) {
      booking[event.target.name] = this.toUppercaseFormat(event.target.value);
    }
    this.setState({ booking, bookingCustomFields }, () => {
      this.handleCheckChanges();
    });
  }
  handleTinInput = (e) => {
    const { booking, tinMessage, identityType } = this.state;
    const { auth } = this.props;
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      booking.taxIdentificationNo = e.target.value;
      this.setState({
        booking,
        taxIdentificationNo: e.target.value,
        tinError: null,
        tinMessage: null,
      }, () => {
        this.handleCheckChanges();
      });
      return;
    }

    const tinInput = this.toUppercaseFormat(e.target.value);
    const tinFound = e.target.tinFound;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      booking.taxIdentificationNo = '';
      this.setState({ taxIdentificationNo: '', booking, tinFound, tinError: false });
      return;
    }
    if (isAlphanumeric) {
      booking.taxIdentificationNo = tinInput;
      this.setState({ taxIdentificationNo: tinInput, booking, tinFound, tinError: tinFound === false, tinMessage: tinFound ? null : tinMessage }, () => {
        this.handleCheckChanges();
      });
      if (tinFound) {
        return;
      }

      const matched = REGEX_TIN_VALID.test(tinInput);
      const genericTin = getGenericTinByIdTypeAndTinNo(identityType, tinInput, this.state.isForeignCompany);
      this.setLoading('validatingTIN', true).then(() => {
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }

        this.debounceTimeout = setTimeout(() => {
          if (matched) {
            if (tinInput === GOVERNMENT_GENERIC_TIN) {
              const isForeign = !isForeignIdType(this.state.identityType, this.state.isForeignCompany);
              this.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading('validatingTIN', false);
              });
            } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
              this.setState({
                tinError: !isGenericTinFound(genericTin),
                tinFound: isGenericTinFound(genericTin),
                tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading('validatingTIN', false);
              });
            } else {
              this.validateTIN(tinInput).finally(() => {
                this.setLoading('validatingTIN', false);
              });
            }
          } else {
            this.setState({ tinError: true }, () => {
              this.setLoading('validatingTIN', false);
            });
          }
        }, 3000);
      });
    }
  }

  async validateTIN(tinInput) {
    const { identityType, identity } = this.state;
    if (!tinInput || !identityType || !identity) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === identityType).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: identity,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        this.setState({
          tinError: false,
          tinFound: true,
          tinMessage: null,
        });
      } else {
        const errorMessage = await res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
      }
    }
  }

  hasResetIdentityIcon = () => {
    if (!this.state.opportunityID && !this.isLoading('searchingID') &&
    this.state.identity !== '' &&
    this.state.identityLock) {
      return true;
    }
    return false;
  }
  hasResetMobileIcon = (mobile) => {
    if (!this.state.opportunityID && !this.isLoading('searchingIDByMobile') &&
      mobile !== '' &&
      this.state.mobileLock) {
      return true;
    }
    return false;
  }
  handleResetAutofill = () => {
    const { defaultCountryPhoneCode, defaultCountryAddressCode } = this.state;
    const booking = Object.assign(this.state.booking, {
      address1: '',
      address2: '',
      address3: '',
      address4: '',
      address5: '',
      address6: '',
      address7: '',
      address8: '',
      address9: '',
      address10: '',
      country: defaultCountryAddressCode,
      customerDetailID: null,
      customerID: null,
      email: '',
      identity: '',
      identityTypeID: null,
      identityPresetID: '',
      identityPresetLabel: '',
      identityPresetRegex: '',
      prsID: '',
      mobile: '',
      mobilePrefix: defaultCountryPhoneCode,
      name: '',
      phone: '',
      phonePrefix: defaultCountryPhoneCode,
      preferredName: '',
      title: this.state.hideTitle ? 'Not Applicable' : '',
      jobTitle: '',
      monthlyIncome: '',
      nationality: '',
      gender: '',
      race: '',
      raceOther: '',
      bumi: 'Not Applicable',
      maritalStatus: '',
      birthdate: '',
      customerSpecification: [],
      firstTimeBuyer: this.state.hideFirstTimeBuyer ? 'no' : '',
      taxIdentificationNo: '',
    });
    this.setState({
      booking,
      autofillOptions: [],
      existingCustomer: {},
      externalCustomer: {},
      leadCustomer: {},
      identity: '',
      identityLock: false,
      mobileLock: false,
      prsID: '',
    }, () => {
      if (this.identityInputRef.current) {
        this.identityInputRef.current.focus();
      }
    });
  }
  handleModalReservationClose = () => {
    const { store } = this.context;
    this.setState({ modalReservationIsOpen: false }, () => {
      store.dispatch(push(`/projects/${this.state.projectID}/units/${this.state.projectUnitID}/`));
    });
  }
  handleCountdownFinish = () => {
    const { store } = this.context;
    this.setState({ showCountdown: false }, () => {
      this.handleResetCheck(() => {
        store.dispatch(replace(`/projects/${this.state.projectID}/units/`));
      });
    });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }

  // CPI-1248 (part 1): may the purchasers on this form reserve the unit they picked? A Vietnamese
  // unit flagged isBumi is the "Local unit", and one declared foreigner anywhere on the booking -
  // the primary purchaser or any joint purchaser the CRM opportunity brought with it - is enough
  // to refuse it. False for every non-Vietnamese session, and for a purchaser whose citizenship
  // the CRM never captured. book-api enforces the same rule on the write.
  //
  // The percentage quota on the project's Foreign Purchase Control threshold (CPI-1220) is the
  // OTHER half of CPI-1248 and is NOT decided here - see README.
  vnLocalUnitForeignerBlocked = () => {
    const { booking, projectUnitDetails, srRelatedBookingCustomers } = this.state;
    return blocksVietnamLocalUnit(this.props.auth, projectUnitDetails, [
      booking,
      ...(srRelatedBookingCustomers || []),
    ]);
  }

  async submitBooking() {
    const { store } = this.context;
    const { t, auth } = this.props;
    const { booking, projectUnitDetails, projectCustomFields, bookingCustomFields, srRelatedBookingCustomers } = this.state;
    const isIndonesia = auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    // CPI-976: no TIN field in Vietnam, so the BRN "Invalid TIN" precondition must not apply.
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    const bcf = bookingCustomFields.filter(bbcf => DEFAULT_BOOKING_FIELD_LIST.every(pf => bbcf.name !== pf.name));
    const trimmedIdentity = this.state.identity ? this.state.identity.trim() : '';
    const taxTinValidationStatus = this.state.tinError === false ? 'success' : 'failed';
    if (!isIndonesia && !isVietnam && this.state.identityType !== 2 && (taxTinValidationStatus !== 'success' && (this.state.identityType === IDENTITY_TYPE_BRN || this.state.project.requireValidTinAtBookingCreation) && !this.state.isForeignCompany)) {
      store.dispatch(flashMessage({
        header: 'Invalid TIN',
        message: 'Tax Identification Number is invalid',
        icon: 'warning sign',
        type: 'error',
        autoHideDuration: 5000,
      }));
      return;
    }
    // prsID
    let prsExists = false;
    bookingCustomFields.forEach((cf, idx) => {
      if (cf.name === 'no_rujukan_pr1ma') {
        prsExists = true;
        if (this.state.prsID) {
          bcf[idx].value = this.state.prsID;
        }
      }
    });
    if (!prsExists && projectCustomFields) {
      const prspcf = projectCustomFields.find(p => p.name === 'no_rujukan_pr1ma');
      if (prspcf) {
        const prsCustomField = {
          name: 'no_rujukan_pr1ma',
          value: this.state.prsID ? this.state.prsID : prspcf.value,
          projectBookingCustomFieldID: prspcf.id,
        };
        bcf.push(prsCustomField);
      }
    }
    // Check if Selling Price is not empty
    if (booking.spaValue === null || booking.spaValue === '') {
      booking.spaValue = '0';
      this.setState({ booking });
    }
    if (booking.identity === '' || booking.customerID === null) {
      booking.identity = trimmedIdentity;
    }
    // CPI-974 (A3): a locked VN form also skips validate(), which would flag fields it disabled.
    if (isVietnam && !this.state.srOpportunity) {
      store.dispatch(flashErrorMessage({
        message: this.state.srError === 'not_approved' ?
          t('Booking has not been approved') :
          `${t('No existing details found')}.`,
      }));
      return;
    }
    // CPI-1248: before anything is validated, priced or posted - Save & Continue must neither
    // advance nor reach the API.
    if (this.vnLocalUnitForeignerBlocked()) {
      store.dispatch(flashErrorMessage({
        header: t('Warning', { ns: TRANSLATION_FILES.translation }),
        message: t(VN_LOCAL_UNIT_FOREIGNER_MESSAGE, { ns: TRANSLATION_FILES.translation }),
        autoHideDuration: 5000,
        icon: 'warning sign',
      }));
      return;
    }
    const validations = await AppForm.validate(this.validation, booking);
    const errMessages = validations.filter(v => !v.isValid);
    const customer = {
      identity: trimmedIdentity,
      identityTypeID: !isNumeric(this.state.identityType) ? 6 : this.state.identityType,
      identityPresetID: this.state.identityPresetID,
      identityPresetLabel: this.state.identityPresetLabel,
      identityPresetRegex: this.state.identityPresetRegex,
      specifications: booking.customerSpecification,
      externalID: booking.externalCustomerID,
      taxIdentificationNo: booking.taxIdentificationNo,
      taxTinValidationStatus,
      isForeignCompany: booking.isForeignCompany,
    };
    const bookingCustomer = {
      address1: booking.address1,
      address2: booking.address2,
      address3: booking.address3,
      address4: booking.address4,
      address5: booking.address5,
      address6: booking.address6,
      address7: booking.address7,
      address8: booking.address8,
      address9: booking.address9,
      address10: booking.address10,
      country: booking.country,
      email: booking.email,
      mobile: booking.mobile,
      mobilePrefix: booking.mobilePrefix,
      name: booking.name,
      phone: booking.phone,
      phonePrefix: booking.phonePrefix,
      preferredName: booking.preferredName,
      title: this.state.hideTitle ? 'Not Applicable' : booking.title,
      customerID: booking.customerID,
      jobTitle: booking.jobTitle,
      monthlyIncome: parseFloat(booking.monthlyIncome),
      nationality: booking.nationality,
      birthdate: booking.birthdate,
      gender: booking.gender,
      race: booking.race.toUpperCase() === 'Others'.toUpperCase() ? booking.raceOther : booking.race,
      bumi: booking.bumi,
      maritalStatus: booking.maritalStatus,
      emergencyContactName: booking.emergencyContactName,
      emergencyContactRelation: booking.emergencyContactRelation,
      emergencyContactMobilePrefix: booking.emergencyContactMobilePrefix,
      emergencyContactMobile: booking.emergencyContactMobile,
      emergencyContactEmail: booking.emergencyContactEmail,
      emergencyContactIdentity: booking.emergencyContactIdentity,
      customer,
      leadCustomerID: booking.leadCustomerID,
      leadICFrontURL: booking.leadICFrontURL,
      leadICBackURL: booking.leadICBackURL,
      externalID: booking.externalCustomerID,
      himsKodPoskod: booking.himsKodPoskod,
      himsKodBandar: booking.himsKodBandar,
      himsKodDaerah: booking.himsKodDaerah,
      himsKodNegeri: booking.himsKodNegeri,
      himsKodNegara: booking.himsKodNegara,
      sstRegistrationNo: booking.sstRegistrationNo,
    };
    // CPI-1248: the primary purchaser's citizenship, which this payload used to drop - the
    // Purchaser tab (CPI-976 M4) has always sent it, so a reservation created here read back as
    // an undeclared purchaser. Vietnam only; the key is not added to a MY/ID payload at all.
    if (isVietnam) {
      bookingCustomer.citizenship = booking.citizenship || '';
    }
    // CPI-974 (D18): post every CRM purchaser, primary first; always empty off Vietnam.
    let postBooking = {
      bookingCustomFields: bcf,
      bookingCustomers: [
        bookingCustomer,
        ...this.state.srRelatedBookingCustomers,
      ],
      customerID: booking.customerID,
      paymentMethodID: booking.paymentMethodID,
      projectID: booking.projectID,
      projectUnitID: booking.projectUnitID,
      spaValue: parseInt(booking.spaValue, 10),
      nettSellingPrice: parseFloat(booking.nettSellingPrice),  // TODO Remove (deprecated tier pricing)
      statusID: booking.statusID,
      tierPricingName: booking.tierPricingName,
      tierPricingDescription: booking.tierPricingDescription,
      unitPackagePricingID: booking.unitPackagePricingID,
      unitPackageFeeID: booking.unitPackageFeeID,
      linkBuyerApp: booking.linkBuyerApp,
      origin: booking.origin,
      originID: booking.originID,
      firstTimeBuyer: this.state.hideFirstTimeBuyer ? 'no' : booking.firstTimeBuyer,
      externalID: booking.externalID,
    };
    // clear unitPackagePricingID if base selling price selected
    if (projectUnitDetails.spaValue === booking.unitPackagePricingID) postBooking.unitPackagePricingID = '';
    if (isVietnamCompany(this.props.auth)) {
      postBooking.waiveBankGuarantee = !!booking.waiveBankGuarantee;
    }
    postBooking = fullToAmount(postBooking, booking.spaValue);
    if (
      booking.maUserAffiliateCompanyBranchShortName &&
      booking.maUserAffiliateCompanyBranchID &&
      booking.maUserAffiliateCompanyID &&
      booking.maUserAffiliateID &&
      booking.maCreatedByPreferredName &&
      booking.maUserID
    ) {
      // eslint-disable-next-line max-len
      postBooking.maUserAffiliateCompanyBranchShortName = booking.maUserAffiliateCompanyBranchShortName;
      postBooking.maUserAffiliateCompanyBranchID = booking.maUserAffiliateCompanyBranchID;
      postBooking.maUserAffiliateCompanyID = booking.maUserAffiliateCompanyID;
      postBooking.maUserAffiliateID = booking.maUserAffiliateID;
      postBooking.maCreatedByName = booking.maCreatedByName;
      postBooking.maCreatedByEmail = booking.maCreatedByEmail;
      postBooking.maCreatedByPreferredName = booking.maCreatedByPreferredName;
      postBooking.maUserID = booking.maUserID;
    }

    // set origin if booking is from lead
    if (this.state.opportunityID) {
      postBooking.origin = 'lead';
      // postBooking.originID = this.state.opportunityID;
      postBooking.leadOpportunityID = this.state.opportunityID;
    }

    await this.setComponentState({
      errMessages,
    });
    let header = t('Please fix form errors', { ns: TRANSLATION_FILES.translation });
    if (isPRS) header = <span>Please fix form errors or inform the customer to update their details in <a href="http://www.pr1ma.my" target="_blank">PRS system (www.pr1ma.my)</a></span>;
    if (!customer.identityTypeID) {
      const errMessagesWithIdentityType = Object.assign([], errMessages);
      errMessagesWithIdentityType.unshift({
        isValid: false,
        key: '',
        message: t('Please select Identity Type'),
      });
      store.dispatch(flashErrorMessage({ header, list: errMessagesWithIdentityType.map(l => l.message) }));
      return;
    }
    if (errMessages.length > 0) {
      store.dispatch(flashErrorMessage({ header, list: errMessages.map(l => l.message) }));
      return;
    }
    if (!isVietnam && this.isUnderagePurchaser(bookingCustomer.birthdate)) {
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }
    if (!isVietnam && this.isUnderageNRICPurchaser(customer.identityTypeID, trimmedIdentity)) {
      store.dispatch(flashErrorMessage({ message: this.getMinimumPurchaserAgeMessage() }));
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const source = queryParams.get('source');

    let res;
    try {
      res = await this.form.submit(`/bookings/${source ? `?source=${source}` : ''}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin, // client vendor source
        },
        body: JSON.stringify(postBooking),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        const mType = await err.res.headers.get('M-Type');
        if (mType === 'error_user_cooldown') {
          store.dispatch(flashErrorMessage({ header: t('Booking Cooldown'), message, autoHideDuration: 5000, icon: 'wait' }));
          return;
        }
        if (mType === 'error_bap_user_cooldown') {
          const defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
          await store.dispatch(flashErrorMessage({ header: defaultBookingStatus === 'reserved' ? 'Reservation Abuse Prevention' : 'Booking Abuse Prevention', message, autoHideDuration: 5000, icon: 'wait' }));
          return;
        }
        if (mType === 'error_unit_unavailable') {
          await this.setComponentState({ showSwapUnit: true });
        }
        // CPI-974 (A3): must sit before the generic 412 block MY's own messages fall through.
        if (mType === 'error_sr_status_not_approved') {
          store.dispatch(flashErrorMessage({
            header: t('Warning', { ns: TRANSLATION_FILES.translation }),
            message: message || t('Booking has not been approved'),
            autoHideDuration: 5000,
            icon: 'warning sign',
          }));
          return;
        }
        // CPI-1248: book-api refuses the same booking with a 412. It is a purchaser problem, not
        // an availability one, so it must not read as the generic precondition message - and the
        // swap-unit prompt above is deliberately not opened for it.
        if (mType === 'error_vn_local_unit_foreigner') {
          store.dispatch(flashErrorMessage({
            header: t('Warning', { ns: TRANSLATION_FILES.translation }),
            message: message || t(VN_LOCAL_UNIT_FOREIGNER_MESSAGE, { ns: TRANSLATION_FILES.translation }),
            autoHideDuration: 5000,
            icon: 'warning sign',
          }));
          return;
        }
        // CPI-1248 (part 2): the project's Foreign Purchase Control threshold. book-api owns the
        // count - the screen has no unit or booking totals and pre-counts nothing - so this only
        // renders the API's refusal, and for the same reason as above it must not fall through to
        // the generic 412 or open the swap-unit prompt.
        if (mType === 'error_vn_foreign_threshold_exceeded') {
          store.dispatch(flashErrorMessage({
            header: t('Warning', { ns: TRANSLATION_FILES.translation }),
            message: message || t(VN_FOREIGN_THRESHOLD_MESSAGE, { ns: TRANSLATION_FILES.translation }),
            autoHideDuration: 5000,
            icon: 'warning sign',
          }));
          return;
        }
        if (err.res.status === 412) {
          store.dispatch(flashMessage({
            header: t('Warning', { ns: TRANSLATION_FILES.translation }),
            message,
            icon: 'warning sign',
            type: 'warning',
            autoHideDuration: 5000,
          }));
          return;
        }
        if (message.includes('SPA')) {
          store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), message: t('Selling Price requires positive amount', { ns: TRANSLATION_FILES.translation }) }));
          return;
        }
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setComponentState({
      booking: Object.assign({}, BookingForm.defaultValues),
      bookingSubmitted: true,
    }, () => {
      this.handleResetCheck((noChanges) => {
        if (noChanges) {
          // The API checks the deferred rules without blocking reservation creation. Only
          // contacts needing correction interrupt the configured next step with purchaser review.
          const reviewRelatedPurchasers = isVietnam && res.purchasersIsolated &&
            res.relatedPurchasersRequireReview === true;
          const nextURL = reviewRelatedPurchasers
            ? `/bookings/${res.id}/?section=purchaser&reviewPurchasers=1`
            : bookingFlow(res, 0);
          let message = 'Unit is only considered successfully booked when checked and updated by admin';
          if (booking.statusID === 'booked') {
            message = 'Unit is successfully booked';
          }
          store.dispatch(push(nextURL));
          store.dispatch(flashSuccessMessage({
            header: `${t('Unit {{reference}} is reserved', { reference: projectUnitDetails.reference, ns: TRANSLATION_FILES.translation })}.`,
            message: `${t(message, { ns: TRANSLATION_FILES.translation })}.`,
          }));
          store.dispatch(clearBookQuery()); // clear book query cache
        }
      });
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    this.submitBooking();
  }
  handleShowSwapUnit = () => {
    this.setState({ showSwapUnit: true, manualSwap: true });
  }
  handleCancelChange = (e) => {
    const { store } = this.context;
    e.preventDefault();
    if (this.state.manualSwap) {
      this.setState({
        showSwapUnit: false,
      });
      return;
    }
    store.dispatch(push(`/projects/${this.state.projectID}/units/`));
  }
  handleConfirmChange = (e) => {
    e.preventDefault();
    this.setState({
      showSwapUnit: false,
    });
  }
  handleProjectUnitClear = () => {
    this.setState({ selectedProjectUnit: {
      key: '',
      title: '',
    } });
  }
  handleProjectUnitSelect = (value) => {
    const query = decodeSearch(this.props.location.search);
    let projectUnitID = this.state.projectUnitID;
    let selectedProjectUnit = this.state.selectedProjectUnit;
    let projectUnitSwapError = this.state.projectUnitSwapError;
    if (value.hrefLang !== 'new') {
      projectUnitSwapError = true;
      selectedProjectUnit = {
        key: '',
        title: '',
      };
    } else {
      projectUnitSwapError = false;
      selectedProjectUnit = value;
      projectUnitID = value.key;
      query.unitID = value.key;
      this.replaceQuery(query);
      this.getProjectUnit(this.state.projectID, value.key);
    }
    this.setState({
      selectedProjectUnit,
      projectUnitSwapError,
      projectUnitID,
    });
  }
  handleBirthdateSelect = (day) => {
    const { booking } = this.state;
    booking.birthdate = day;
    this.setState({ booking });
  }
  handleClearTimer = () => {
    this.fetchPreReservation(true);
  }
  handleUserClear = () => {
    const { booking } = this.state;
    booking.maCreatedByName = '';
    booking.maCreatedByEmail = '';
    booking.maCreatedByPreferredName = '';
    booking.maUserID = 0;
    booking.maUserAffiliateCompanyBranchShortName = '';
    booking.maUserAffiliateCompanyBranchID = 0;
    booking.maUserAffiliateCompanyID = 0;
    booking.maUserAffiliateID = 0;
    this.setState({ booking, searchUserValue: '' });
  }
  handleUserSelect = (value) => {
    const { booking, searchUsersData } = this.state;
    const selectedUser = searchUsersData.find(d => d.email === value.description);
    if (selectedUser &&
      selectedUser.name !== '' &&
      selectedUser.preferredName !== '' &&
      selectedUser.companyBranchShortName !== '' &&
      selectedUser.companyBranchID > 0 &&
      selectedUser.companyID > 0 &&
      selectedUser.affiliateID > 0 &&
      selectedUser.id > 0) {
      booking.maCreatedByName = selectedUser.name;
      booking.maCreatedByEmail = selectedUser.email;
      booking.maCreatedByPreferredName = selectedUser.preferredName;
      booking.maUserAffiliateCompanyBranchShortName = selectedUser.companyBranchShortName;
      booking.maUserAffiliateCompanyBranchID = selectedUser.companyBranchID;
      booking.maUserAffiliateCompanyID = selectedUser.companyID;
      booking.maUserAffiliateID = selectedUser.affiliateID;
      booking.maUserID = selectedUser.id;
      this.setState({ booking });
    }
  }
  handleUserfetch = (data, searchUserValue) => {
    this.setState({ searchUsersData: data, searchUserValue });
  }
  handleCloseLaunchModeMultiModal = (e) => {
    const { store } = this.context;
    if (e) e.preventDefault();
    store.dispatch(goBack());
  }
  // "Go back to A40.07": the held unit's page, where its Reserve screen can be reopened.
  handleGoBackToHeldUnit() {
    const { store } = this.context;
    const { heldUnit, projectID } = this.state;
    this.setState({ showLaunchModeMulti: false });
    store.dispatch(push(heldUnitPagePath(projectID, heldUnit.heldUnitID)));
  }
  // "Release A40.07 and continue": release the other hold, then take this unit's hold again.
  async handleReleaseHeldUnitAndContinue() {
    const { store } = this.context;
    const { t } = this.props;
    const { heldUnit, projectID } = this.state;
    await this.setComponentState({ showLaunchModeMulti: false });
    await this.setLoading('isFetching', true);
    try {
      await store.dispatch(fetchM(preReservedURL(config.get('bookApiURL'), projectID, heldUnit.heldUnitID, { clear: true }), {
        credentials: 'include',
        method: 'GET',
        ignoreForbidden: true,
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading('isFetching', false);
      const message = (err.res && err.res.status >= 400 && err.res.status < 500)
        ? await err.res.text()
        : `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.`;
      store.dispatch(flashErrorMessage({ message }));
      await this.setComponentState({ showLaunchModeMulti: true });
      return;
    }
    await this.setComponentState({ heldUnit: null, launchModeMultiErr: '' });
    await this.fetchPreReservation(false);
  }
  handleSelectHimsDistrict = (himsCity) => {
    const { booking } = this.state;
    booking.himsKodDaerah = himsCity ? himsCity.value : '';

    this.setState({ booking }, () => {
      this.handleCheckChanges();
    });
  }
  handleSelectHimsPostcode = (himsPostcode) => {
    const { booking } = this.state;
    const { addressSettings } = this.props;

    booking.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    booking.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    booking.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const addressFields = enabledAddressSettings.reduce((acc, as) => {
      const labelKey = as.label.toLowerCase();
      return {
        ...acc,
        ...(labelKey === 'postcode' && { postcode: as }),
        ...(labelKey === 'city' && { city: as }),
        ...(labelKey === 'state' && { state: as }),
      };
    }, {});
    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      const key = _.camelCase(addressFields.postcode.columnName);
      booking[key] = himsPostcode ? himsPostcode.text : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      const key = _.camelCase(addressFields.city.columnName);
      booking[key] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      const himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      const srState = STATES.find(s => s.kod_negeri_id === himsState);
      const key = _.camelCase(addressFields.state.columnName);
      booking[key] = srState ? srState.value : '';
    }

    this.setState({ booking }, () => {
      this.handleCheckChanges();
    });
  }
  async fetchPreReservation(clear = false, skipLoader = false) {
    const query = {};
    if (clear) {
      query.clear = 'true';
    }
    const { store } = this.context;
    const { t } = this.props;
    if (!skipLoader) await this.setLoading('isFetching', true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.state.projectID}/units/${this.state.projectUnitID}/pre_reserved/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        const mType = await err.res.headers.get('M-Type');
        if (mType === UNIT_HELD_M_TYPE) {
          if (!skipLoader) await this.setLoading('isFetching', false);
          await this.setComponentState({
            showLaunchModeMulti: true,
            launchModeMultiErr: message,
            heldUnit: parseUnitHeldRefusal(message, err.res.headers),
          });
          return null;
        }
        if (mType === 'error_launch_mode_timeout') {
          if (!skipLoader) await this.setLoading('isFetching', false);
          await this.setComponentState({ showSwapUnit: true });
        }
        if (mType === 'error_launch_mode_locked') {
          store.dispatch(push(`/projects/${this.state.projectID}/units/${this.state.projectUnitID}/`));
        }
        if (mType === 'error_bap_user_cooldown') {
          const defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
          await store.dispatch(push(`/projects/${this.state.projectID}/units/`));
          await store.dispatch(flashErrorMessage({ header: defaultBookingStatus === 'reserved' ? 'Reservation Abuse Prevention' : 'Booking Abuse Prevention', message, autoHideDuration: 10000, icon: 'wait' }));
          return null;
        }
        store.dispatch(flashErrorMessage({ message }));
        return null;
      }
      if (!skipLoader) await this.setLoading('isFetching', false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return null;
    }
    if (!skipLoader) await this.setLoading('isFetching', false);
    const json = await res.json();
    if (json) {
      await this.setComponentState({ reservedTimeoutExpireAt: json.reservedTimeoutExpireAt });
    }
    if (clear) {
      this.handleResetCheck(() => {
        if (this.props.location.action === 'PUSH') {
          store.dispatch(goBack());
        } else {
          store.dispatch(replace(`/projects/${this.state.projectID}/units/${this.state.projectUnitID}/`));
        }
      });
    }
    return null;
  }
  async fetchPreReservationCooldown(skipLoader = false) {
    const { store } = this.context;
    const { t } = this.props;
    if (!skipLoader) await this.setLoading('isFetching', true);
    try {
      await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.state.projectID}/units/${this.state.projectUnitID}/pre_reserved_cooldown/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        const mType = await err.res.headers.get('M-Type');
        if (mType === 'error_user_cooldown') {
          await store.dispatch(push(`/projects/${this.state.projectID}/units/${this.state.projectUnitID}/`));
          await store.dispatch(flashErrorMessage({ header: t('Booking Cooldown'), message, autoHideDuration: 10000, icon: 'wait' }));
          return;
        }
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      if (!skipLoader) await this.setLoading('isFetching', false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!skipLoader) await this.setLoading('isFetching', false);
  }
  replaceQuery(query) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  validateIdentityType = () => {
    const { identityType } = this.state;
    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  }
  filterPackingPricing = (packagePricings) => {
    const { booking, projectUnitDetails } = this.state;
    const newPackagePricings = packagePricings;
    const pricings = projectUnitDetails.projectUnitPackagePricings;
    if (pricings) {
      packagePricings.forEach((pt, idx) => {
        const price = pricings.find(t => t.id === pt.value);
        if (price) {
          // expired schedule
          const sStart = price.projectPackagePricing.scheduleStartAt;
          const sEnd = price.projectPackagePricing.scheduleEndAt;
          if ((sStart && moment(sStart).unix() > moment().unix()) ||
          (sEnd && moment(sEnd).unix() < moment().unix())) {
            newPackagePricings[idx].disabled = true;
          } else if (price && price.projectPackagePricing && price.projectPackagePricing.bumiPurchaserOnly) {
            // booking package pricing primary bumi customer
            if (booking.bumi === 'Bumiputera') {
              newPackagePricings[idx].disabled = false;
            } else {
              newPackagePricings[idx].disabled = true;
            }
          }
        }
      });
    }
    return newPackagePricings;
  }
  filterFeePackages = (feePackages) => {
    const { projectUnitDetails } = this.state;
    const newFeePackages = feePackages;
    const unitFeePackages = projectUnitDetails.projectUnitPackageFees;
    if (unitFeePackages) {
      feePackages.forEach((pt, idx) => {
        const pp = unitFeePackages.find(t => t.id === pt.value);
        if (pp) {
          // expired schedule
          const sStart = pp.projectFeePackage.scheduleStartAt;
          const sEnd = pp.projectFeePackage.scheduleEndAt;
          if ((sStart && moment(sStart).unix() > moment().unix()) ||
          (sEnd && moment(sEnd).unix() < moment().unix())) {
            newFeePackages[idx].disabled = true;
          }
        }
      });
    }
    return newFeePackages;
  }
  getIdentityType= () => {
    const { t, auth } = this.props;
    const { identityPresets, identityType, identityPresetID, identityPresetLabel } = this.state;
    const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
    if (isPRS) return `${t('NRIC Number')} :`;
    if (identityType === '') {
      return `${t('Identity Number')} :`;
    }
    if ((identityType > 4 || typeof (identityType) === 'string') && identityPresets && identityPresets.length > 0) {
      const idx = identityPresets.findIndex(i => i.id === identityPresetID);
      if (idx !== -1) {
        return identityPresets[idx].label;
      } else if (identityPresetLabel) {
        return identityPresetLabel;
      }
      return `${t('ID Number')} :`;
    }
    switch (identityType) {
      case 2:
        return `${t('Passport Number')} :`;
      case 4:
        return `${t(isVietnam ? 'Enterprise Registration Certificate' : 'Company Registration Number')} :`;
      default:
        return `${t('Identity Number')} :`;
    }
  }
  identityValidation = () => {
    const { auth, t } = this.props;
    const { identityType, identityPresetRegex } = this.state;
    if (identityType === 6 || !isNumeric(identityType)) {
      return {
        validRegex: identityPresetRegex,
      };
    }
    // CPI-974: a Vietnamese CCCD is checked against the CCCD rule, not the Malaysian IC one,
    // and carries the CRM's wording. null outside Vietnam and for every other identity type,
    // so the return below is unchanged.
    const vn = vnIdentityValidation(auth, identityType, t);
    if (vn) {
      return vn;
    }
    return {
      countryCode: 'MY',
      identityType: this.validateIdentityType(),
    };
  }
  newBookingStatutes = [
    { text: 'Reserved', value: 'reserved', name: 'reserved' },
    { text: 'Booked', value: 'booked', name: 'booked' },
  ]

  isCustomFieldRequiredAtStatus = (field) => {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // For DEFAULT fields (purchaser fields), always use isRequired directly
    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    const currentStatus = this.state.booking.statusID || 'reserved';
    const requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    const statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3,
    };

    const currentLevel = statusHierarchy[currentStatus];
    const requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  }

  renderCustomField(t, data, idx) {
    if (data.isDefault) {
      if (data.name === 'emergencyContactMobile') {
        const emergencyContactValidation = [{
          validate: phoneNumber,
          option: this.state.booking.emergencyContactMobilePrefix === 'other' ? {} : {
            isMobile: true,
            phonePrefix: this.state.booking.emergencyContactMobilePrefix,
            validRegex: getPhoneValidRegex(
              this.state.phoneValidationPresets,
              this.state.booking.emergencyContactMobilePrefix,
              'mobile',
            ),
          },
        }];
        if (this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled) {
          emergencyContactValidation.push(required);
        }
        return (
          <Grid.Column key={idx} width={16}>
            <Form.Group widths="equal">
              <AppForm.Validate
                ref={this.validation.emergencyContactMobilePrefix}
                onChange={this.handleSelectChange}
                validateLabel={t('{{label}} Prefix', { label: data.label })}
              >
                <Form.Select
                  disabled={this.isVNFormLocked()}
                  label={t('{{label}} Prefix', { label: data.label, ns: TRANSLATION_FILES.models.customer })}
                  name="emergencyContactMobilePrefix"
                  onChange={this.handleSelectChange}
                  options={this.toUppercaseOptions(INTL_CALL_CODES)}
                  search
                  selectOnBlur={false}
                  value={this.state.booking.emergencyContactMobilePrefix}
                />
              </AppForm.Validate>
              <PhoneInput
                autoComplete="off"
                disabled={this.isVNFormLocked()}
                label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
                name="emergencyContactMobile"
                onChange={this.handleInputChange}
                placeholder={data.label}
                prefix={this.state.booking.emergencyContactMobilePrefix}
                ref={this.validation.emergencyContactMobile}
                type="tel"
                validation={emergencyContactValidation}
                value={this.state.booking.emergencyContactMobile}
                validateLabel={data.label}
              />
            </Form.Group>
          </Grid.Column>
        );
      }
      if (data.name === 'birthdate') {
        return (
          <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
            <Form.Group widths="equal">
              <InputBirthdate
                date={this.state.booking.birthdate}
                onSelectDay={this.handleBirthdateSelect}
                label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
                disabled={this.state.identityType === IDENTITY_TYPE_BRN || this.isVNFormLocked()}
              />
            </Form.Group>
          </Grid.Column>
        );
      }
      if (data.name === 'race') {
        const raceOptions = RACE.map(o => ({
          ...o,
          text: t(o.text, { ns: TRANSLATION_FILES.constants }),
        }));
        return (
          <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
            <Form.Group widths="equal">
              <AppForm.Validate
                validation={(this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled) ? [required] : null}
                ref={this.validation.race}
                onChange={(e, d) => this.handleCustomSelectChange(e, d, data.id, raceOptions)}
                validateLabel={data.label}
              >
                <Form.Select
                  disabled={this.isVNFormLocked()}
                  name="race"
                  fluid
                  options={this.toUppercaseOptions(raceOptions)}
                  placeholder={data.label}
                  label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
                  search
                  selectOnBlur={false}
                  value={this.state.booking.race}
                />
              </AppForm.Validate>
              <AppForm.Input
                autoComplete="off"
                disabled={this.state.booking.race.toUpperCase() !== 'Others'.toUpperCase() || this.isVNFormLocked()}
                fluid
                name="raceOther"
                onChange={this.handleInputChange}
                placeholder={t('Fill in your Race')}
                label={translateModels(t, 'raceOther', 'booking')}
                ref={this.validation.raceOther}
                validateLabel={translateModels(t, 'raceOther', 'booking')}
                validation={this.state.booking.race.toUpperCase() === 'Others'.toUpperCase() ? [required] : null}
              />
            </Form.Group>
          </Grid.Column>
        );
      }
    }
    if (data.type === 'input') {
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          <Form.Group widths="equal">
            <AppForm.Input
              disabled={data.isDisabled || this.isVNFormLocked() || (isPRS && data.name === 'no_rujukan_pr1ma')}
              autoComplete="off"
              label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
              name={data.name}
              onChange={e => this.handleCustomInputChange(e, data.id, data.isDefault)}
              placeholder={data.placeholder}
              ref={this.validation[data.name]}
              validation={(this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled && !(isPRS && data.name === 'no_rujukan_pr1ma')) ?
              [required, {
                validate: value => checkRegex(value, data),
              }] : [{
                validate: value => checkRegex(value, data),
              }]}
              value={this.state.booking[data.name]}
              validateLabel={data.label}
            />
          </Form.Group>
        </Grid.Column>
      );
    }
    if (data.type === 'textarea') {
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          <Form.Group widths="equal">
            <AppForm.Validate
              validation={(this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled) ? [required] : null}
              ref={this.validation[data.name]}
              onChange={e => this.handleCustomInputChange(e, data.id, data.isDefault)}
              validateLabel={data.label}
            >
              <Form.TextArea
                disabled={data.isDisabled || this.isVNFormLocked()}
                autoComplete="off"
                label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
                name={data.name}
                placeholder={data.placeholder}
                ref={this.validation[data.name]}
                value={this.state.booking[data.name]}
                style={{ minHeight: '6em', height: '6em' }}
              />
            </AppForm.Validate>
          </Form.Group>
        </Grid.Column>
      );
    }
    if ((data.type === 'dropdown' || data.type === 'dropdown_multi')) {
      const renderLabel = label => ({
        content: label.text,
        circular: true,
      });
      let customFieldOptions = [];
      if (data.projectBookingCustomFieldOptions &&
        data.projectBookingCustomFieldOptions.length > 0) {
        data.projectBookingCustomFieldOptions.sort(
          (a, b) => a.position - b.position).forEach((d) => {
            customFieldOptions.push(
              { text: d.title, value: d.value, id: d.id },
            );
          });
      }
      if (data.isDefault) {
        switch (data.name) {
          case 'nationality':
            customFieldOptions = SELECT_NATIONALITY;
            break;
          case 'gender':
            customFieldOptions = GENDER.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          case 'bumi':
            customFieldOptions = BUMI.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          case 'maritalStatus':
            customFieldOptions = MARITAL_STATUS.map(o => ({
              ...o,
              text: t(o.text, { ns: TRANSLATION_FILES.constants }),
            }));
            break;
          default:
            break;
        }
      }
      let value = this.state.booking[data.name];
      if (data.type === 'dropdown_multi') {
        if (this.state.booking[data.name] && value !== '') {
          value = value.split(',');
        } else {
          value = [];
        }
      }
      return (
        <Grid.Column key={idx} mobile={16} tablet={8} computer={8}>
          <Form.Group widths="equal">
            <AppForm.Validate
              key={idx}
              validation={(this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled) ? [required] : null}
              ref={this.validation[data.name]}
              onChange={(e, d) => this.handleCustomSelectChange(e, d, data.id, customFieldOptions)}
              validateLabel={data.label}
            >
              <Form.Select
                disabled={data.isDisabled || this.isVNFormLocked()}
                className="custom_dropdown"
                label={`${data.label}${this.isCustomFieldRequiredAtStatus(data) ? '*' : ''}`}
                name={data.name}
                options={this.toUppercaseOptions(customFieldOptions)}
                placeholder={data.placeholder}
                search
                selectOnBlur={false}
                value={value}
                multiple={data.type === 'dropdown_multi'}
                renderLabel={renderLabel}
                clearable
              />
            </AppForm.Validate>
          </Form.Group>
        </Grid.Column>
      );
    }
    return '';
  }
  // CPI-974 (D5): the Booking ID search takes the Identity Type row's position. Vietnam only.
  renderBookingIDSearch = () => {
    const { t } = this.props;
    const { srCode, srSearching, srOpportunity } = this.state;
    return (
      <Grid.Row centered>
        <Grid.Column width={16}>
          <Form.Group>
            <Form.Input
              width={12}
              autoComplete="off"
              label={`${t('Booking ID', { ns: TRANSLATION_FILES.translation })}*`}
              name="srCode"
              value={srCode}
              onChange={this.handleSRCodeChange}
              onKeyPress={this.handleSRCodeKeyPress}
              placeholder={t('Booking ID', { ns: TRANSLATION_FILES.translation })}
              disabled={!!srOpportunity}
            />
            <Form.Field width={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
              {
                srOpportunity ? (
                  <Button
                    type="button"
                    basic
                    onClick={(e) => { e.preventDefault(); this.handleResetSRSearch(); }}
                    content={t('Clear Form')}
                  />
                ) : (
                  <Button
                    type="button"
                    primary
                    loading={srSearching}
                    disabled={srSearching || !srCode.trim()}
                    onClick={(e) => { e.preventDefault(); this.searchOpportunityBySRCode(); }}
                    content={t('Search')}
                  />
                )
              }
            </Form.Field>
          </Form.Group>
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderBookingIDNotices = () => {
    const { t } = this.props;
    const { srError, srErrorProjectName, srIdentityTypeUnmapped, srRelatedBookingCustomers } = this.state;
    return (
      <React.Fragment>
        { srError &&
          <Grid.Column width={16}>
            <Segment secondary>
              <b>
                {
                  srError === 'not_approved' ?
                    t('Booking has not been approved') :
                    srError === 'wrong_project' ?
                      t('This Booking ID belongs to a different project{{project}}. Use a Booking ID for this project, or reserve a unit in the project it was created for.', {
                        project: srErrorProjectName ? ` (${srErrorProjectName})` : '',
                      }) :
                      `${t('No existing details found')}.`
                }
              </b>
            </Segment>
          </Grid.Column>
        }
        { srIdentityTypeUnmapped &&
          <Grid.Column width={16}>
            <Segment secondary>
              <b>{t('Identity type could not be matched, please select it manually')}.</b>
            </Segment>
          </Grid.Column>
        }
        { this.renderVNCRMPurchaserNotice() }
      </React.Fragment>
    );
  }

  // What the CRM said about the buyer the agent swapped in.
  renderVNCRMPurchaserNotice = () => {
    const { t } = this.props;
    const { vnCRMLookup, vnCRMCustomer } = this.state;
    if (!vnCRMLookup || vnCRMLookup === 'searching') {
      return null;
    }
    if (vnCRMLookup === 'found') {
      const contact = this.getCRMContact(vnCRMCustomer) || {};
      return (
        <Grid.Column width={16}>
          <Segment secondary>
            <b>{t('Found in CRM')}: {contact.name || ''}</b>
            <Button
              type="button"
              primary
              size="small"
              style={{ marginLeft: '1em' }}
              onClick={(e) => { e.preventDefault(); this.applyVNCRMPurchaser(); }}
              content={t('Use this customer')}
            />
          </Segment>
        </Grid.Column>
      );
    }
    if (vnCRMLookup === 'not_found') {
      return (
        <Grid.Column width={16}>
          <Segment secondary>
            <b>{t('Not found in CRM. Fill in the details and a new customer will be created in the CRM when you save')}.</b>
          </Segment>
        </Grid.Column>
      );
    }
    return null;
  }

  renderCustomFields(t, fields, isDefault) {
    const { auth } = this.props;
    let customFields = fields;
    if (isDefault && customFields && customFields.length < 1) {
      customFields = EXTRA_PURCHASER_CUSTOM_FIELDS;
    }
  // CPI-976: Vietnam has no race / bumi / SST Registration No. default purchaser fields.
    if (isDefault && customFields && isCountryVietnam(auth && auth.company && auth.company.countryCode)) {
      customFields = customFields.filter(f => !['race', 'bumi', 'sstRegistrationNo'].includes(f.name));
    }
    if (customFields && customFields.length > 0) {
      return (
        <Grid>
          <Grid.Row>
            {customFields.filter(f => PURCHASER_CUSTOM_FIELDS.some(pf =>
              f.name !== pf.name && !f.isHidden)).sort(
              (a, b) => a.position - b.position,
            ).map(
              (data, idx) => this.renderCustomField(t, data, idx),
            )}
          </Grid.Row>
        </Grid>
      );
    }
    return '';
  }
  customFormulaTypeConverter = (customPrice) => {
    const { projectUnitDetails } = this.state;
    if (customPrice && projectUnitDetails.spaValue) {
      const valueDiff = customPrice - projectUnitDetails.spaValue;
      if (valueDiff > 0) {
        return 'add_custom_formula';
      } else if (valueDiff < 0) {
        return 'deduct_custom_formula';
      }
    }
    return null;
  }
  renderFormulaChangePrefix = (type) => {
    switch (type) {
      case 'deduct_from_list_price':
      case 'deduct_from_spa_price':
      case 'deduct_from_sub_total':
      case 'deduct_custom_formula':
        return <Icon color="red" size="small" name="minus" />;
      case 'add_from_list_price':
      case 'add_from_spa_price':
      case 'add_from_sub_total':
      case 'add_custom_formula':
        return <Icon color="green" size="small" name="plus" />;
      default:
        break;
    }
    return '';
  }
  renderFormulaChangeClass = (type) => {
    switch (type) {
      case 'deduct_from_list_price':
      case 'deduct_from_spa_price':
      case 'deduct_from_sub_total':
      case 'deduct_custom_formula':
        return 'text_deduct';
      case 'add_from_list_price':
      case 'add_from_spa_price':
      case 'add_from_sub_total':
      case 'add_custom_formula':
        return 'text_add';
      default:
        break;
    }
    return '';
  }
  hasAccessNettSellingPrice(project) {
    const { auth } = this.props;
    if (auth.isSuperAdmin || auth.isHeadquarters) {
      return true;
    }
    if (project && project.accessBULNettSellingPrice && auth.isBranchLeader) {
      return true;
    }
    if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
      return true;
    }
    return false;
  }
  vnStoredPackageTotal = (packagePricingID) => {
    const { projectUnitDetails } = this.state;
    const pricings = (projectUnitDetails && projectUnitDetails.projectUnitPackagePricings) || [];
    const pricing = pricings.find(d => d.id === packagePricingID);
    return pricing && pricing.totalPrice !== undefined && pricing.totalPrice !== null
      ? pricing.totalPrice
      : null;
  }
  applyVNLivePackageTotal = (preview) => {
    if (!isVietnamCompany(this.props.auth)) {
      return;
    }
    const total = livePackageTotal(preview);
    const { booking, projectUnitDetails, vnLivePackageTotals } = this.state;
    const packagePricingID = booking.unitPackagePricingID;
    if (total === null || !packagePricingID || packagePricingID === projectUnitDetails.spaValue) {
      this.setState({ vnPreviewFailed: false });
      return;
    }
    const spaValue = amountToFixed(total, projectUnitDetails.spaTimes);
    const spaValueChanged = String(booking.spaValue) !== String(spaValue);
    booking.spaValue = spaValue;
    this.setState({
      booking,
      vnPreviewFailed: false,
      vnLivePackageTotals: { ...vnLivePackageTotals, [packagePricingID]: total },
    }, () => {
      if (this.validation.spaValue.current) {
        this.validation.spaValue.current.validate(booking.spaValue);
      }
      if (spaValueChanged) {
        this.handleCheckChanges();
      }
    });
  }
  markVNPreviewFailed = () => {
    if (!isVietnamCompany(this.props.auth)) {
      return;
    }
    const { booking, projectUnitDetails, vnLivePackageTotals } = this.state;
    const packagePricingID = booking.unitPackagePricingID;
    const nextTotals = { ...vnLivePackageTotals };
    delete nextTotals[packagePricingID];
    const storedTotal = this.vnStoredPackageTotal(packagePricingID);
    if (storedTotal !== null) {
      booking.spaValue = amountToFixed(storedTotal, projectUnitDetails.spaTimes);
    }
    this.setState({ booking, vnPreviewFailed: true, vnLivePackageTotals: nextTotals });
  }
  vnApplyLivePackageTotals = (options) => {
    if (!isVietnamCompany(this.props.auth)) {
      return options;
    }
    const { vnLivePackageTotals, projectUnitDetails } = this.state;
    if (!vnLivePackageTotals || Object.keys(vnLivePackageTotals).length === 0) {
      return options;
    }
    const pricings = (projectUnitDetails && projectUnitDetails.projectUnitPackagePricings) || [];
    return options.map((option) => {
      const live = liveTotalFor(vnLivePackageTotals, option.value);
      const pricing = live === null ? null : pricings.find(d => d.id === option.value);
      if (!pricing) {
        return option;
      }
      const ppp = pricing.projectPackagePricing;
      const hasProjectPackage = !!(ppp && ppp.id);
      const name = hasProjectPackage ? ppp.name : pricing.customName;
      const description = hasProjectPackage ? ppp.description : pricing.customDescription;
      const amount = live.toString();
      return {
        ...option,
        description: amount,
        content: (
          <Header className="ddPricingTierItem">
            <div className="name">{name}</div>
            <div className="value"><LoanAmount precise={false} format="0,000,000.00" amount={amount} prefix={<CurrencySymbol />} /></div>
            <Header.Subheader>{renderPackagePricingDescription(description)}</Header.Subheader>
          </Header>
        ),
      };
    });
  }
  handleWaiveBankGuaranteeChange = (event, data) => {
    const { booking } = this.state;
    booking.waiveBankGuarantee = !!data.checked;
    // Every recorded total was priced with the tick as it stood, so clear them (D-C4).
    this.setState({ booking, isPreviewing: false, vnLivePackageTotals: {} }, () => {
      this.handleCheckChanges();
      this.getPackagePricingCalculation();
    });
  }
  renderFeePackageSelect = (t, feePackages) => (
    <Form.Select
      disabled={!this.hasPackagePricingAccess() || this.isVNFormLocked()}
      className="ddPricingTierDropdown"
      label={translateModels(t, 'unitPackageFeeID', 'booking')}
      name="unitPackageFeeID"
      options={feePackages}
      placeholder={t('Select {{title}}', { title: translateModels(t, 'unitPackageFeeID', 'booking') })}
      search
      selectOnBlur={false}
      value={this.state.booking.unitPackageFeeID}
      onChange={
        this.hasPackagePricingAccess() ?
        this.handleSelectChange :
        () => {}
      }
    />
  )
  // CPI-977 (PO, 14 Sep): shown on every Vietnam reservation, whether or not the package
  // carries a BGW discount line - the tick is recorded on the booking, no discount is implied.
  renderVNBankGuaranteeWaiver = (t) => {
    if (!isVietnamCompany(this.props.auth)) {
      return null;
    }
    return (
      <div className="vnWaiveBankGuarantee" style={{ marginTop: '0.75em' }}>
        <Checkbox
          name="waiveBankGuarantee"
          label={t('Waive Bank Guarantee')}
          checked={!!this.state.booking.waiveBankGuarantee}
          onChange={this.handleWaiveBankGuaranteeChange}
          disabled={!this.hasPackagePricingAccess() || this.isVNFormLocked()}
        />
      </div>
    );
  }
  // CPI-977 S4: one number, the deposit to collect; book-api computes it from the package's rate.
  // Not mounted since 14 Sep (PO: hide the grey box for now) - kept for when the deposit comes back.
  renderVNPricePanel = (t) => {
    if (!isVietnamCompany(this.props.auth)) {
      return null;
    }
    const { booking, project, newPPI, vnPreviewFailed } = this.state;
    const figure = vnPricePanelFigure({
      preview: newPPI,
      previewFailed: vnPreviewFailed,
      storedTotal: booking.spaValue,
    });
    const deposit = depositToCollect({
      preview: figure.isLive ? newPPI : null,
      flatAmount: (project && project.defaultBookingFeeAmount) || 0,
    });
    return (
      <Segment secondary className="vnPricePanel">
        <Grid columns={2} verticalAlign="middle">
          <Grid.Row>
            <Grid.Column>{t('Nett Price')}</Grid.Column>
            <Grid.Column textAlign="right">
              <strong>{formatMajorAmount(figure.amount, VN_CURRENCY_CODE)}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>{t('Deposit to collect')}</Grid.Column>
            <Grid.Column textAlign="right">
              <strong>{formatMajorAmount(deposit.amount, VN_CURRENCY_CODE)}</strong>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {figure.showStoredNotice && (
          <p className="text-subtitle vnStoredTotalNotice">{t(VN_STORED_TOTAL_NOTICE)}</p>
        )}
        <p className="text-subtitle">{t('Amounts exclude VAT')}</p>
      </Segment>
    );
  }
  // CPI-977 (PO mock-up, 2 Sep): the Vietnam booking summary sits inline under Booking Details
  // and follows the package, the waiver and the fee package live - one card, no preview button.
  // Every number is the server's own preview (newPPI / newBFP), the same ones the price panel uses.
  vnSummaryLines = (packagePricing) => {
    const calculations = (packagePricing && packagePricing.calculations) || [];
    return calculations.filter(c => c && !c.isSubTotal);
  }
  vnSignedAmount = (calculationType, amount) => {
    const value = Math.abs(Number(amount) || 0);
    const type = String(calculationType || '');
    const isDeduct = type.includes('deduct');
    const isAdd = !isDeduct && type.includes('add');
    let sign = '';
    if (isDeduct) sign = '- ';
    if (isAdd) sign = '+ ';
    let className = '';
    if (isDeduct) className = 'text_deduct';
    if (isAdd) className = 'text_add';
    return (
      <span className={className}>{sign}{formatMajorAmount(value, VN_CURRENCY_CODE)}</span>
    );
  }
  // "Edit Package" on the summary takes the agent back to the Pricing Package dropdown above.
  focusVNPricingPackageField = () => {
    const field = document.querySelector('.ddPricingTierDropdown');
    if (!field) {
      return;
    }
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const input = field.querySelector('input.search');
    if (input) {
      input.focus();
    }
  }
  renderVNBookingSummary = (t) => {
    if (!isVietnamCompany(this.props.auth)) {
      return null;
    }
    const { booking, projectUnitDetails, identity, newPPI, newBFP } = this.state;
    const unitDetails = projectUnitDetails || {};
    const unitPackagePricings = unitDetails.projectUnitPackagePricings || [];
    const selectedUnitPackagePricing = unitPackagePricings.find(d => d.id === booking.unitPackagePricingID) || null;
    const packagePricing = (newPPI && newPPI.packagePricing) || null;
    const lines = selectedUnitPackagePricing ? this.vnSummaryLines(packagePricing) : [];
    const total = selectedUnitPackagePricing ? livePackageTotal(newPPI) : null;
    const unitFeePackages = unitDetails.projectUnitPackageFees || [];
    const selectedUnitFeePackage = unitFeePackages.find(d => d.id === booking.unitPackageFeeID) || null;
    const feePackage = selectedUnitFeePackage && newBFP && newBFP.packageFee ? newBFP.packageFee : null;
    const feeItems = (feePackage && feePackage.items) || [];
    const canEditPackage = this.hasPackagePricingAccess() && !this.isVNFormLocked();
    return (
      <Segment padded className="bookingSummaryContainer vnBookingSummary">
        <div className="bookingSummary">
          <Header as="h4">{t('Booking Summary')}</Header>
          <Grid columns="equal" className="personalInfo">
            <Grid.Row>
              <Grid.Column>
                <small>{t('Purchaser Full Name')}</small>
                <br />
                {booking.name || '-'}
              </Grid.Column>
              <Grid.Column>
                <small>{this.getIdentityType()}</small>
                <br />
                {identity || '-'}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <small>{t('Project')}</small>
                <br />
                {unitDetails.projectName || '-'}
              </Grid.Column>
              <Grid.Column>
                <small>{t('Unit')}</small>
                <br />
                {unitDetails.reference || '-'}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Segment secondary size="small" className="vnSummaryPackageBar">
            <b>{`${t('Pricing Package')}: `}</b>
            <i>{selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.name : '-'}</i>
            {canEditPackage && (
              <Label
                as="button"
                type="button"
                size="small"
                className="textButton"
                content={t('Edit Package')}
                onClick={this.focusVNPricingPackageField}
                style={{ float: 'right' }}
              />
            )}
          </Segment>
          <Grid columns="equal" className="vnSummaryLines">
            <Grid.Row>
              <Grid.Column><b>{t('Unit Selling Price')}</b></Grid.Column>
              <Grid.Column textAlign="right">
                <b>{formatMajorAmount(unitDetails.spaValue, VN_CURRENCY_CODE)}</b>
              </Grid.Column>
            </Grid.Row>
            {lines.map((line, idx) => (
              <Grid.Row key={line.id || idx}>
                <Grid.Column>
                  <b>{line.name}</b>
                  {line.description ? <span><br /><small>{line.description}</small></span> : null}
                </Grid.Column>
                <Grid.Column textAlign="right">
                  {this.vnSignedAmount(line.calculationType, line.valueChange)}
                </Grid.Column>
              </Grid.Row>
            ))}
            <Grid.Row>
              <Grid.Column><b>{t('Total Selling Price')}</b></Grid.Column>
              <Grid.Column textAlign="right">
                <b>{formatMajorAmount(total !== null ? total : booking.spaValue, VN_CURRENCY_CODE)}</b>
              </Grid.Column>
            </Grid.Row>
            {feePackage && (
              <Grid.Row>
                <Grid.Column>
                  <b>{t('Additional Package')}</b>
                  <br />
                  <small>{selectedUnitFeePackage.projectFeePackage.name}</small>
                  {feeItems.map((item, idx) => (
                    <span key={item.id || idx}>
                      <br />
                      <small>{item.description ? `${item.name} - ${item.description}` : item.name}</small>
                    </span>
                  ))}
                </Grid.Column>
                <Grid.Column textAlign="right">
                  {this.vnSignedAmount('add', feePackage.totalPrice)}
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </div>
      </Segment>
    );
  }
  handleCheckIsPreview = () => {
    if (!this.state.isPreviewing) {
      Promise.all([
        this.getPackagePricingCalculation(),
        this.getFeePackageBreakdown(),
      ]).then(() => {
        this.setState({ isPreviewing: true });
      });
    } else {
      this.setState({ isPreviewing: false });
    }
  }
  renderBookingSummary = () => {
    const { t } = this.props;
    const { booking, projectUnitDetails, identity, newPPI, newBFP, globalSettings, project } = this.state;
    const unitPackagePricings = projectUnitDetails ? projectUnitDetails.projectUnitPackagePricings : [];
    const selectedUnitPackagePricing = unitPackagePricings ? unitPackagePricings.find(data => data.id === booking.unitPackagePricingID) : null;

    const listCalculations = newPPI.packagePricing && newPPI.packagePricing.calculations && newPPI.packagePricing.calculations.length > 0
    ? newPPI.packagePricing.calculations.filter(ppc => ppc.category === 'list_price') : [];
    const spaCalculations = newPPI.packagePricing && newPPI.packagePricing.calculations && newPPI.packagePricing.calculations.length > 0
    ? newPPI.packagePricing.calculations.filter(ppc => ppc.category === 'spa_price') : [];

    const unitFeePackages = projectUnitDetails ? projectUnitDetails.projectUnitPackageFees : [];
    const selectedUnitFeePackage = unitFeePackages ? unitFeePackages.find(data => data.id === booking.unitPackageFeeID) : null;
    return (
      <Segment padded className="bookingSummaryContainer">
        <Button icon type="button" onClick={this.handleCheckIsPreview} floated="right" style={{ padding: '0', background: 'none' }}>
          <Icon name="close" />
        </Button>
        <div className="bookingSummary">
          <Header textAlign="center">{t('Booking Summary')}</Header>
          <Divider />
          <Grid columns="equal" className="personalInfo">
            <Grid.Row>
              <Grid.Column><b>{`${t('Purchaser Full Name')} :`}</b></Grid.Column>
              <Grid.Column>{booking.name || '-'}</Grid.Column>
              <Grid.Column><b>{this.getIdentityType()}</b></Grid.Column>
              <Grid.Column textAlign="right">{identity || '-'}</Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column><b>{`${t('Project')} :`}</b></Grid.Column>
              <Grid.Column>{projectUnitDetails.projectName ? projectUnitDetails.projectName : '-'}</Grid.Column>
              <Grid.Column><b>{`${t('Unit')} :`}</b></Grid.Column>
              <Grid.Column textAlign="right">{projectUnitDetails.reference ? projectUnitDetails.reference : '-'}</Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
          <Grid columns="equal">
            <Grid.Row>
              <Grid.Column width={8}>
                <b>
                  {`${t('Pricing Package')} : ${selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.name : t('Base Selling Price')}`}
                </b>
                <br />
                <small>{ selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.description : ''}</small>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <b>
                  {
                    globalSettings && globalSettings.unitSellingPrice
                      ? globalSettings.unitSellingPrice
                      : t('Unit Selling Price')
                  }
                </b>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <b>
                  <LoanAmount
                    format="0,000,000.00"
                    amount={projectUnitDetails.spaValue}
                    prefix={<CurrencySymbol />}
                  />
                </b>
              </Grid.Column>
            </Grid.Row>
            {
              selectedUnitPackagePricing && selectedUnitPackagePricing.isCustomPrice ? (
                <Grid.Row>
                  <Grid.Column>
                    <b>{selectedUnitPackagePricing.customName}</b>
                    <br />
                    <small>{selectedUnitPackagePricing.customDescription}</small>
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    <LoanAmount
                      format="0,000,000.00"
                      amount={selectedUnitPackagePricing.totalPrice ? selectedUnitPackagePricing.totalPrice.toFixed(2) : '0.00'}
                      prefix={<CurrencySymbol />}
                    />
                  </Grid.Column>
                </Grid.Row>
              ) : null
            }
            {
              listCalculations.map((data, idx) => {
                const customFormulaType = this.customFormulaTypeConverter(newPPI.packagePricing.totalPrice || 0);
                return (
                  <Grid.Row key={idx}>
                    {
                      data.isSubTotal ? (
                        <Grid.Column><b>{t('Sub Total')}</b></Grid.Column>
                      ) : (
                        <Grid.Column><b>{data.name}</b><br /> <small>{data.description}</small></Grid.Column>
                      )
                    }
                    <Grid.Column textAlign="right">
                      <LoanAmount
                        format="0,000,000.00"
                        amount={data.newValue ? data.newValue.toFixed(2) : '0.00'}
                        prefix={<CurrencySymbol />}
                      />
                      <br />
                      {
                        !data.isSubTotal && (
                          <small>
                            {
                              this.renderFormulaChangePrefix(
                                data.calculationType === 'custom_formula'
                                  ? customFormulaType
                                  : data.calculationType,
                              )
                            }
                          </small>
                        )
                      }
                      {
                        !data.isSubTotal && (
                          <small
                            className={`
                              div_inline_block
                              ${this.renderFormulaChangeClass(
                                data.calculationType === 'custom_formula'
                                ? customFormulaType
                                : data.calculationType,
                              )}
                            `}
                          >
                            <LoanAmount
                              format="0,000,000.00"
                              amount={data.valueChange ? data.valueChange.toFixed(2) : '0.00'}
                              prefix={<CurrencySymbol />}
                            />
                            <br />
                          </small>
                        )
                      }
                    </Grid.Column>
                  </Grid.Row>
                );
              })
            }
            <Grid.Row>
              <Grid.Column>
                <b>
                  {
                    selectedUnitPackagePricing ?
                    'Total Selling Price SPA'
                    : (
                      t(booking.unitPackagePricingID === projectUnitDetails.spaValue ?
                      'Total Selling Price SPA'
                      : 'Selling Price SPA')
                    )
                  }
                </b>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <b>
                  <LoanAmount
                    format="0,000,000.00"
                    amount={newPPI.packagePricing ? newPPI.packagePricing.spaPrice.toFixed(2) : booking.spaValue}
                    prefix={<CurrencySymbol />}
                  />
                </b>
              </Grid.Column>
            </Grid.Row>
            {
              spaCalculations.map((data, idx) => {
                const customFormulaType = this.customFormulaTypeConverter(newPPI.packagePricing.totalPrice || 0);
                return (
                  <Grid.Row key={idx}>
                    {
                      data.isSubTotal ? (
                        <Grid.Column><b>{t('Sub Total')}</b></Grid.Column>
                      ) : (
                        <Grid.Column><b>{data.name}</b><br /> <small>{data.description}</small></Grid.Column>
                      )
                    }
                    <Grid.Column textAlign="right">
                      <LoanAmount
                        format="0,000,000.00"
                        amount={data.newValue ? data.newValue.toFixed(2) : '0.00'}
                        prefix={<CurrencySymbol />}
                      />
                      <br />
                      {
                        !data.isSubTotal && (
                          <small>
                            {
                              this.renderFormulaChangePrefix(
                                data.calculationType === 'custom_formula'
                                  ? customFormulaType
                                  : data.calculationType,
                              )
                            }
                          </small>
                        )
                      }
                      {
                        !data.isSubTotal && (
                          <small
                            className={`
                              div_inline_block
                              ${this.renderFormulaChangeClass(
                                data.calculationType === 'custom_formula'
                                ? customFormulaType
                                : data.calculationType,
                              )}
                            `}
                          >
                            <LoanAmount
                              format="0,000,000.00"
                              amount={data.valueChange ? data.valueChange.toFixed(2) : '0.00'}
                              prefix={<CurrencySymbol />}
                            />
                            <br />
                          </small>
                        )
                      }
                    </Grid.Column>
                  </Grid.Row>
                );
              })
            }
            {
              this.hasAccessNettSellingPrice(project) ? (
                <Grid.Row>
                  <Grid.Column><b>{t('Nett Selling Price')}</b></Grid.Column>
                  <Grid.Column textAlign="right">
                    <b>
                      <LoanAmount
                        format="0,000,000.00"
                        amount={newPPI.packagePricing ? newPPI.packagePricing.totalPrice.toFixed(2) : newPPI.nettSellingPrice}
                        prefix={<CurrencySymbol />}
                      />
                    </b>
                  </Grid.Column>
                </Grid.Row>
              ) : ''
            }
          </Grid>
          {selectedUnitFeePackage && newBFP && newBFP.packageFee && <Divider />}
          {
            selectedUnitFeePackage && newBFP && newBFP.packageFee ? (
              <Grid columns="equal">
                <Grid.Row>
                  <Grid.Column width={8}>
                    <b>
                      Additional Fee Package : { selectedUnitFeePackage ? selectedUnitFeePackage.projectFeePackage.name : 'Base Selling Price'}
                    </b>
                    <br />
                    <small>{ selectedUnitFeePackage ? selectedUnitFeePackage.projectFeePackage.description : ''}</small>
                  </Grid.Column>
                </Grid.Row>
                {
                  newBFP.packageFee.items.map((data, idx) => (
                    <Grid.Row key={idx}>
                      <Grid.Column><b>{data.name}</b><br /> <small>{data.description}</small></Grid.Column>
                      <Grid.Column textAlign="right">
                        <LoanAmount
                          format="0,000,000.00"
                          amount={data.valueChange ? data.valueChange.toFixed(2) : '0.00'}
                          prefix={<CurrencySymbol />}
                        />
                        <br />
                        <small>
                          <Icon color="green" size="small" name="plus" />
                        </small>
                        <small className="div_inline_block text_add">
                          <LoanAmount
                            format="0,000,000.00"
                            amount={data.valueChange ? data.valueChange.toFixed(2) : '0.00'}
                            prefix={<CurrencySymbol />}
                          />
                          <br />
                        </small>
                      </Grid.Column>
                    </Grid.Row>
                  ))
                }
                <Grid.Row>
                  <Grid.Column><b>Total Additional Fee</b></Grid.Column>
                  <Grid.Column textAlign="right">
                    <b>
                      <LoanAmount
                        format="0,000,000.00"
                        amount={newBFP.packageFee ? newBFP.packageFee.totalPrice.toFixed(2) : 0}
                        prefix={<CurrencySymbol />}
                      />
                    </b>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            ) : null
          }
        </div>
      </Segment>
    );
  }
  checkIsEmailRequired = () => {
    const { projectCustomFields } = this.state;
    const { auth } = this.props;
    // CPI-976: purchaser email always mandatory for Vietnam (mirrors Overview/Purchaser.jsx).
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) return true;
    if (projectCustomFields && projectCustomFields.length > 0 && projectCustomFields.filter(p => p.name === 'email').length > 0) {
      return projectCustomFields.find(p => p.name === 'email').isRequired;
    }
    return false;
  }
  getEmailValidation = () => {
    const emailValidation = [email];
    if (this.checkIsEmailRequired()) {
      emailValidation.push(required);
    }
    return emailValidation;
  }
  toUppercaseFormat = (val) => {
    const { appConfig } = this.props;
    const uppercasePurchaserInfoIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.uppercasePurchaserInfoIsEnabled;
    return uppercasePurchaserInfoIsEnabled && val && typeof val === 'string' ? val.toUpperCase() : val;
  }
  toUppercaseOptions = opts => opts.map(opt => ({
    ...opt,
    text: this.toUppercaseFormat(opt.text),
  }))
  render() {
    const { auth, appConfig, t } = this.props;
    const {
      isLaunchMode,
      paymentMethods,
      projectUnitDetails,
      projectAllowLinkBuyerApp,
      reservedTimeoutExpireAt,
      searchUserValue,
      showCountdown,
      showPurchaserExtraFields,
      showLaunchModeMulti,
      launchModeMultiErr,
      heldUnit,
      isPreviewing,
      project,
      projectCustomFields,
      screenWidth,
    } = this.state;
    const { user } = auth;
    const packagePricings = this.vnApplyLivePackageTotals(this.filterPackingPricing(this.state.packagePricings));
    const defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
    const feePackages = this.filterFeePackages(this.state.feePackages);
    const showAutofill = this.hasAutofillAccess();
    const paymentMethodOptions = this.state.booking.linkBuyerApp ? paymentMethods.filter(m => m.value === 'referred_banker' || m.value === 'own_banker') : paymentMethods;
     // add validateRef for all custom fields
    if (projectCustomFields && projectCustomFields.length > 0) {
      projectCustomFields.filter(f => PURCHASER_CUSTOM_FIELDS.some(pf =>
      f.name !== pf.name && !f.isHidden)).forEach((pcf) => {
        this.validation[pcf.name] = createRef();
      });
    }
    const himsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled && project && project.himsIsEnabled;
    const enabledAddressSettings = this.props.addressSettings.data.filter(as => as.enabled);
    const isBCustomerMalaysia = this.state.booking.country.toUpperCase() === 'MY';
    const isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    const isVietnam = auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    const hideLabel = isIndonesia || this.state.isForeignCompany;
    const inputs = enabledAddressSettings.map((as, idx) => {
      const key = _.camelCase(as.columnName);
      let addressLabel = as.label.toLowerCase();
      let isRequired = as.required;
      let errMessage = null;
      const validations = [{
        validate: stringLength,
        option: {
          max: 256,
        },
      }];

      // When company is Vietnam: apply country-dependent logic for state field
      if (isVietnam && addressLabel === 'state') {
        if (isBCustomerMalaysia) {
          // Malaysia selected: keep as "State", required
          isRequired = true;
        } else {
          // Non-Malaysia selected: change to "City/Province", optional
          addressLabel = 'cityOrProvince';
          isRequired = false;
        }
      } else if (isVietnam && addressLabel === 'city' && !isBCustomerMalaysia) {
        addressLabel = 'ward';
        isRequired = false;
      } else if (isVietnam && addressLabel === 'postcode' && !isBCustomerMalaysia) {
        addressLabel = 'postalCode';
        isRequired = false;
      }
      if (isRequired) {
        validations.push(required);
      }
      if (!himsIsEnabled && isBCustomerMalaysia && as.label.toLowerCase() === 'postcode') {
        validations.push({
          validate: matchRegex,
          option: {
            validRegex: REGEX_POSTCODE_MY,
          },
        });
        errMessage = 'Invalid MY postcode format';
      }

      const label = `${translateModels(t, addressLabel, 'booking')}${isRequired ? '*' : ''}`;

      if (!isPRS && isBCustomerMalaysia && as.label.toLowerCase() === 'state') {
        return (
          <AppForm.Validate
            key={idx}
            validation={isRequired ? [required] : null}
            ref={this.validation[key]}
            onChange={this.handleSelectChange}
            validateLabel={as.label.toLowerCase() === 'state' ? translateModels(t, 'state', 'booking') : as.label}
          >
            <Form.Select
              name={key}
              disabled={this.isVNFormLocked()}
              fluid
              options={this.toUppercaseOptions(STATES)}
              placeholder={t('Select {{title}}', { title: label.toLowerCase() })}
              label={label}
              search
              selectOnBlur={false}
              value={this.state.booking[key]}
            />
          </AppForm.Validate>
        );
      }

      if (himsIsEnabled && isBCustomerMalaysia && as.label.toLowerCase() === 'postcode') {
        return (
          <SearchHimsPostcodes
            validateRef={this.validation.himsKodPoskod}
            name="himsKodPoskod"
            onSelect={this.handleSelectHimsPostcode}
            state={this.state.booking.address7}
            value={this.state.booking.himsKodPoskod}
          />
        );
      }

      return (
        <AppForm.Input
          key={idx}
          autoComplete="off"
          disabled={this.isVNFormLocked()}
          name={key}
          onChange={this.handleInputChange}
          placeholder={label}
          label={label}
          ref={this.validation[key]}
          validation={validations}
          value={this.state.booking[key]}
          validateLabel={label}
          message={errMessage}
        />
      );
    });
    inputs.push((
      <AppForm.Validate
        key="inputs_country"
        validation={[required]}
        ref={this.validation.country}
        onChange={(e, data) => {
          // Reset state input field
          if (!isPRS) {
            const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
            if (as) {
              const key = _.camelCase(as.columnName);
              const { booking } = this.state;
              if (booking[key]) {
                booking[key] = '';
                this.setState({ booking });
              }
            }
          }
          this.handleSelectChange(e, data);
        }}
        validateLabel={translateModels(t, 'country', 'booking')}
      >
        <Form.Select
          autoComplete="off"
          disabled={this.isVNFormLocked()}
          fluid
          label={`${translateModels(t, 'country', 'booking')}*`}
          name="country"
          options={this.toUppercaseOptions(SELECT_COUNTRIES)}
          placeholder={`${t('Select {{title}}', { title: translateModels(t, 'country', 'booking') })}*`}
          search
          selectOnBlur={false}
          value={this.state.booking.country}
        />
      </AppForm.Validate>
    ));
    // CPI-1248: Citizenship on the reservation form, Vietnam only. Both VN rules - the Local unit
    // restriction and the foreign control threshold - are decided on this value at create time,
    // and nothing re-runs them afterwards, so it has to be confirmed before Save and Continue
    // rather than inherited invisibly from the CRM. The Booking ID lookup still prefills it; the
    // user can correct it, and a blank one can no longer be submitted. `nationality` is a separate
    // field and is never a substitute for this declaration.
    if (isVietnam) {
      inputs.push((
        <AppForm.Validate
          key="inputs_citizenship"
          validation={[required]}
          ref={this.validation.citizenship}
          onChange={this.handleSelectChange}
          validateLabel={t('Citizenship')}
        >
          <Form.Select
            autoComplete="off"
            disabled={this.isVNFormLocked()}
            fluid
            label={`${t('Citizenship')}*`}
            name="citizenship"
            options={this.toUppercaseOptions([
              { text: t('Local'), value: CITIZENSHIP_LOCAL },
              { text: t('Foreigner'), value: CITIZENSHIP_FOREIGNER },
            ])}
            placeholder={`${t('Select {{title}}', { title: t('Citizenship') })}*`}
            selectOnBlur={false}
            value={this.state.booking.citizenship}
          />
        </AppForm.Validate>
      ));
    }
    const constructIdentityTypeDropdown = () => (
      isPRS ? (
        <AppForm.Input
          loading={this.state.loaders.searchingID}
          autoComplete="off"
          name="prsID"
          onChange={this.handlePRSIDChange}
          placeholder={`${t('PRS ID')}*`}
          ref={this.validation.prsID}
          readOnly={this.state.identityLock}
          validation={[required, {
            validate: stringLength,
            option: {
              min: 13,
            },
          }]}
          value={this.state.prsID}
          validateLabel={t('PRS ID')}
        />
      ) : (
        <Dropdown
          disabled={this.state.identityLock || this.state.loaders.searchingID || this.state.booking.linkBuyerApp || this.isVNFormLocked()}
          fluid
          name="identityType"
          onChange={this.handleIDTypeChange}
          options={this.toUppercaseOptions(this.state.identityTypeOpts)}
          placeholder={`${t('Select {{title}}', { title: t('Identity Type') })}*`}
          selection
          selectOnBlur={false}
          value={this.state.identityType}
        />
      )
    );
    const constructIdentityInput = () => (
      <Input
        className={`ui input
          ${this.isLoading('searchingID') || this.state.vnCRMLookup === 'searching' ? 'loading circle notched icon ' : ''}
          ${this.hasResetIdentityIcon() ? 'icon ' : ''}
          ${this.state.identityError ? ' error' : ''}`}
        label={this.getIdentityInputLabel(hideLabel)}
        disabled={this.state.identityType === '' || this.state.loaders.searchingID || this.isVNFormLocked()}
        name="identity"
        placeholder={`${t(this.getIdentityPlaceholder(isIndonesia))}`}
        readOnly={this.state.identityLock}
        inputRef={this.identityInputRef}
        type={this.state.identityType === 1 ? 'tel' : 'text'}
        value={this.state.identity}
        icon={
          this.hasResetIdentityIcon() ? <Icon
            link
            name="x"
            onClick={this.handleResetAutofill}
            title={t('Clear Form')}
          /> : (this.isLoading('searchingID') || this.state.vnCRMLookup === 'searching') ?
            <Icon loading name="circle notch" /> : null
        }
        validation={[required, {
          validate: validateIdentity,
          option: this.identityValidation(),
        }]}
        ref={this.validation.identity}
        onChange={this.handleIdentityChange}
        validateLabel={t(isPRS ? 'NRIC Number' : 'Identity')}
        onError={(identityError) => { this.setState({ identityError }); }}
      />
    );
    const constructTinInput = () => {
      const mustValidTinForMY = !isIndonesia && this.state.identityType !== 2 && ((this.state.identityType === 4) || (this.state.project && this.state.project.requireValidTinAtBookingCreation));

      let tinValidation = [];
      if (isIndonesia) {
        tinValidation = [{
          validate: matchRegex,
          option: {
            validRegex: REGEX_NPWP_ID,
          },
        }];
      } else {
        tinValidation = mustValidTinForMY && !this.state.isForeignCompany ? [required, {
          validate: matchRegex,
          option: { validRegex: REGEX_TIN_VALID },
        }] : [{
          validate: matchRegex,
          option: { validRegex: REGEX_TIN_VALID },
        }];
      }

      return (
        <TinFieldInput
          isIndonesia={isIndonesia}
          value={this.state.taxIdentificationNo}
          errMessage={this.state.tinMessage}
          isLoading={this.isLoading('validatingTIN')}
          tinError={isMalaysia && this.state.tinError}
          required={isMalaysia && mustValidTinForMY && !this.state.isForeignCompany}
          validation={tinValidation}
          ref={this.validation.taxIdentificationNo}
          onChange={this.handleTinInput}
          identityType={this.state.identityType}
          identityValue={this.state.identity}
          // readOnly={isMalaysia && this.state.tinFound}
          unitID={this.state.projectUnitID}
        />
      );
    };
    const isForeignCompanyCheckbox = () => (
      <div style={{ display: 'flex', justifyContent: 'start', marginTop: '1em' }}>
        <Checkbox
          label={t('Foreign Company', { ns: TRANSLATION_FILES.screens })}
          onChange={(e, d) => {
            const setStateTin = d.checked ? FOREIGN_BUYER_GENERIC_TIN : '';
            this.setState(prevState => ({
              booking: {
                ...prevState.booking,
                taxIdentificationNo: setStateTin,
                isForeignCompany: d.checked,
              },
              taxIdentificationNo: setStateTin,
              isForeignCompany: d.checked,
            }), () => {
              this.handleTinInput({ target: { value: d.checked ? setStateTin : '', tinFound: false } });
            });
          }}
          checked={this.state.isForeignCompany}
        />
      </div>
    );
    const isMobile = screenWidth <= 767;
    const isTablet = screenWidth > 767 && screenWidth <= 991;
    const isComputer = screenWidth > 991;
    const constructResponsiveIdentityTinInputs = () => (
      <React.Fragment>
        {/* display only on mobile */}
        {isMobile && <Grid.Row columns={1} centered>
          <Grid.Column style={{ marginBottom: this.getIdentityInputLabel(hideLabel) ? '1rem' : '1.5rem' }}>
            {constructIdentityTypeDropdown()}
            {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox()}
          </Grid.Column>
          <Grid.Column textAlign="left" style={{ marginBottom: '1rem' }}>
            {constructIdentityInput()}
          </Grid.Column>
          <Grid.Column>
            {(isMalaysia || isIndonesia) && constructTinInput()}
          </Grid.Column>
        </Grid.Row>}

        {/* display only on tablet */}
        {isTablet && <Grid.Row columns={3} centered>
          <Grid.Column style={{ marginTop: this.getIdentityInputLabel(hideLabel) ? '2.2rem' : '1.9rem' }}>
            {constructIdentityTypeDropdown()}
            {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox()}
          </Grid.Column>
          <Grid.Column textAlign="left" style={{ marginTop: this.getIdentityInputLabel(hideLabel) ? '0.1rem' : '1.9rem' }}>
            {constructIdentityInput()}
          </Grid.Column>
          <Grid.Column style={{ marginTop: this.getIdentityInputLabel(hideLabel) ? '1.3rem' : '0rem' }}>
            {(isMalaysia || isIndonesia) && constructTinInput()}
          </Grid.Column>
        </Grid.Row>}

        {/* display only on computer */}
        {isComputer && <Grid.Row columns={3} centered>
          <Grid.Column style={{ marginTop: '1.9rem' }}>
            {constructIdentityTypeDropdown()}
            {(isMalaysia && this.state.identityType === IDENTITY_TYPE_BRN) && isForeignCompanyCheckbox()}
          </Grid.Column>
          <Grid.Column textAlign="left" style={{ marginTop: this.getIdentityInputLabel(hideLabel) ? '0.1rem' : '1.9rem' }}>
            {constructIdentityInput()}
          </Grid.Column>
          <Grid.Column>
            {(isMalaysia || isIndonesia) && constructTinInput()}
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    );

    return (
      <AppForm
        error={this.state.errMessages.length > 0}
        onSubmit={this.handleSubmit}
        ref={(ref) => { this.form = ref; }}
      >
        <BookingSwapUnit
          open={this.state.showSwapUnit}
          onClose={this.handleCancelChange}
          onConfirm={this.handleConfirmChange}
          projectUnitClear={this.handleProjectUnitClear}
          projectUnitSelect={this.handleProjectUnitSelect}
          projectUnitselectedValue={this.state.selectedProjectUnit}
          projectID={this.state.projectID}
          hasAccess={this.hasUnitSwapAccess()}
          error={this.state.projectUnitSwapError || false}
          manualSwap={this.state.manualSwap}
        />
        <Modal open={this.state.modalReservationIsOpen} basic size="small" closeOnDimmerClick={false} closeOnDocumentClick={false}>
          <Header icon="warning sign" content={t('Reservation Limit Exceeded')} />
          <Modal.Content>
            <p>
              {`${t(
                'Your business unit has reached it\'s reservation limit of {{limit}}. Please contact {{company}}',
                {
                  limit: user && user.affiliate && user.affiliate.companyBranch ? user.affiliate.companyBranch.reservationLimit : 0,
                  company: user && user.affiliate && user.affiliate.company ? user.affiliate.company.name : '',
                },
              )}.`}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              inverted
              onClick={this.handleModalReservationClose}
            >
              {t('Okay', { ns: TRANSLATION_FILES.translation })}
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal size="small" open={showLaunchModeMulti} onClose={this.handleCloseLaunchModeMultiModal}>
          <Header icon="warning sign" content={t('Error', { ns: TRANSLATION_FILES.translation })} />
          <Modal.Content>
            <Modal.Description>{launchModeMultiErr}</Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            {(heldUnit && heldUnit.heldUnitID) ?
              <span>
                <Button
                  onClick={(e) => { e.preventDefault(); this.handleGoBackToHeldUnit(); }}
                  content={t('Go back to {{reference}}', { reference: heldUnit.heldUnitReference, ns: TRANSLATION_FILES.translation })}
                />
                <Button
                  color="green"
                  onClick={(e) => { e.preventDefault(); this.handleReleaseHeldUnitAndContinue(); }}
                  content={t('Release {{reference}} and continue', { reference: heldUnit.heldUnitReference, ns: TRANSLATION_FILES.translation })}
                />
              </span>
              :
              <Button
                onClick={this.handleCloseLaunchModeMultiModal}
                content={t('Close', { ns: TRANSLATION_FILES.translation })}
              />
            }
          </Modal.Actions>
        </Modal>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {(isLaunchMode && reservedTimeoutExpireAt) &&
                <Message size="mini" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                  {showCountdown ?
                    <span>
                      {t('Time remaining')}&nbsp;
                      <Countdown
                        targetDate={
                          moment(reservedTimeoutExpireAt).toDate()
                        }
                        timeSeparator={' '}
                        onFinished={this.handleCountdownFinish}
                        format={
                          this.getCountdownFormat(
                            projectUnitDetails.reservedTimeoutExpireAt,
                          )
                        }
                        leadingZero
                      />
                      &nbsp;
                      <button
                        className="a-button-blue"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleClearTimer();
                        }}
                      >
                        <u>{t('Cancel and release unit')}</u>
                      </button>
                    </span>
                    : t('Unit now available for all')
                  }
                  <br />
                  <small>
                    You will be redirected to the unit selection page once the countdown ends.
                    {(this.hasAccessIsExternalAgent() && project.bapIsEnabled) ? <br /> : ''}
                    {(this.hasAccessIsExternalAgent() && project.bapIsEnabled) ? `Abuse prevention has been turned on. You may lock this unit for a maximum of ${project.bapMaxAttempts} attempts within ${project.bapWindowMinutes} mins. Failure to complete a ${defaultBookingStatus === 'reserved' ? 'reservation' : 'booking'} will result in a ${project.bapIsProjectMode ? 'project-wide' : ''} ban for ${project.bapCooldownMinutes} mins.` : ''}
                  </small>
                </Message>
              }
              <Segment padded>
                <Dimmer style={{ zIndex: 20 }} active={this.isLoading('isFetching')} inverted>
                  <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                </Dimmer>
                { (projectUnitDetails.reference &&
                  projectUnitDetails.projectName
                  ) ?
                    <div>
                      <Header textAlign="center">
                        {t(isVietnam ? 'Unit selection for' : 'Booking for')} <br className="large-hide small-hide tablet-hide" />
                        <button
                          className="a-button-blue"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleShowSwapUnit();
                          }}
                        >
                          {projectUnitDetails.reference}
                        </button>
                        , {projectUnitDetails.projectName}
                        {projectUnitDetails.isBumi &&
                          <Label size="mini">{unitQuotaChipLabel(auth, t)}</Label>}
                        <Header.Subheader>
                          <button
                            className="a-button-blue"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleShowSwapUnit();
                            }}
                          >
                            {t('Change Unit')}
                          </button>
                        </Header.Subheader>
                      </Header>
                      <Divider />
                    </div>
                  : ''
                }
                {
                  project && (project.paymentFlow || project.loanTrackerDirectShow) ?
                    <BookingSteppers
                      totalSteps={project.paymentFlow && project.loanTrackerDirectShow ? 3 : 2}
                      lastStepLabel={t(project.paymentFlow && !project.loanTrackerDirectShow ? 'Payment' : 'Mortgage')}
                    />
                  : <Header textAlign="center" size="small" style={{ marginTop: '1rem' }}>{t('Purchaser')}</Header>
                }
                <br />
                <Grid>
                  {isVietnam && this.renderBookingIDSearch()}
                  {constructResponsiveIdentityTinInputs()}
                  <Grid.Row centered>
                    { projectAllowLinkBuyerApp &&
                      <Grid.Column width={16}>
                        <Form.Checkbox
                          style={{ margin: '1rem 0' }}
                          label={
                            <label htmlFor="linkBuyerApp">
                              {translateModels(t, 'linkBuyerApp', 'booking')}
                              <Popup
                                wide="very"
                                hoverable
                                trigger={<Icon name="info circle" color="blue" />}
                              >
                                {t('Buyer can perform Credit Check, Loan Selection, and keep track of their booking on Buyer App. More info on', { ns: TRANSLATION_FILES.screens })} <a href="https://apps.mhub.my/buyer/" target="_blank" rel="noopener noreferrer">https://apps.mhub.my/buyer/</a>
                              </Popup>
                            </label>
                          }
                          name="linkBuyerApp"
                          checked={this.state.booking.linkBuyerApp}
                          onChange={this.handleLinkBuyerAppCheck}
                        />
                      </Grid.Column>
                    }
                    {isVietnam && this.renderBookingIDNotices()}
                    {showAutofill && this.state.showNoAutofill &&
                      <Grid.Column width={16}>
                        <Segment secondary>
                          <b>
                            {
                              isPRS ?
                              this.state.fetchDataErrorMessage :
                              `${t('No existing details found')}.`
                            }
                          </b>
                        </Segment>
                      </Grid.Column>
                    }
                    {showAutofill && (!isPRS && (this.state.autofillOptions && this.state.autofillOptions.length > 0)) &&
                      <Grid.Column width={16}>
                        <Segment secondary>
                          <b>{t('Customer details found')}. &nbsp;</b><br className="large-hide small-hide" />
                          {
                            (this.state.autofillOptions && this.state.autofillOptions.length > 0) && (
                              <Dropdown
                                trigger={(
                                  <button
                                    className="a-button-blue"
                                    onClick={e => e.preventDefault()}
                                  >
                                    {t('Autofill')}
                                  </button>
                                )}
                                /* options={this.state.autofillOptions} */
                              >
                                <Dropdown.Menu>
                                  <Dropdown.Header content={t('Autofill from')} />
                                  {this.state.autofillOptions.map(item => <Dropdown.Item {...item} />)}
                                </Dropdown.Menu>
                              </Dropdown>
                            )
                          }
                        </Segment>
                      </Grid.Column>
                    }
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <Form.Group widths="equal">
                        {
                          this.state.hideTitle ? null : (
                            <AppForm.Validate
                              validation={[required]}
                              ref={this.validation.title}
                              onChange={this.handleSelectChange}
                              validateLabel={translateModels(t, 'title', 'booking')}
                            >
                              <Form.Select
                                disabled={this.isVNFormLocked()}
                                label={`${translateModels(t, 'title', 'booking')}*`}
                                name="title"
                                onChange={this.handleSelectChange}
                                options={this.toUppercaseOptions(CUSTOMER_TITLES)}
                                placeholder={`${t('Select {{title}}', { title: translateModels(t, 'title', 'booking') })}*`}
                                search
                                selectOnBlur={false}
                                value={this.state.booking.title}
                              />
                            </AppForm.Validate>
                          )
                        }
                        <AppForm.Input
                          autoComplete="off"
                          disabled={this.isVNFormLocked()}
                          label={`${t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}*`}
                          name="name"
                          onChange={this.handleInputChange}
                          placeholder={`${t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}*`}
                          ref={this.validation.name}
                          validation={[required, ...vnFullNameValidations(auth, this.state.identityType, t)]}
                          value={this.state.booking.name}
                          validateLabel={t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')}
                        />
                        <AppForm.Input
                          autoComplete="off"
                          disabled={this.isVNFormLocked()}
                          label={`${t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}*`}
                          name="preferredName"
                          onChange={this.handleInputChange}
                          placeholder={`${t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}*`}
                          ref={this.validation.preferredName}
                          validation={
                            this.state.identityType === 4
                              ? [required, ...vnPreferredNameValidations(auth, t)]
                              : [
                                required,
                                {
                                  validate: stringLength,
                                  option: {
                                    max: 15,
                                  },
                                },
                                ...vnPreferredNameValidations(auth, t),
                              ]
                          }
                          value={this.state.booking.preferredName}
                          validateLabel={t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')}
                        />
                        <AppForm.Input
                          autoComplete="off"
                          disabled={this.isVNFormLocked()}
                          label={`${translateModels(t, 'email', 'booking')}${this.checkIsEmailRequired() ? '*' : ''}`}
                          name="email"
                          type="email"
                          onChange={this.handleInputChange}
                          placeholder={translateModels(t, 'email', 'booking')}
                          validation={this.getEmailValidation()}
                          validateLabel={translateModels(t, 'email', 'booking')}
                          ref={this.validation.email}
                          value={this.state.booking.email}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <AppForm.Validate
                          validation={[required]}
                          ref={this.validation.mobilePrefix}
                          onChange={this.handleSelectChange}
                          validateLabel={translateModels(t, 'mobilePrefix', 'booking')}
                        >
                          <Form.Select
                            label={`${translateModels(t, 'mobilePrefix', 'booking')}*`}
                            name="mobilePrefix"
                            disabled={this.state.mobileLock || this.isVNFormLocked()}
                            onChange={this.handleSelectChange}
                            options={this.toUppercaseOptions(INTL_CALL_CODES)}
                            search
                            selectOnBlur={false}
                            value={this.state.booking.mobilePrefix}
                          />
                        </AppForm.Validate>
                        <PhoneInput
                          className={`ui fluid
                            ${this.state.booking.mobilePrefix}
                            ${this.isLoading('searchingIDByMobile') ? 'loading icon ' : ''}
                            ${this.hasResetMobileIcon() ? 'icon ' : ''}input
                          `}
                          autoComplete="off"
                          icon={this.getPhoneInputIcon()}
                          iconPosition="right"
                          label={this.state.booking.mobilePrefix === '60' ? `${t('Mobile')}* (e.g. 196756118)` : `${t('Mobile')}*`}
                          name="mobile"
                          onChange={this.handleInputChange}
                          placeholder={this.state.booking.mobilePrefix === '60' ? `${t('Mobile')}* (e.g. 196756118)` : `${t('Mobile')}*`}
                          disabled={this.isVNFormLocked()}
                          prefix={this.state.booking.mobilePrefix}
                          readOnly={this.state.mobileLock}
                          ref={this.validation.mobile}
                          type="tel"
                          validation={[required, {
                            validate: phoneNumber,
                            option: this.state.booking.mobilePrefix === 'other' ? {} : {
                              isMobile: true,
                              phonePrefix: this.state.booking.mobilePrefix,
                              validRegex: getPhoneValidRegex(
                                this.state.phoneValidationPresets,
                                this.state.booking.mobilePrefix,
                                'mobile',
                              ),
                            },
                          }]}
                          value={this.state.booking.mobile}
                          validateLabel={t('Mobile')}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Select
                          disabled={this.isVNFormLocked()}
                          label={t('House/Office Phone prefix')}
                          name="phonePrefix"
                          onChange={this.handleSelectChange}
                          options={this.toUppercaseOptions(INTL_CALL_CODES)}
                          search
                          selectOnBlur={false}
                          value={this.state.booking.phonePrefix}
                        />
                        <PhoneInput
                          autoComplete="off"
                          disabled={this.isVNFormLocked()}
                          label={this.state.booking.phonePrefix === '60' ? `${t('House/Office Phone')} (e.g. 378317749)` : t('House/Office Phone')}
                          name="phone"
                          onChange={this.handleInputChange}
                          placeholder={this.state.booking.phonePrefix === '60' ? `${t('Phone')} (e.g. 378317749)` : t('Phone')}
                          prefix={this.state.booking.phonePrefix}
                          type="tel"
                          ref={!isPRS && this.validation.phone}
                          validation={isPRS ? null : [{
                            validate: phoneNumber,
                            option: this.state.booking.phonePrefix === 'other' ? {} : {
                              phonePrefix: this.state.booking.phonePrefix,
                              validRegex: getPhoneValidRegex(
                                this.state.phoneValidationPresets,
                                this.state.booking.phonePrefix,
                                'phone',
                              ),
                            },
                          }]}
                          value={this.state.booking.phone}
                          validateLabel={t('House/Office Phone')}
                        />
                      </Form.Group>
                      {
                        // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                        _.chunk(inputs, 2).map((p, idx) => (
                          <Form.Group widths="equal" key={`group_${idx}`}>
                            {p}
                          </Form.Group>
                        ))
                      }
                      {
                        himsIsEnabled && isBCustomerMalaysia ? (
                          <Form.Group widths="equal">
                            <SearchHimsDistricts
                              validateRef={this.validation.himsKodDaerah}
                              name="himsKodDaerah"
                              onSelect={this.handleSelectHimsDistrict}
                              state={this.state.booking.address7}
                              value={this.state.booking.himsKodDaerah}
                            />
                            <span style={{ flex: '1 1 auto', width: '100%' }} />
                          </Form.Group>
                        ) : null
                      }
                    </Grid.Column>
                  </Grid.Row>
                  { showPurchaserExtraFields &&
                    this.renderCustomFields(t, this.state.projectCustomFields.filter(c => c.isDefault), true)
                  }
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <Divider />
                      <Header textAlign="center" size="small">{t('Booking Details')}</Header>
                      {/* CPI-977 S3: the ticket's UI item reads "below above payment package
                          field" and its screenshot puts the tick above, so it goes above. The
                          Pricing Package dropdown shares its row with Selling Price, so "above
                          the field" means above that row. */}
                      <Form.Group widths="equal">
                        <AppForm.Input
                          disabled={!this.hasSPAValueAccess() || this.isVNFormLocked()}
                          fluid
                          label={translateModels(t, 'spaValue', 'booking')}
                          name="spaValue"
                          onChange={
                            this.hasSPAValueAccess() ?
                            this.handleInputChange :
                            () => {}
                          }
                          placeholder={`${translateModels(t, 'spaValue', 'booking')}*`}
                          ref={this.validation.spaValue}
                          type="number"
                          step=".01"
                          pattern="[0-9]*"
                          validation={[required]}
                          value={this.state.booking.spaValue}
                          validateLabel={translateModels(t, 'spaValue', 'booking')}
                        />
                        <AppForm.Validate
                          validation={isPackagePricingRequired || this.state.isRequirePricingSelection ? [required] : null}
                          ref={this.validation.unitPackagePricingID}
                          onChange={
                            this.hasPackagePricingAccess() ?
                              this.handleSelectChange :
                              () => { }
                          }
                          validateLabel={t('Pricing Package')}
                        >
                          <Form.Select
                            disabled={!this.hasPackagePricingAccess() || this.isVNFormLocked()}
                            className="ddPricingTierDropdown"
                            label={`${t('Pricing Package')}${isPackagePricingRequired || this.state.isRequirePricingSelection ? '*' : ''}`}
                            name="unitPackagePricingID"
                            options={packagePricings}
                            placeholder={t('Select {{title}}', { title: t('Pricing Package') })}
                            search
                            selectOnBlur={false}
                            value={this.state.booking.unitPackagePricingID}

                          />
                          {/* CPI-977 S1: why Save is dead. The field's own validation only speaks on
                              submit, and with Save disabled it never gets the chance. Rendered inside
                              the validate wrapper so it sits under the dropdown like a field error. */}
                          {this.isSaveBlockedByPricingPackage() && (
                            <AppForm.Helper type="error">{t('Pricing Package is required')}</AppForm.Helper>
                          )}
                        </AppForm.Validate>
                      </Form.Group>
                      {/* CPI-977 (PO, 14 Sep): the Nett Price / Deposit to collect panel is hidden for now;
                          renderVNPricePanel stays so it can be switched back on. */}
                      <Form.Group widths="equal">
                        <AppForm.Validate
                          validation={[required]}
                          ref={this.validation.paymentMethodID}
                          onChange={this.handleSelectChange}
                          validateLabel={translateModels(t, 'paymentMethodID', 'booking')}
                        >
                          <Form.Select
                            fluid
                            disabled={(isVietnam && !this.hasSourceOfFinanceEditAccess()) || this.isVNFormLocked()}
                            label={`${translateModels(t, 'paymentMethodID', 'booking')}*`}
                            name="paymentMethodID"
                            options={paymentMethodOptions.map(o => ({
                              ...o,
                              text: t(o.text, { ns: TRANSLATION_FILES.constants, defaultValue: o.text }),
                            }))}
                            placeholder={t('Select {{title}}', { title: `${translateModels(t, 'paymentMethodID', 'booking')}*` })}
                            selectOnBlur={false}
                            value={this.state.booking.paymentMethodID}
                          />
                          {this.state.booking.paymentMethodID === 'referred_banker' &&
                          (this.hasAccessIsExternalAgent() && project && project.hlbCampaignIsEnabled) && (
                            <div className="hlb-eligible-banner" style={{ marginTop: '0.5em' }}>
                              <img src={GiftBlueSvg} width={20} alt="gift" />
                              <span>
                                <strong>MHub Rewards: </strong>
                                Get RM10 when you choose Hong Leong Bank as your panel banker.
                              </span>
                            </div>
                          )}
                        </AppForm.Validate>
                        {
                          // CPI-977 mock-up: in Vietnam the waiver tick sits directly under the
                          // Additional Fee Package dropdown, inside the same column.
                          isVietnam ? (
                            <Form.Field>
                              {this.renderFeePackageSelect(t, feePackages)}
                              {this.renderVNBankGuaranteeWaiver(t)}
                            </Form.Field>
                          ) : this.renderFeePackageSelect(t, feePackages)
                        }
                      </Form.Group>
                      {/* CPI-977 (PO, 14 Sep): the inline Booking Summary is hidden for now - Vietnam does
                          not show pricing package details on the reservation form. renderVNBookingSummary
                          stays so it can be switched back on. */}
                      {
                        this.state.hideFirstTimeBuyer ? null : (
                          <Form.Group widths="2">
                            <AppForm.Validate
                              validation={[required]}
                              ref={this.validation.firstTimeBuyer}
                              onChange={this.handleSelectChange}
                              validateLabel={translateModels(t, 'firstTimeBuyer', 'booking')}
                            >
                              <Form.Select
                                disabled={this.isVNFormLocked()}
                                label={`${translateModels(t, 'firstTimeBuyer', 'booking')}?*`}
                                name="firstTimeBuyer"
                                options={FIRST_TIME_BUYER.map(l => ({
                                  ...l,
                                  text: t(l.text, { ns: TRANSLATION_FILES.constants }),
                                }))}
                                placeholder={`${translateModels(t, 'firstTimeBuyer', 'booking')}?`}
                                selectOnBlur={false}
                                value={this.state.booking.firstTimeBuyer}
                              />
                            </AppForm.Validate>
                          </Form.Group>
                        )
                      }
                      <Form.Group widths="equal">
                        <Form.Select
                          disabled={!this.state.allowCustomBookingStatus || this.isVNFormLocked()}
                          fluid
                          label={`${translateModels(t, 'statusID', 'booking')}*`}
                          name="statusID"
                          onChange={(e, data) => {
                            if (this.state.allowCustomBookingStatus) {
                              this.handleSelectChange(e, data);
                            }
                          }}
                          options={this.newBookingStatutes.map(s => ({
                            ...s,
                            text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                          }))}
                          placeholder={t('Select {{title}}', { title: `${translateModels(t, 'statusID', 'booking')}*` })}
                          selectOnBlur={false}
                          value={this.state.booking.statusID}
                        />
                        <AppForm.Input
                          disabled
                          fluid
                          label={`${t('Project Name')}*`}
                          name="projectName"
                          placeholder={`${t('Project Name')}*`}
                          value={projectUnitDetails.projectName}
                        />
                        <AppForm.Input
                          disabled
                          fluid
                          label={`${t('Unit Number')}*`}
                          name="reference"
                          placeholder={`${t('Unit Number')}*`}
                          value={projectUnitDetails.reference}
                        />
                        <AppForm.Input
                          disabled
                          fluid
                          label={`${t('Unit Status')}*`}
                          name="unitStatus"
                          placeholder={`${t('Unit Status')}*`}
                          value={projectUnitDetails.unitStatus}
                        />
                      </Form.Group>
                      {this.hasAccess(false, true, true, false, false) &&
                        <Grid>
                          <Grid.Row style={{ paddingBottom: '0.5em' }}>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                              <b>{createdByLabel(this.props.auth, t, t('Created By'))}</b>
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row style={{ padding: 0 }}>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                              <SearchStaff
                                disabled={this.isVNFormLocked() || agentAssignedLocked(this.props.auth)}
                                onClear={this.handleUserClear}
                                onSelect={this.handleUserSelect}
                                selectedValue={this.getSelectedCreatorValue()}
                                searchAll
                                onFetch={this.handleUserfetch}
                                value={searchUserValue}
                                placeholder={createdByLabel(this.props.auth, t, t('Created By'))}
                              />
                              {this.state.vnAgentError &&
                                <div style={{ color: '#db2828', marginTop: '0.5em' }}>{this.state.vnAgentError}</div>
                              }
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      }
                      {this.renderCustomFields(t, this.state.projectCustomFields.filter(c => !c.isDefault), false)}
                    </Grid.Column>
                    <Grid.Column width={16} textAlign="center" className="button-group">
                      {/* temp workaround fix button alignment in webview */}
                      {/* later need to overhaul this so that it is responsive with less code */}
                      <div className="tablet-hide mobile-hide" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        {!isVietnam && (
                          <Button
                            style={{ maxWidth: '25%' }}
                            content={t('Preview Price Breakdown')}
                            icon="eye"
                            labelPosition="left"
                            primary
                            type="button"
                            onClick={this.handleCheckIsPreview}
                            className={
                              this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'previewBtn'
                            }
                          />
                        )}
                        <Button
                          style={{ maxWidth: '25%' }}
                          disabled={this.isLoading('isFetching') || (isPRS ? this.state.autofillOptions && this.state.autofillOptions.length < 1 : false) || this.state.validatingTin || this.isSaveBlockedByPricingPackage()}
                          loading={this.isLoading('isFetching')}
                          positive
                          className={
                            this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'saveBtn'
                          }
                        >
                          {t('Save and Continue')}
                          {this.state.booking.statusID === 'reserved' ? <br /> : ''}
                          {this.state.booking.statusID === 'reserved' ? <small>{t('Pending Confirmation')}</small> : ''}
                        </Button>
                      </div>
                      <Grid.Row className="small-hide large-hide">
                        {!isVietnam && (
                          <Button
                            content={t('Preview Price Breakdown')}
                            icon="eye"
                            labelPosition="left"
                            primary
                            type="button"
                            onClick={this.handleCheckIsPreview}
                            className={
                              this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'previewBtn'
                            }
                          />
                        )}
                        <Button
                          disabled={this.isLoading('isFetching') || (isPRS ? this.state.autofillOptions && this.state.autofillOptions.length < 1 : false) || this.state.validatingTin || this.isSaveBlockedByPricingPackage()}
                          loading={this.isLoading('isFetching')}
                          positive
                          className={
                            this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'saveBtn'
                          }
                        >
                          {t('Save and Continue')}
                          {this.state.booking.statusID === 'reserved' ? <br /> : ''}
                          {this.state.booking.statusID === 'reserved' ? <small>{t('Pending Confirmation')}</small> : ''}
                        </Button>
                      </Grid.Row>
                    </Grid.Column>
                    <Grid.Column width={16} textAlign="center" style={{ marginTop: '0.5em' }}>
                      <p>
                        { (projectUnitDetails.bookingUnitLimit > 1 &&
                          projectUnitDetails.reservedCount > 0) ?
                          t('Unit is currently reserved, but project setup allows for multiple reservation pending confirmation.')
                          : ''
                        }
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              {
                isPreviewing && !isVietnam &&
                this.renderBookingSummary()
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.booking,
  TRANSLATION_FILES.models.bookingPackagePricing,
], { withRef: true })(connect(BookingForm.mapStateToProps)(BookingForm));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Form.jsx